var ui = (function () {
	function initPriorityForms() {
		$("[data-role='priority-form-wrapper-native']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='priority-form']");
			var outboundDate = currentFormWrapper.find("[data-field='outbound-date']");
			var outboundHours = currentFormWrapper.find("[data-field='outbound-hours']");
			var outboundMinutes = currentFormWrapper.find("[data-field='outbound-minutes']");
			var returnDate = currentFormWrapper.find("[data-field='return-date']");
			var returnHours = currentFormWrapper.find("[data-field='return-hours']");
			var returnMinutes = currentFormWrapper.find("[data-field='return-minutes']");
			var bookingType = currentFormWrapper.find("[data-field='booking-type']");
			var outboundDateWrapper = currentFormWrapper.find("[data-role='outbound-date-wrapper']");
			var returnDateWrapper = currentFormWrapper.find("[data-role='return-date-wrapper']");
			var tickets = currentFormWrapper.find("[data-field='tickets']");
			var hiddenProductId = currentFormWrapper.find("[data-field='hidden-product-id']");
			var hiddenEntryHour = currentFormWrapper.find("[data-field='hidden-entry-hour']");
			var hiddenEntryMinute = currentFormWrapper.find("[data-field='hidden-entry-minute']");
			var hiddenEntryDate = currentFormWrapper.find("[data-field='hidden-entry-date']");
			var hiddenReturnHour = currentFormWrapper.find("[data-field='hidden-return-hour']");
			var hiddenReturnMinute = currentFormWrapper.find("[data-field='hidden-return-minute']");
			var hiddenReturnDate = currentFormWrapper.find("[data-field='hidden-return-date']");
			var hiddenType = currentFormWrapper.find("[data-field='hidden-type']");
			var hiddenTickets = currentFormWrapper.find("[data-field='hidden-tickets']");
			var hiddenIsFrontEnd = currentFormWrapper.find("[data-field='is-frontend']");

			var validationErrror = false;

			
			bookingType.on('change', function () {
				var selectedBookingType = currentFormWrapper.find("[data-field='booking-type']:checked").val();
				var validationBlock = document.querySelector('.purchase-flow__priority .validation');

				if (selectedBookingType != 'BOTH') {
					validationBlock.classList.remove('validation--open');
				} else {
					validateTimes();
				}
			});

			outboundDate.on('change', function () {
				returnDate.datepicker('option', 'minDate', outboundDate.datepicker('getDate'));
				validateTimes();
			});

			returnDate.on('change', function (e) {
				outboundDate.datepicker('option', 'maxDate', returnDate.datepicker('getDate'));
				validateTimes();
			});

			outboundHours.on('change', function () {
				validateTimes();
			});

			outboundMinutes.on('change', function () {
				validateTimes();
			});

			returnHours.on('change', function () {
				validateTimes();
			});

			returnMinutes.on('change', function () {
				validateTimes();
			});

			function validateTimes() {
				var selectedBookingType = currentFormWrapper.find("[data-field='booking-type']:checked").val();

				var formattedEntryDateTime = formatDate(outboundDate.datepicker('getDate')) + ' ' + outboundHours.val() + ':' + outboundMinutes.val();
				var formattedReturnDateTime = formatDate(returnDate.datepicker('getDate')) + ' ' + returnHours.val() + ':' + returnMinutes.val();
				var productId = currentFormWrapper.find("[data-field='booking-type']:checked").data('product-id');

				hiddenProductId.val(productId);

				var isAvailable = false;

				if (selectedBookingType == 'OUT') {
					isAvailable = checkAvailabilityPriority(formattedEntryDateTime, null, hiddenProductId.val(), false, false, hiddenIsFrontEnd.val());
				} else if (selectedBookingType == 'IN') {
					isAvailable = checkAvailabilityPriority(formattedEntryDateTime, formattedReturnDateTime, hiddenProductId.val(), true, false, hiddenIsFrontEnd.val());
				} else {
					isAvailable = checkAvailabilityPriority(formattedEntryDateTime, formattedReturnDateTime, null, false, true, hiddenIsFrontEnd.val());
				}

				if (isAvailable) {
					if (selectedBookingType != 'BOTH') return;

					var outboundTime = parseInt(outboundHours.val()) * 60 + parseInt(outboundMinutes.val());
					var returnTime = parseInt(returnHours.val()) * 60 + parseInt(returnMinutes.val());

					if (outboundTime > returnTime) {
						toggleValidationError(true, 'Entry time cannot be later than exit time');
					} else {
						toggleValidationError(false, '');
					}
				}
			}

			function checkAvailabilityPriority(arrivalDateTime, returnDateTime, productId, isInbound, isEachWay, isFrontEnd) {
				if (isFrontEnd == 'false') {
					$.ajax({
						method: 'GET',
						url: '/umbraco/api/AeroparkerBookingApi/IsPrioritySecurityAvailable?arrivalDateTime=' + arrivalDateTime + '&returnDateTime=' + returnDateTime + '&productId=' + productId + '&isInbound=' + isInbound + '&isEachWay=' + isEachWay,
						success: function success(isValid) {
							if (!isValid) {
								toggleValidationError(true, ' This time slot is currently unavailable, please try a different slot');
								return false;
							} else {
								toggleValidationError(false, '');
								return true;
							}
						},
						error: function error() {
							console.log('Error with checkAvailabilityPriority()');
						},
					});
				} else {
					return true;
				}
			}

			function toggleValidationError(status, message) {
				var continueButton = document.querySelector('.purchase-flow__priority button[type="submit"]');
				var validationBlock = document.querySelector('.purchase-flow__priority .validation');

				if (validationBlock !== null) {
					var validationSpan = validationBlock.querySelector('[data-field="error-message"]');

					if (status === true) {
						validationBlock.classList.add('validation--open');
						continueButton.disabled = true;
					} else {
						validationBlock.classList.remove('validation--open');
						continueButton.disabled = false;
					}
					validationSpan.innerHTML = message;
				}
			}

			bookingType.change(function () {
				var selectedBookingType = currentFormWrapper.find("[data-field='booking-type']:checked").val();
				if (selectedBookingType === 'BOTH') {
					outboundDateWrapper.show();
					returnDateWrapper.show();
				}
				if (selectedBookingType === 'IN') {
					console.log("Got to line 173");
					validateTimes();
					outboundDateWrapper.hide();
					returnDateWrapper.show();
				}
				if (selectedBookingType === 'OUT') {
					outboundDateWrapper.show();
					returnDateWrapper.hide();
				}
			});

			outboundDate.datepicker({
				dateFormat: 'dd/mm/yy',
				onSelect: function onSelect(selected) {
					var selectedDate = outboundDate.datepicker('getDate');
					hiddenEntryDate.val(formatDate(selectedDate));
				},
				beforeShow: function beforeShow(textbox, instance) {
					if ($(window).width() < 600 && outboundDate.parents('.timeline-panel').length) {
						$('#ui-datepicker-div').wrap("<div class='timeline-datepicker-wrapper show'></div>");
					}
				},
				onClose: function onClose(textbox, instance) {
					if ($(window).width() < 600 && outboundDate.parents('.timeline-panel').length) {
						// Fading out here so as to not clash with the datepicker fadeout animation
						$('.timeline-datepicker-wrapper').fadeOut('fast', function () {
							$('#ui-datepicker-div').unwrap();
						});
					}
				},
				minDate: 0,
			});

			outboundDate.datepicker('setDate', new Date());
			returnDate.datepicker('setDate', new Date());

			currentForm.submit(function (e) {
				var outboundDateValue = formatDateUk(outboundDate.datepicker('getDate')) || '';
				var returnDateValue = formatDateUk(returnDate.datepicker('getDate')) || '';
				var productId = currentFormWrapper.find("[data-field='booking-type']:checked").data('product-id');
				var selectedBookingType = currentFormWrapper.find("[data-field='booking-type']:checked").val();
				hiddenReturnDate.val();
				if (selectedBookingType === 'BOTH') {
					hiddenEntryDate.val(outboundDateValue);
					hiddenEntryHour.val(outboundHours.val());
					hiddenEntryMinute.val(outboundMinutes.val());
					hiddenReturnDate.val(returnDateValue);
					hiddenReturnHour.val(returnHours.val());
					hiddenReturnMinute.val(returnMinutes.val());
					hiddenType.val('3');
					hiddenProductId.val('');
				}

				if (selectedBookingType === 'IN') {
					hiddenEntryDate.val(returnDateValue);
					hiddenEntryHour.val(returnHours.val());
					hiddenEntryMinute.val(returnMinutes.val());
					hiddenProductId.val(productId);
				}

				if (selectedBookingType === 'OUT') {
					hiddenEntryDate.val(outboundDateValue);
					hiddenEntryHour.val(outboundHours.val());
					hiddenEntryMinute.val(outboundMinutes.val());
					hiddenProductId.val(productId);
				}

				hiddenTickets.val(tickets.val());
				if (typeof ga === 'function') {
					var link = this;
					ga(function (tracker) {
						var linker = new window.gaplugins.Linker(tracker);
						linker.decorate(link);
					});
				}
				return true;
			});
		});

		$("[data-role='priority-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='priority-form']");
			var outboundDate = currentFormWrapper.find("[data-field='outbound-date']");
			var outboundHours = currentFormWrapper.find("[data-field='outbound-hours']");
			var outboundMinutes = currentFormWrapper.find("[data-field='outbound-minutes']");
			var returnDate = currentFormWrapper.find("[data-field='return-date']");
			var returnHours = currentFormWrapper.find("[data-field='return-hours']");
			var returnMinutes = currentFormWrapper.find("[data-field='return-minutes']");
			var bookingType = currentFormWrapper.find("[data-field='booking-type']");
			var outboundDateWrapper = currentFormWrapper.find("[data-role='outbound-date-wrapper']");
			var returnDateWrapper = currentFormWrapper.find("[data-role='return-date-wrapper']");
			var tickets = currentFormWrapper.find("[data-field='tickets']");
			var hiddenProductId = currentFormWrapper.find("[data-field='hidden-product-id']");
			var hiddenEntryHour = currentFormWrapper.find("[data-field='hidden-entry-hour']");
			var hiddenEntryMinute = currentFormWrapper.find("[data-field='hidden-entry-minute']");
			var hiddenEntryDate = currentFormWrapper.find("[data-field='hidden-entry-date']");
			var hiddenReturnHour = currentFormWrapper.find("[data-field='hidden-return-hour']");
			var hiddenReturnMinute = currentFormWrapper.find("[data-field='hidden-return-minute']");
			var hiddenReturnDate = currentFormWrapper.find("[data-field='hidden-return-date']");
			var hiddenType = currentFormWrapper.find("[data-field='hidden-type']");
			var hiddenTickets = currentFormWrapper.find("[data-field='hidden-tickets']");
			var hiddenIsFrontEnd = currentFormWrapper.find("[data-field='is-frontend']");

			var submitButton = currentFormWrapper.find("button[type='submit']");
			var errorMessage = currentFormWrapper.find("[data-role='error']");
			outboundDate.on('change', function () {
				returnDate.datepicker('option', 'minDate', outboundDate.datepicker('getDate'));
			});

			returnDate.on('change', function () {
				outboundDate.datepicker('option', 'maxDate', returnDate.datepicker('getDate'));
			});

			bookingType.on('change', function () {
				var selectedBookingType = currentFormWrapper.find("[data-field='booking-type']:checked").val();
				if (selectedBookingType === 'BOTH') {
					outboundDateWrapper.show();
					returnDateWrapper.show();
				}
				if (selectedBookingType === 'IN') {
					validateTimes();
					outboundDateWrapper.hide();
					returnDateWrapper.show();
				}
				if (selectedBookingType === 'OUT') {
					outboundDateWrapper.show();
					returnDateWrapper.hide();
				}
			});

			outboundDate.datepicker({
				dateFormat: 'dd/mm/yy',
				onSelect: function onSelect(selected) {
					var selectedDate = outboundDate.datepicker('getDate');
					hiddenEntryDate.val(formatDate(selectedDate));
				},
				beforeShow: function beforeShow(textbox, instance) {
					if ($(window).width() < 600 && outboundDate.parents('.timeline-panel').length) {
						$('#ui-datepicker-div').wrap("<div class='timeline-datepicker-wrapper show'></div>");
					}
				},
				onClose: function onClose(textbox, instance) {
					if ($(window).width() < 600 && outboundDate.parents('.timeline-panel').length) {
						// Fading out here so as to not clash with the datepicker fadeout animation
						$('.timeline-datepicker-wrapper').fadeOut('fast', function () {
							$('#ui-datepicker-div').unwrap();
						});
					}
				},
				minDate: 0,
			});

			validateTimes();

			var validationErrror = false;
			bookingType.on('change', function () {
				var selectedBookingType = currentFormWrapper.find("[data-field='booking-type']:checked").val();
				var validationBlock = document.querySelector('.book-priority .validation');

				if (selectedBookingType != 'BOTH') {
					validationBlock.classList.remove('validation--open');
				} else {
					validateTimes();
				}
			});

			outboundDate.on('change', function () {
				returnDate.datepicker('option', 'minDate', outboundDate.datepicker('getDate'));
				validateTimes();
			});

			returnDate.on('change', function (e) {
				outboundDate.datepicker('option', 'maxDate', returnDate.datepicker('getDate'));
				validateTimes();
			});

			outboundHours.on('change', function () {
				validateTimes();
			});

			outboundMinutes.on('change', function () {
				validateTimes();
			});

			returnHours.on('change', function () {
				validateTimes();
			});

			returnMinutes.on('change', function () {
				validateTimes();
			});

			function validateTimes() {
				var selectedBookingType = currentFormWrapper.find("[data-field='booking-type']:checked").val();

				var formattedEntryDateTime = formatDate(outboundDate.datepicker('getDate')) + ' ' + outboundHours.val() + ':' + outboundMinutes.val();
				var formattedReturnDateTime = formatDate(returnDate.datepicker('getDate')) + ' ' + returnHours.val() + ':' + returnMinutes.val();
				var productId = currentFormWrapper.find("[data-field='booking-type']:checked").data('product-id');

				hiddenProductId.val(productId);

				var isAvailable = false;

				if (selectedBookingType == 'OUT') {
					isAvailable = checkAvailabilityPriority(formattedEntryDateTime, null, hiddenProductId.val(), false, false, hiddenIsFrontEnd.val());
				} else if (selectedBookingType == 'IN') {
					isAvailable = checkAvailabilityPriority(formattedEntryDateTime, formattedReturnDateTime, hiddenProductId.val(), true, false, hiddenIsFrontEnd.val());
				} else {
					isAvailable = checkAvailabilityPriority(formattedEntryDateTime, formattedReturnDateTime, null, false, true, hiddenIsFrontEnd.val());
				}

				if (isAvailable) {
					if (selectedBookingType != 'BOTH') return;

					var outboundTime = parseInt(outboundHours.val()) * 60 + parseInt(outboundMinutes.val());
					var returnTime = parseInt(returnHours.val()) * 60 + parseInt(returnMinutes.val());

					if (outboundTime > returnTime) {
						toggleValidationError(true, 'Entry time cannot be later than exit time');
					} else {
						toggleValidationError(false, '');
					}
				}
			}

			function checkAvailabilityPriority(arrivalDateTime, returnDateTime, productId, isInbound, isEachWay, isFrontEnd) {
				if (isFrontEnd == 'false') {
					$.ajax({
						method: 'GET',
						url: '/umbraco/api/AeroparkerBookingApi/IsPrioritySecurityAvailable?arrivalDateTime=' + arrivalDateTime + '&returnDateTime=' + returnDateTime + '&productId=' + productId + '&isInbound=' + isInbound + '&isEachWay=' + isEachWay,
						success: function success(isValid) {
							if (!isValid) {
								toggleValidationError(true, ' This time slot is currently unavailable, please try a different slot');
								return false;
							} else {
								toggleValidationError(false, '');
								return true;
							}
						},
						error: function error() {
							console.log('Error with checkAvailabilityPriority()');
						},
					});
				} else {
					return true;
				}
			}

			function toggleValidationError(status, message) {
				//var continueButton = document.querySelector('.book-priority__btn button[type="submit"]');
				var continueButton = $('.book-priority__btn button[type="submit"]');

				var validationBlock = $('.book-priority .validation');

				if (validationBlock !== null) {
					var validationSpan = $(validationBlock).closest('[data-field="error-message"]');

					if (status === true) {
						continueButton.attr('disabled', 'true');
						validationBlock.show();
					} else {
						continueButton.removeAttr('disabled');
						validationBlock.hide();
					}
					$(validationSpan).innerHTML = message;
				}
			}
			currentForm.submit(function (e) {
				var outboundDateValue = formatDateUk(outboundDate.datepicker('getDate')) || '';
				var returnDateValue = formatDateUk(returnDate.datepicker('getDate')) || '';
				var productId = currentFormWrapper.find("[data-field='booking-type']:checked").data('product-id');
				var selectedBookingType = currentFormWrapper.find("[data-field='booking-type']:checked").val();
				hiddenReturnDate.val();
				if (selectedBookingType === 'BOTH') {
					hiddenEntryDate.val(outboundDateValue);
					hiddenEntryHour.val(outboundHours.val());
					hiddenEntryMinute.val(outboundMinutes.val());
					hiddenReturnDate.val(returnDateValue);
					hiddenReturnHour.val(returnHours.val());
					hiddenReturnMinute.val(returnMinutes.val());
					hiddenType.val('3');
					hiddenProductId.val('');
					currentForm.attr('action', currentForm.attr('multipurchase-action'));
				}

				if (selectedBookingType === 'IN') {
					hiddenEntryDate.val(returnDateValue);
					hiddenEntryHour.val(returnHours.val());
					hiddenEntryMinute.val(returnMinutes.val());
					hiddenProductId.val(productId);
					currentForm.attr('action', currentForm.attr('purchase-action'));
				}

				if (selectedBookingType === 'OUT') {
					hiddenEntryDate.val(outboundDateValue);
					hiddenEntryHour.val(outboundHours.val());
					hiddenEntryMinute.val(outboundMinutes.val());
					hiddenProductId.val(productId);
					currentForm.attr('action', currentForm.attr('purchase-action'));
				}

				hiddenTickets.val(tickets.val());
				if (typeof ga === 'function') {
					var link = this;
					ga(function (tracker) {
						var linker = new window.gaplugins.Linker(tracker);
						linker.decorate(link);
					});
				}
				return true;
			});
		});
	}
	function checkAvailabilityPriorityGui(isSubmit, submitButtonElement, currentFormElement, errorMessageElement, productId, entryDate, entryTime, exitDate, exitTime, isAncillary, quantity) {
		checkAvailability(
			productId,
			entryDate,
			entryTime,
			exitDate,
			exitTime,
			true,
			quantity,
			function () {
				errorMessageElement.hide();
				submitButtonElement.data('valid', true);
				console.log('Valid');
				if (isSubmit) {
					currentFormElement.submit();
				}
			},
			function () {
				errorMessageElement.show();
				submitButtonElement.data('valid', false);
				console.log('Invalid');
			}
		);
	}
	function checkAvailability(productId, entryDate, entryTime, exitDate, exitTime, isAncillary, quantity, onValidCallback, onInvalidCallback) {
		// This method is designed to be gui-agnostic, so should be more reusable. Specific Gui implementations would interact success/fail with the dom and call this

		// Time/Date is in past, or exit date after entry date, so don't even waste time doing any further checks
		var currentTime = new Date();
		var chosenEntryDateTime = new Date(entryDate.getFullYear(), entryDate.getMonth(), entryDate.getDate(), parseInt(entryTime.split(':')[0]), parseInt(entryTime.split(':')[1]));
		var chosenExitDateTime = exitDate !== '' ? new Date(exitDate.getFullYear(), exitDate.getMonth(), exitDate.getDate(), parseInt(exitTime.split(':')[0]), parseInt(exitTime.split(':')[1])) : '';
		if (chosenEntryDateTime < currentTime || (chosenExitDateTime !== '' && chosenExitDateTime < chosenEntryDateTime)) {
			onInvalidCallback();
		} else {
			var formattedEntryDateTime = formatDate(entryDate) + ' ' + entryTime;
			var formattedExitDateTime = exitDate !== '' ? formatDate(exitDate) + ' ' + exitTime : formattedEntryDateTime;
			var controller = '/umbraco/api/AeroparkerBookingApi/IsParkingDateTimeValid?productId={1}&arrivalDateTime={2}&returnDateTime={3}&productAffiliateCode={4}&isAncillary={5}&quantity={6}';
			controller = controller.replace('{1}', productId).replace('{2}', formattedEntryDateTime).replace('{3}', formattedExitDateTime).replace('{4}', '').replace('{5}', isAncillary).replace('{6}', quantity);
			$.ajax({
				method: 'GET',
				url: window.location.origin + controller,
				success: function success(isValid) {
					if (isValid) {
						onValidCallback();
					} else {
						onInvalidCallback();
					}
				},
				error: function error() {
					//If something happens with the api, we will just let the orginal form post handle the availability validation
					onValidCallback();
				},
			});
		}
	}
	function initLoungeForms() {
		// Rewritten to a reusable method which reduces duplication of code - you should now just need to
		// use the same data-role/data-field references on any copy of the form and it'll work

		$("[data-role='lounge-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='lounge-form']");
			var outboundDate = currentFormWrapper.find("[data-field='outbound-date']");
			var outboundDateLabel = currentFormWrapper.find("[data-field='outbound-date-label']");
			var outboundTime = currentFormWrapper.find("[data-field='outbound-time']");
			var outboundTimeWrapper = currentFormWrapper.find("[data-role='outbound-time-wrapper']");
			var outboundQuantityWrapper = currentFormWrapper.find("[data-role='outbound-quantity-wrapper']");
			var outboundQuantityAdults = currentFormWrapper.find("[data-field='outbound-quantity-adults']");
			var outboundQuantityChildren = currentFormWrapper.find("[data-field='outbound-quantity-children']");
			var productId = currentFormWrapper.find("[data-field='product-id']");
			var hiddenProductId = currentFormWrapper.find("[data-field='hidden-product-id']");
			var hiddenEntryDate = currentFormWrapper.find("[data-field='hidden-entry-date']");
			var hiddenParkingProductId = currentFormWrapper.find("[data-field='hidden-parking-product-id']");
			var hiddenParkingEntryDate = currentFormWrapper.find("[data-field='hidden-parking-entry-date']");
			var hiddenParkingEntryTime = currentFormWrapper.find("[data-field='hidden-parking-entry-time']");
			var hiddenParkingExitDate = currentFormWrapper.find("[data-field='hidden-parking-exit-date']");
			var hiddenParkingExitTime = currentFormWrapper.find("[data-field='hidden-parking-exit-time']");
			var hiddenArrivalHour = currentFormWrapper.find("[data-field='hidden-arrival-hour']");
			var hiddenArrivalMinute = currentFormWrapper.find("[data-field='hidden-arrival-minute']");
			var hiddenAdults = currentFormWrapper.find("[data-field='hidden-adults']");
			var hiddenChildren = currentFormWrapper.find("[data-field='hidden-children']");
			var timeNotAvailableErrorMessageSelector = currentFormWrapper.find("[data-message='time-slot-not-available']");
			var submitButtonSelector = currentFormWrapper.find("button[type='submit']");
			productId.change(function () {
				var selectedItem = $(this).children(':selected');
				//selectedItem.data("parking-product") ? outboundTimeWrapper.show() : outboundTimeWrapper.hide();
				outboundTimeWrapper.show();
				if (selectedItem.data('parking-product')) {
					outboundQuantityWrapper.hide();
				} else {
					outboundQuantityWrapper.show();
				}
				outboundDateLabel.text(selectedItem.data('date-label'));
				buildTimeSlots(selectedItem, outboundTime);
				outboundTimeChange(productId, outboundDate, outboundTime, outboundQuantityAdults, outboundQuantityChildren, timeNotAvailableErrorMessageSelector, submitButtonSelector);
			});
			outboundDate.datepicker({
				dateFormat: 'dd/mm/yy',
				onSelect: function onSelect(selected) {
					var selectedDate = entryDate.datepicker('getDate');
					hiddenEntryDate.val(formatDate(selectedDate));
				},
				beforeShow: function beforeShow(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						$('#ui-datepicker-div').wrap("<div class='timeline-datepicker-wrapper show'></div>");
					}
				},
				onClose: function onClose(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						// Fading out here so as to not clash with the datepicker fadeout animation
						$('.timeline-datepicker-wrapper').fadeOut('fast', function () {
							$('#ui-datepicker-div').unwrap();
						});
					}
				},
				minDate: 0,
			});
			currentFormWrapper.find('select, input').change(function () {
				outboundTimeChange(productId, outboundDate, outboundTime, outboundQuantityAdults, outboundQuantityChildren, timeNotAvailableErrorMessageSelector, submitButtonSelector);
			});
			currentForm.submit(function (e) {
				var selectedDate = outboundDate.datepicker('getDate');
				var selectedItem = productId.children(':selected');
				var defaultAffiliateCode = productId.data('default-affiliate-code');
				var affiliateCode = selectedItem.data('product-affiliate-code') || productId.data('default-affiliate-code');

				// Validate it matches any time restriction
				var minimumNotice = parseInt(selectedItem.data('minimum-notice')) || 0;
				var minimumTime = new Date();
				minimumTime.setMinutes(minimumTime.getMinutes() + minimumNotice);
				var chosenTime = getDateTime(outboundDate, outboundTime);
				if (chosenTime < minimumTime) {
					if (minimumNotice === 0) {
						alert('You must choose a slot further in the future');
					} else {
						alert('You must leave at least ' + (minimumNotice % 60 === 0 ? minimumNotice / 60 + ' hours' : minimumNotice + ' minutes') + ' for this test.');
					}
				} else {
					hiddenAdults.val((outboundQuantityWrapper.is(':visible') ? outboundQuantityAdults.val() : 1) || 1);
					hiddenChildren.val((outboundQuantityWrapper.is(':visible') ? outboundQuantityChildren.val() : 1) || 1);
					if (selectedItem.data('parking-product')) {
						hiddenParkingEntryDate.val(formatDateUk(selectedDate));
						hiddenParkingExitDate.val(formatDateUk(selectedDate));
						hiddenParkingEntryTime.val(formatTime(outboundTime.val()));
						hiddenParkingExitTime.val(selectedItem.data('end-time') || outboundTime.children(':selected').next().attr('value'));
						hiddenParkingProductId.val(productId.val());
						currentForm.attr('action', currentForm.data('parking-action').replace('/' + defaultAffiliateCode + '/', '/' + affiliateCode + '/'));
					} else {
						var time = outboundTime.val().split(':');
						hiddenEntryDate.val(formatDateUk(selectedDate));
						hiddenArrivalHour.val(time[0]);
						hiddenArrivalMinute.val(time[1]);
						if (selectedItem.data('multipurchase-product')) {
							hiddenProductId.val('');
							currentForm.attr('action', currentForm.data('multipurchase-action').replace('/' + defaultAffiliateCode + '/', '/' + affiliateCode + '/'));
						} else {
							hiddenProductId.val(productId.val());
							currentForm.attr('action', currentForm.data('purchase-action').replace('/' + defaultAffiliateCode + '/', '/' + affiliateCode + '/'));
						}
					}
					var link = this;
					ga(function (tracker) {
						var linker = new window.gaplugins.Linker(tracker);
						linker.decorate(link);
					});
					return true;
				}
				return false;
			});
			productId.change();
		});
	}

	function initNativeLoungeForms() {
		// Rewritten to a reusable method which reduces duplication of code - you should now just need to
		// use the same data-role/data-field references on any copy of the form and it'll work

		$("[data-role='lounge-native-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='lounge-form']");
			var outboundDate = currentFormWrapper.find("[data-field='outbound-date']");
			var outboundDateLabel = currentFormWrapper.find("[data-field='outbound-date-label']");
			var outboundTime = currentFormWrapper.find("[data-field='outbound-time']");
			var outboundTimeWrapper = currentFormWrapper.find("[data-role='outbound-time-wrapper']");
			var outboundQuantityWrapper = currentFormWrapper.find("[data-role='outbound-quantity-wrapper']");
			var outboundQuantityAdults = currentFormWrapper.find("[data-field='outbound-quantity-adults']");
			var outboundQuantityChildren = currentFormWrapper.find("[data-field='outbound-quantity-children']");
			var productId = currentFormWrapper.find("[data-field='product-id']");
			var hiddenProductId = currentFormWrapper.find("[data-field='hidden-product-id']");
			var hiddenEntryDate = currentFormWrapper.find("[data-field='hidden-entry-date']");
			var hiddenParkingProductId = currentFormWrapper.find("[data-field='hidden-parking-product-id']");
			var hiddenParkingEntryDate = currentFormWrapper.find("[data-field='hidden-parking-entry-date']");
			var hiddenParkingEntryTime = currentFormWrapper.find("[data-field='hidden-parking-entry-time']");
			var hiddenParkingExitDate = currentFormWrapper.find("[data-field='hidden-parking-exit-date']");
			var hiddenParkingExitTime = currentFormWrapper.find("[data-field='hidden-parking-exit-time']");
			var hiddenArrivalHour = currentFormWrapper.find("[data-field='entry-hour']");
			var hiddenArrivalMinute = currentFormWrapper.find("[data-field='entry-minute']");
			var hiddenAdults = currentFormWrapper.find("[data-field='hidden-adults']");
			var hiddenChildren = currentFormWrapper.find("[data-field='hidden-children']");
			var timeNotAvailableErrorMessageSelector = currentFormWrapper.find("[data-message='time-slot-not-available']");
			var submitButtonSelector = currentFormWrapper.find("button[type='submit']");
			productId.change(function () {
				var selectedItem = $(this).children(':selected');
				//selectedItem.data("parking-product") ? outboundTimeWrapper.show() : outboundTimeWrapper.hide();
				outboundTimeWrapper.show();
				if (selectedItem.data('parking-product')) {
					outboundQuantityWrapper.hide();
				} else {
					outboundQuantityWrapper.show();
				}
				outboundDateLabel.text(selectedItem.data('date-label'));
				buildTimeSlots(selectedItem, outboundTime);
				outboundTimeChange(productId, outboundDate, outboundTime, outboundQuantityAdults, outboundQuantityChildren, timeNotAvailableErrorMessageSelector, submitButtonSelector);
			});
			outboundDate.datepicker({
				dateFormat: 'dd/mm/yy',
				onSelect: function onSelect(selected) {
					var selectedDate = entryDate.datepicker('getDate');
					hiddenEntryDate.val(formatDate(selectedDate));
				},
				beforeShow: function beforeShow(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						$('#ui-datepicker-div').wrap("<div class='timeline-datepicker-wrapper show'></div>");
					}
				},
				onClose: function onClose(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						// Fading out here so as to not clash with the datepicker fadeout animation
						$('.timeline-datepicker-wrapper').fadeOut('fast', function () {
							$('#ui-datepicker-div').unwrap();
						});
					}
				},
				minDate: 0,
			});
			currentFormWrapper.find('select, input').change(function () {
				outboundTimeChange(productId, outboundDate, outboundTime, outboundQuantityAdults, outboundQuantityChildren, timeNotAvailableErrorMessageSelector, submitButtonSelector);
			});
			currentForm.submit(function (e) {
				var selectedDate = outboundDate.datepicker('getDate');
				var selectedItem = productId.children(':selected');
				var defaultAffiliateCode = productId.data('default-affiliate-code');
				var affiliateCode = selectedItem.data('product-affiliate-code') || productId.data('default-affiliate-code');

				// Validate it matches any time restriction
				var minimumNotice = parseInt(selectedItem.data('minimum-notice')) || 0;
				var minimumTime = new Date();
				minimumTime.setMinutes(minimumTime.getMinutes() + minimumNotice);
				var chosenTime = getDateTime(outboundDate, outboundTime);
				if (chosenTime < minimumTime) {
					if (minimumNotice === 0) {
						alert('You must choose a slot further in the future');
					} else {
						alert('You must leave at least ' + (minimumNotice % 60 === 0 ? minimumNotice / 60 + ' hours' : minimumNotice + ' minutes') + ' for this test.');
					}
				} else {
					hiddenAdults.val((outboundQuantityWrapper.is(':visible') ? outboundQuantityAdults.val() : 1) || 1);
					hiddenChildren.val((outboundQuantityWrapper.is(':visible') ? outboundQuantityChildren.val() : 1) || 1);
					if (selectedItem.data('parking-product')) {
						hiddenParkingEntryDate.val(formatDateUk(selectedDate));
						hiddenParkingExitDate.val(formatDateUk(selectedDate));
						hiddenParkingEntryTime.val(formatTime(outboundTime.val()));
						hiddenParkingExitTime.val(selectedItem.data('end-time') || outboundTime.children(':selected').next().attr('value'));
						hiddenParkingProductId.val(productId.val());
						currentForm.attr('action', currentForm.data('parking-action').replace('/' + defaultAffiliateCode + '/', '/' + affiliateCode + '/'));
					} else {
						var time = outboundTime.val().split(':');
						hiddenEntryDate.val(formatDateUk(selectedDate));
						hiddenArrivalHour.val(time[0]);
						hiddenArrivalMinute.val(time[1]);
						/* if (selectedItem.data("multipurchase-product")) {
							hiddenProductId.val("");
							currentForm.attr("action", currentForm.data("multipurchase-action").replace("/" + defaultAffiliateCode + "/", "/" + affiliateCode + "/"));
						} else {
							hiddenProductId.val(productId.val());
							currentForm.attr("action", currentForm.data("purchase-action").replace("/" + defaultAffiliateCode + "/", "/" + affiliateCode + "/"));
						} */
					}
					var link = this;
					ga(function (tracker) {
						var linker = new window.gaplugins.Linker(tracker);
						linker.decorate(link);
					});
					return true;
				}
				return false;
			});
			productId.change();
		});
	}

	function initEditLoungeForms() {
		// Rewritten to a reusable method which reduces duplication of code - you should now just need to
		// use the same data-role/data-field references on any copy of the form and it'll work
		$('[data-lounge-edit]').each(function () {
			var currentFormWrapper = $(this);
			var entryDate = currentFormWrapper.find("[data-field='entry-date']");
			var entryTime = currentFormWrapper.find("[data-field='entry-time']");
			var currentForm = currentFormWrapper.find("[data-role='lounge-form-edit']");
			var hiddenEntryDate = currentForm.find("[data-field='hidden-entry-date']");
			var hiddenEntryHour = currentForm.find("[data-field='hidden-entry-hour']");
			var hiddenEntryMinute = currentForm.find("[data-field='hidden-entry-minute']");

			var editButton = currentFormWrapper.find('[data-lounge-details-edit]');

			editButton.click(function (event) {
				event.preventDefault();
				$('[data-fields-edit]').removeClass('purchase-flow__flight-summary__edit');
				$('[data-fields-edit]').addClass('purchase-flow__flight-summary__row--edit');
				$('[data-lounge-details-edit]').hide();
				currentForm.show();
			});

			var editBar = currentFormWrapper.find('[data-lounge-details-edit-fields]');

			editBar.click(function (event) {
				event.preventDefault();
				console.log('Clicked on edit bar');
				$('[data-fields-edit]').removeClass('purchase-flow__flight-summary__edit');
				$('[data-fields-edit]').addClass('purchase-flow__flight-summary__row--edit');
				$('[data-lounge-details-edit]').hide();
				currentForm.show();
			});

			entryDate.datepicker({
				dateFormat: 'dd/mm/yy',
				onSelect: function onSelect(selected) {
					var selectedDate = entryDate.datepicker('getDate');
					hiddenEntryDate.val(formatDate(selectedDate));
				},
				beforeShow: function beforeShow(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						$('#ui-datepicker-div').wrap("<div class='timeline-datepicker-wrapper show'></div>");
					}
				},
				onClose: function onClose(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						// Fading out here so as to not clash with the datepicker fadeout animation
						$('.timeline-datepicker-wrapper').fadeOut('fast', function () {
							$('#ui-datepicker-div').unwrap();
						});
					}
				},
				minDate: 0,
			});

			currentForm.submit(function (e) {
				var chosenTime = getDateTime(entryDate, entryTime);
				var minimumNotice = 30;
				var minimumTime = new Date();
				minimumTime.setMinutes(minimumTime.getMinutes() + minimumNotice);

				if (chosenTime < minimumTime) {
					alert('You must leave at least ' + (minimumNotice % 60 === 0 ? minimumNotice / 60 + ' hours' : minimumNotice + ' minutes'));

					return false;
				} else {
					var time = entryTime.val().split(':');
					var selectedDate = entryDate.datepicker('getDate');
					hiddenEntryDate.val(formatDate(selectedDate));
					hiddenEntryHour.val(time[0]);
					hiddenEntryMinute.val(time[1]);

					return true;
				}
			});
		});
	}

	function initSecurityForms() {
		// Could possibly share with the lounge as near identical, but lounge may be changing

		$("[data-role='security-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='security-form']");
			var entryDate = currentFormWrapper.find("[data-field='entry-date']");
			var entryTime = currentFormWrapper.find("[data-field='entry-time']");
			var tickets = currentFormWrapper.find("[data-field='tickets']");
			var hiddenEntryHour = currentFormWrapper.find("[data-field='hidden-entry-hour']");
			var hiddenEntryMinute = currentFormWrapper.find("[data-field='hidden-entry-minute']");
			var hiddenEntryDate = currentFormWrapper.find("[data-field='hidden-entry-date']");
			var hiddenTickets = currentFormWrapper.find("[data-field='hidden-tickets']");
			var productId = currentFormWrapper.find("[data-field='product-id']");
			entryDate.datepicker({
				dateFormat: 'dd/mm/yy',
				onSelect: function onSelect(selected) {
					var selectedDate = entryDate.datepicker('getDate');
					hiddenEntryDate.val(formatDate(selectedDate));
				},
				beforeShow: function beforeShow(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						$('#ui-datepicker-div').wrap("<div class='timeline-datepicker-wrapper show'></div>");
					}
				},
				onClose: function onClose(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						// Fading out here so as to not clash with the datepicker fadeout animation
						$('.timeline-datepicker-wrapper').fadeOut('fast', function () {
							$('#ui-datepicker-div').unwrap();
						});
					}
				},
				minDate: 0,
			});

			function checkSecurityAvailability(arrivalDateTime, returnDateTime, productId = 0, isInbound = null, isEachWay = null) {	
				const arrivalDate = new Date(arrivalDateTime);
				const now = new Date();

				if (arrivalDate < now) {
					toggleSecurityValidationError(true);
					return; 
				} else {	
					$.ajax({
						method: 'GET',
						url: '/umbraco/api/AeroparkerBookingApi/IsPrioritySecurityAvailable?arrivalDateTime=' + arrivalDateTime + '&returnDateTime=' + returnDateTime + '&productId=' + productId + '&isInbound=' + isInbound + '&isEachWay=' + isEachWay,
						success: function success(isValid) {
							if (!isValid) {
								toggleSecurityValidationError(true);
								return false;
							} else {
								toggleSecurityValidationError(false);
								return true;
							}
						},
						error: function error() {
							console.log('Error with checkSecurityAvailability()');
						},
					});
				}
			}
			
			function toggleSecurityValidationError(status) {
				var continueButton = document.getElementById('book-priority-security-button');
				var validationBlock = document.getElementById('book-priority-security-error');
				var continueButtonMobile = document.getElementById('book-priority-security-button-mobile');
				var validationBlockMobile = document.getElementById('book-priority-security-error-mobile');
				var continueButtonHero = document.getElementById('book-priority-security-button-hero');
				var validationBlockHero = document.getElementById('book-priority-security-error-hero');

				if (validationBlock !== null) {
					if (status === false) {
						if (continueButton) continueButton.disabled = false;
						if (validationBlock) validationBlock.style.display = 'none';
				
						if (continueButtonMobile) continueButtonMobile.disabled = false;
						if (validationBlockMobile) validationBlockMobile.style.display = 'none';
				
						if (continueButtonHero) continueButtonHero.disabled = false;
						if (validationBlockHero) validationBlockHero.style.display = 'none';
					} else {
						if (continueButton) continueButton.disabled = true;
						if (validationBlock) validationBlock.style.display = 'inline-block';
				
						if (continueButtonMobile) continueButtonMobile.disabled = true;
						if (validationBlockMobile) validationBlockMobile.style.display = 'inline-block';
				
						if (continueButtonHero) continueButtonHero.disabled = true;
						if (validationBlockHero) validationBlockHero.style.display = 'inline-block';
					}
				}
			}

			currentFormWrapper.find('select, input').change(function () {				
				var formattedEntryDateTime = formatDate(entryDate.datepicker('getDate')) + ' ' + entryTime.val();
				checkSecurityAvailability(formattedEntryDateTime, null, productId.val(), false, false);
			});

			currentForm.submit(function (e) {
				hiddenEntryDate.val(formatDateUk(entryDate.datepicker('getDate')));
				var time = formatTime(entryTime.val());
				var splitTime = time.split(':');
				hiddenEntryHour.val(splitTime[0]);
				hiddenEntryMinute.val(splitTime[1]);
				hiddenTickets.val(tickets.val());
				var link = this;
				ga(function (tracker) {
					var linker = new window.gaplugins.Linker(tracker);
					linker.decorate(link);
				});
				return true;
			});
		});

		$('[data-security-edit]').each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='security-form']");
			var entryDate = currentFormWrapper.find("[data-field='entry-date']");
			var entryTime = currentFormWrapper.find("[data-field='entry-time']");
			var tickets = currentFormWrapper.find("[data-field='tickets']");
			var hiddenEntryHour = currentFormWrapper.find("[data-field='hidden-entry-hour']");
			var hiddenEntryMinute = currentFormWrapper.find("[data-field='hidden-entry-minute']");
			var hiddenEntryDate = currentFormWrapper.find("[data-field='hidden-entry-date']");
			var hiddenTickets = currentFormWrapper.find("[data-field='hidden-tickets']");

			entryDate.datepicker({
				dateFormat: 'dd/mm/yy',
				onSelect: function onSelect(selected) {
					var selectedDate = entryDate.datepicker('getDate');
					hiddenEntryDate.val(formatDate(selectedDate));
				},
				beforeShow: function beforeShow(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						$('#ui-datepicker-div').wrap("<div class='timeline-datepicker-wrapper show'></div>");
					}
				},
				onClose: function onClose(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						// Fading out here so as to not clash with the datepicker fadeout animation
						$('.timeline-datepicker-wrapper').fadeOut('fast', function () {
							$('#ui-datepicker-div').unwrap();
						});
					}
				},
				minDate: 0,
			});

			currentForm.submit(function (e) {
				hiddenEntryDate.val(formatDateUk(entryDate.datepicker('getDate')));
				hiddenTickets.val(tickets.val());
				var time = formatTime(entryTime.val());
				var splitTime = time.split(':');
				hiddenEntryHour.val(splitTime[0]);
				hiddenEntryMinute.val(splitTime[1]);

				return true;
			});
		});
	}
	function initTestingForms() {
		// Naming for this does not mean this is just test code, it's actually for booking tests

		$("[data-role='testing-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='testing-form']");
			var outboundDate = currentFormWrapper.find("[data-field='outbound-date']");
			var outboundDateLabel = currentFormWrapper.find("[data-field='outbound-date-label']");
			var outboundTime = currentFormWrapper.find("[data-field='outbound-time']");
			var outboundTimeWrapper = currentFormWrapper.find("[data-role='outbound-time-wrapper']");
			var outboundQuantityWrapper = currentFormWrapper.find("[data-role='outbound-quantity-wrapper']");
			var outboundQuantity = currentFormWrapper.find("[data-field='outbound-quantity']");
			var productId = currentFormWrapper.find("[data-field='product-id']");
			var hiddenProductId = currentFormWrapper.find("[data-field='hidden-product-id']");
			var hiddenEntryDate = currentFormWrapper.find("[data-field='hidden-entry-date']");
			var hiddenParkingProductId = currentFormWrapper.find("[data-field='hidden-parking-product-id']");
			var hiddenParkingEntryDate = currentFormWrapper.find("[data-field='hidden-parking-entry-date']");
			var hiddenParkingEntryTime = currentFormWrapper.find("[data-field='hidden-parking-entry-time']");
			var hiddenParkingExitDate = currentFormWrapper.find("[data-field='hidden-parking-exit-date']");
			var hiddenParkingExitTime = currentFormWrapper.find("[data-field='hidden-parking-exit-time']");
			var hiddenArrivalHour = currentFormWrapper.find("[data-field='hidden-arrival-hour']");
			var hiddenArrivalMinute = currentFormWrapper.find("[data-field='hidden-arrival-minute']");
			var hiddenQuantity = currentFormWrapper.find("[data-field='hidden-quantity']");
			var timeNotAvailableErrorMessageSelector = currentFormWrapper.find("[data-message='time-slot-not-available']");
			var submitButtonSelector = currentFormWrapper.find("button[type='submit']");
			productId.change(function () {
				var selectedItem = $(this).children(':selected');
				//selectedItem.data("parking-product") ? outboundTimeWrapper.show() : outboundTimeWrapper.hide();
				outboundTimeWrapper.show();
				if (selectedItem.data('parking-product')) {
					outboundQuantityWrapper.hide();
				} else {
					outboundQuantityWrapper.show();
				}
				outboundDateLabel.text(selectedItem.data('date-label'));
				buildTimeSlots(selectedItem, outboundTime);
				if (productId.data('loaded')) {
					outboundTimeChange(productId, outboundDate, outboundTime, outboundQuantity, null, timeNotAvailableErrorMessageSelector, submitButtonSelector);
				} else {
					productId.data('loaded', true);
				}
			});
			outboundDate.datepicker({
				dateFormat: 'dd/mm/yy',
				minDate: 0,
			});
			$(outboundDate).change(function () {
				outboundTimeChange(productId, outboundDate, outboundTime, outboundQuantity, null, timeNotAvailableErrorMessageSelector, submitButtonSelector);
			});
			$(outboundTime).change(function () {
				outboundTimeChange(productId, outboundDate, outboundTime, outboundQuantity, null, timeNotAvailableErrorMessageSelector, submitButtonSelector);
			});
			$(outboundQuantity).change(function () {
				outboundTimeChange(productId, outboundDate, outboundTime, outboundQuantity, null, timeNotAvailableErrorMessageSelector, submitButtonSelector);
			});
			currentForm.submit(function (e) {
				if (submitButtonSelector.data('checked') !== true) {
					e.preventDefault();
					outboundTimeChange(productId, outboundDate, outboundTime, outboundQuantity, null, timeNotAvailableErrorMessageSelector, submitButtonSelector);
					setTimeout(function () {
						if (!timeNotAvailableErrorMessageSelector.is(':visible')) {
							currentForm.submit();
						}
					}, 500);
					return false;
				}
				var selectedDate = outboundDate.datepicker('getDate');
				var selectedItem = productId.children(':selected');
				var defaultAffiliateCode = productId.data('default-affiliate-code');
				var affiliateCode = selectedItem.data('product-affiliate-code') || productId.data('default-affiliate-code');

				// Validate it matches any time restriction
				var minimumNotice = parseInt(selectedItem.data('minimum-notice')) || 0;
				var minimumTime = new Date();
				minimumTime.setMinutes(minimumTime.getMinutes() + minimumNotice);
				var chosenTime = getDateTime(outboundDate, outboundTime);
				if (chosenTime < minimumTime) {
					if (minimumNotice === 0) {
						alert('You must choose a slot further in the future');
					} else {
						alert('You must leave at least ' + (minimumNotice % 60 === 0 ? minimumNotice / 60 + ' hours' : minimumNotice + ' minutes') + ' for this test.');
					}
				} else {
					hiddenQuantity.val((outboundQuantityWrapper.is(':visible') ? outboundQuantity.val() : 1) || 1);
					if (selectedItem.data('parking-product')) {
						hiddenParkingEntryDate.val(formatDateUk(selectedDate));
						hiddenParkingExitDate.val(formatDateUk(selectedDate));
						hiddenParkingEntryTime.val(formatTime(outboundTime.val()));
						hiddenParkingExitTime.val(selectedItem.data('end-time') || outboundTime.children(':selected').next().attr('value'));
						hiddenParkingProductId.val(productId.val());
						currentForm.attr('action', currentForm.data('parking-action').replace('/' + defaultAffiliateCode + '/', '/' + affiliateCode + '/'));
					} else {
						var time = outboundTime.val().split(':');
						hiddenEntryDate.val(formatDateUk(selectedDate));
						hiddenProductId.val(productId.val());
						hiddenArrivalHour.val(time[0]);
						hiddenArrivalMinute.val(time[1]);
						currentForm.attr('action', currentForm.data('purchase-action').replace('/' + defaultAffiliateCode + '/', '/' + affiliateCode + '/'));
					}
					var link = this;
					ga(function (tracker) {
						var linker = new window.gaplugins.Linker(tracker);
						linker.decorate(link);
					});
					return true;
				}
				return false;
			});
			productId.change();
		});
	}
	function buildTimeSlots(selectedItem, outboundTime) {
		// Build Timeslots - used by testing and lounges
		var slotStart = selectedItem.data('slot-start') || '00:00';
		var slotStartHour = parseInt(slotStart.split(':')[0]) || 0;
		var slotStartMins = parseInt(slotStart.split(':')[1]) || 0;
		var slotEnd = selectedItem.data('slot-end') || '23:59';
		var slotEndHour = parseInt(slotEnd.split(':')[0]) || 23;
		var slotEndMins = parseInt(slotEnd.split(':')[1]) || 59;
		var slotLength = parseInt(selectedItem.data('slot-length')) || 60;
		outboundTime.empty();
		for (var hours = slotStartHour; hours <= slotEndHour; hours++) {
			for (var mins = hours == slotStartHour ? slotStartMins : 0; mins < (hours == slotEndHour ? slotEndMins : 60); mins += slotLength) {
				var friendlyStartTime = String('00' + hours).slice(-2) + ':' + String('00' + mins).slice(-2);
				var friendlyEndTime = String('00' + (mins + slotLength >= 60 ? hours + 1 : hours)).slice(-2) + ':' + String('00' + (mins + slotLength < 60 ? mins + slotLength : mins + slotLength - 60)).slice(-2);
				outboundTime.append("<option value='" + friendlyStartTime + "' data-end-time='" + friendlyEndTime + "'>" + friendlyStartTime + '</option>');
			}
		}
	}
	function outboundTimeChange(productIdSelector, dateSelector, timeSelector, quantitySelector, quantityChildrenSelector, timeNotAvailableErrorMessageSelector, submitButtonSelector) {
		// Check availability - used by testing and lounges
		var quantityValue = quantitySelector.closest("[data-role='outbound-quantity-wrapper']").is(':visible') ? parseInt(quantitySelector.val()) : 1;
		quantityValue += quantitySelector.closest("[data-role='outbound-quantity-wrapper']").is(':visible') ? (quantityChildrenSelector ? parseInt(quantityChildrenSelector.val()) : 0) : 0;
		$(timeNotAvailableErrorMessageSelector).hide();
		$(submitButtonSelector).attr('disabled', 'disabled');
		if ($('option:selected', productIdSelector).length) {
			if ($('option:selected', productIdSelector)[0].hasAttribute('data-parking-product')) {
				var isAncillary = !$('option:selected', productIdSelector).data('parking-product');
				checkTimeIsAvailable(
					productIdSelector,
					dateSelector,
					timeSelector,
					isAncillary,
					quantityValue,
					function () {
						$(submitButtonSelector).removeAttr('disabled');
						$(submitButtonSelector).data('checked', true);
					},
					function () {
						$(timeNotAvailableErrorMessageSelector).show();
						$(submitButtonSelector).data('checked', true);
					}
				);
			} else {
				$(submitButtonSelector).removeAttr('disabled');
				$(submitButtonSelector).data('checked', true);
			}
		}
	}
	function checkTimeIsAvailable(productIdSelector, dateSelector, timeSelector, isAncillary, quantityValue, onValidCallback, onInvalidCallback) {
		// Time/Date is in past, so don't even waste time doing any further checks
		var currentTime = new Date();
		var chosenTime = getDateTime(dateSelector, timeSelector);
		if (chosenTime < currentTime) {
			onInvalidCallback();
		} else {
			var startDate = $(dateSelector).val().split('/');
			var startDateFormatted = startDate.reverse().join('-');
			var startTime = $(timeSelector).val();
			var endTime = $(" option[value='" + startTime + "']", timeSelector).data('end-time');
			var startDateTime = startDateFormatted + ' ' + startTime;
			var endDateTime = startDateFormatted + ' ' + endTime;
			var productId = $(productIdSelector).val();
			var productAffiliateCode = $('option:selected', productIdSelector).data('product-affiliate-code');
			var controller = '/umbraco/api/AeroparkerBookingApi/IsParkingDateTimeValid?productId={1}&arrivalDateTime={2}&returnDateTime={3}&productAffiliateCode={4}&isAncillary={5}&quantity={6}';
			controller = controller.replace('{1}', productId).replace('{2}', startDateTime).replace('{3}', endDateTime).replace('{4}', productAffiliateCode).replace('{5}', isAncillary).replace('{6}', quantityValue);
			$.ajax({
				method: 'GET',
				url: window.location.origin + controller,
				success: function success(isValid) {
					if (isValid) {
						onValidCallback();
					} else {
						onInvalidCallback();
					}
				},
				error: function error() {
					//If something happens with the api, we will just let the orginal form post handle the availability validation
					onValidCallback();
				},
			});
		}
	}

	// Util functions
	function formattedDate(date) {
		var day = String(date.getDate()).padStart(2, '0');
		var month = String(date.getMonth() + 1).padStart(2, '0');
		var year = String(date.getFullYear());
		return ''.concat(day, '/').concat(month, '/').concat(year);
	}

	function initParkingForms() {
		// Rewritten to a reusable method which reduces duplication of code - you should now just need to
		// use the same data-role/data-field references on any copy of the form and it'll work

		$("[data-role='parking-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='parking-form']");
			var entryDate = currentFormWrapper.find("[data-field='entry-date']");
			var entryTime = currentFormWrapper.find("[data-field='entry-time']");
			var exitDate = currentFormWrapper.find("[data-field='exit-date']");
			var exitTime = currentFormWrapper.find("[data-field='exit-time']");
			var combinedEntryExitFields = currentFormWrapper.find("[data-field='entry-date'], [data-field='entry-time'], [data-field='exit-date'], [data-field='exit-time']");
			var hiddenEntryTime = currentFormWrapper.find("[data-field='arrival-time']");
			var hiddenEntryDate = currentFormWrapper.find("[data-field='arrival-date']");
			var hiddenEntryDateTime = currentFormWrapper.find("[data-field='entry-datetime-final']");
			var hiddenExitTime = currentFormWrapper.find("[data-field='departure-time']");
			var hiddenExitDate = currentFormWrapper.find("[data-field='departure-date']");
			var hiddenExitDateTime = currentFormWrapper.find("[data-field='exit-datetime-final']");
			var hiddenOutboundFlightCode = currentFormWrapper.find("[data-field='outbound-flightcode-final']");
			var hiddenInboundFlightCode = currentFormWrapper.find("[data-field='inbound-flightcode-final']");
			var errorField = currentFormWrapper.find("[data-field='error-message']");
			var dynamicPrice = currentFormWrapper.find("[data-role='parking-price']");
			var outboundFlightCode = currentFormWrapper.find("[data-field='outbound-flightcode']");
			var inboundFlightCode = currentFormWrapper.find("[data-field='inbound-flightcode']");

			//Parking Start
			var hiddenParkingStart = document.querySelector("[data-field='hidden-parking-start']");

			var today = formattedDate(new Date());
			var parkingStart = '';

			if (hiddenParkingStart !== null) {
				//Parking Start Variable to be populated
				parkingStart = hiddenParkingStart.value;

				blockOutTimes(today, parkingStart);
			}

			function blockOutTimes(start, end) {
				var startTimeSelect2 = document.querySelector('.select2-results');

				if (start === end) {
					if (startTimeSelect2) {
						var currentDate = new Date();
						var currentHour = currentDate.getHours();
						var nextWholeHour = currentHour;
						if (currentDate.getMinutes() >= 0) {
							nextWholeHour = nextWholeHour + 1;
						}
						var listItems = document.querySelectorAll('.select2-results__option');
						listItems.forEach(function (item) {
							var hour = parseInt(item.textContent.split(':')[0]);
							if (hour < nextWholeHour) {
								item.remove();
							}
						});
					}
				}
			}

			entryDate.datepicker({
				dateFormat: 'dd/mm/yy',
				onSelect: function onSelect(selected) {
					var selectedDate = entryDate.datepicker('getDate');
					exitDate.datepicker('option', 'minDate', selected);
					hiddenEntryDate.val(formatDate(selectedDate));
					validateParkingForm();
					updateDynamicPrice();
					entryDate.trigger('change');
				},
				beforeShow: function beforeShow(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						$('#ui-datepicker-div').wrap("<div class='timeline-datepicker-wrapper show'></div>");
					}
				},
				onClose: function onClose(textbox, instance) {
					if ($(window).width() < 600 && entryDate.parents('.timeline-panel').length) {
						// Fading out here so as to not clash with the datepicker fadeout animation
						$('.timeline-datepicker-wrapper').fadeOut('fast', function () {
							$('#ui-datepicker-div').unwrap();
						});
					}
				},
				minDate: 0,
			});
			entryDate.change(function (e) {
				parkingStart = e.target.value;
				entryTime[0].disabled = false;
				entryTime.select2('open');
			});
			entryTime.on('select2:open', function (e) {
				setTimeout(function () {
					blockOutTimes(today, parkingStart);
				}, 10);
			}),
				entryTime.change(function () {
					if (!hiddenEntryTime) {
						hiddenEntryTime.val(formatTime($(this).val()));
					}
					validateParkingForm();
					exitDate.datepicker('show', 'minDate', entryDate.datepicker('getDate'));
					entryTime.select2('close');
				});
			exitDate.datepicker({
				dateFormat: 'dd/mm/yy',
				onSelect: function onSelect(selected) {
					var selectedDate = exitDate.datepicker('getDate');
					entryDate.datepicker('option', 'maxDate', selected);
					hiddenExitDate.val(formatDate(selectedDate));
					validateParkingForm();
					updateDynamicPrice();
					exitDate.trigger('change');
				},
				beforeShow: function beforeShow(textbox, instance) {
					if ($(window).width() < 600 && exitDate.parents('.timeline-panel').length) {
						$('#ui-datepicker-div').wrap("<div class='timeline-datepicker-wrapper show'></div>");
					}
				},
				onClose: function onClose(textbox, instance) {
					if ($(window).width() < 600 && exitDate.parents('.timeline-panel').length) {
						// Fading out here so as to not clash with the datepicker fadeout animation
						$('.timeline-datepicker-wrapper').fadeOut('fast', function () {
							$('#ui-datepicker-div').unwrap();
						});
					}
				},
				minDate: 'today',
			});
			exitDate.change(function (e) {
				exitTime[0].disabled = false;
				exitTime.select2('open');
			});
			exitTime.on('select2:open', function (e) {
				var end = formattedDate(exitDate.datepicker('getDate'));
				setTimeout(function () {
					blockOutTimes(today, end);
				}, 10);
			}),
				exitTime.change(function () {
					if (!hiddenExitTime) {
						hiddenExitTime.val(formatTime($(this).val()));
					}
					validateParkingForm();
				});
			outboundFlightCode.change(function () {
				var hourCorrection = -2;
				updateTimesFromFlightCode(outboundFlightCode, entryDate, entryTime, hourCorrection);
			});
			inboundFlightCode.change(function () {
				var hourCorrection = 2;
				updateTimesFromFlightCode(inboundFlightCode, exitDate, exitTime, hourCorrection);
			});
			combinedEntryExitFields.change(function () {
				updateDynamicPrice();
			});
			currentForm.submit(function (e) {
				if (!validateParkingForm(false)) return false;
				hiddenEntryDate.val(formatDateUk(entryDate.datepicker('getDate')));
				hiddenExitDate.val(formatDateUk(exitDate.datepicker('getDate')));
				hiddenEntryTime.val(formatTime(entryTime.val()));
				hiddenExitTime.val(formatTime(exitTime.val()));
				hiddenEntryDateTime.val(formatDate(entryDate.datepicker('getDate')).concat(' ', formatTime(entryTime.val())));
				hiddenExitDateTime.val(formatDate(exitDate.datepicker('getDate')).concat(' ', formatTime(exitTime.val())));
				hiddenOutboundFlightCode.val(outboundFlightCode.val());
				hiddenInboundFlightCode.val(inboundFlightCode.val());
				var link = this;
				ga(function (tracker) {
					var linker = new window.gaplugins.Linker(tracker);
					linker.decorate(link);
				});
				return true;
			});

			var exitDateChanged = false;
			function validateParkingForm() {
				if (entryDate.val() === null || entryTime.val() === null || exitDate.val() === null || exitTime.val() === null || entryDate.val() === '' || entryTime.val() === '' || exitDate.val() === '' || exitTime.val() === '') {
					return false;
				}

				var entryDateTime = getDateTime(entryDate, entryTime);
				var exitDateTime = getDateTime(exitDate, exitTime);
				var entryTimeStamp = entryDateTime.getTime();
				var exitTimeStamp = exitDateTime.getTime();

				if (exitDateChanged) {
					if (entryTimeStamp >= exitTimeStamp) {
						errorField.html('Entry time cannot be later than exit time').show();
						return false;
					} else {
						errorField.hide();
					}
				}

				return true;
			}

			exitDate.change(function () {
				exitDateChanged = true;
			});

			function updateTimesFromFlightCode(codeField, dateField, timeField, hourCorrection) {
				var originalDate = new Date(codeField.data('flight-date'));

				// Round time down to nearest hour then add/subtract correction
				var roundedDate = new Date(originalDate);
				roundedDate.setMinutes(0);
				var recommendedDate = new Date(roundedDate);
				recommendedDate.setHours(recommendedDate.getHours() + hourCorrection);
				dateField.datepicker('setDate', recommendedDate);
				timeField.val(formatTime(recommendedDate));
				timeField.trigger('change.select2');
			}
			function updateDynamicPrice() {
				if (dynamicPrice.length) {
					var entryDateTime = formatDate(entryDate.datepicker('getDate')) + ' ' + formatTime(entryTime.val());
					var exitDateTime = formatDate(exitDate.datepicker('getDate')) + ' ' + formatTime(exitTime.val());
					$.ajax({
						url: '/umbraco/api/AeroparkerBookingApi/RetrieveLowestParkingPrice?entryDateTime=' + entryDateTime + '&exitDateTime=' + exitDateTime,
						contentType: 'application/json; charset=utf-8',
						type: 'GET',
					})
						.done(function (data) {
							if (data) {
								dynamicPrice.show();
								dynamicPrice.find("[data-role='parking-price-value']").text(data);
							} else {
								dynamicPrice.hide();
							}
						})
						.fail(function (xhr, status, error) {
							var errorMessage = JSON.parse(xhr.responseText).message;
							console.log(errorMessage);
						});
				}
			}
		});
	}
	function initFastClick() {
		FastClick.attach(document.body);
	}
	function initClickBox() {
		// makes entire 'div'/section clickable to the first link within
		$('.clickBox').click(function () {
			var firstLink = $(this).find('a').first();
			if (firstLink.attr('target') === '_blank') {
				window.open(firstLink.attr('href'), '_blank');
			} else {
				window.location = firstLink.attr('href');
			}
		});
		$('.clickBox')
			.find('a')
			.click(function (e) {
				// Prevent child link elements bubbling
				e.stopPropagation();
			});
	}
	function initTaxisForms() {
		$("[data-role='taxis-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='taxis-form']");
			var airport = currentFormWrapper.find("[data-field='airport']");
			var outboundDate = currentFormWrapper.find("[data-field='outbound-date']");
			var outboundHours = currentFormWrapper.find("[data-field='outbound-hours']");
			var outboundMinutes = currentFormWrapper.find("[data-field='outbound-minutes']");
			var returnDate = currentFormWrapper.find("[data-field='return-date']");
			var returnHours = currentFormWrapper.find("[data-field='return-hours']");
			var returnMinutes = currentFormWrapper.find("[data-field='return-minutes']");
			var bookingType = currentFormWrapper.find("[data-field='booking-type']");
			var outboundDateWrapper = currentFormWrapper.find("[data-role='outbound-date-wrapper']");
			var returnDateWrapper = currentFormWrapper.find("[data-role='return-date-wrapper']");
			var adults = currentFormWrapper.find("[data-field='adults']");
			var children = currentFormWrapper.find("[data-field='children']");
			var infants = currentFormWrapper.find("[data-field='infants']");
			var affiliateId = currentFormWrapper.find("[data-field='affiliateId']");

			outboundDate.on('change', function () {
				returnDate.datepicker('option', 'minDate', outboundDate.datepicker('getDate'));
			});

			returnDate.on('change', function () {
				outboundDate.datepicker('option', 'maxDate', returnDate.datepicker('getDate'));
			});

			bookingType.on('change', function () {
				var selectedBookingType = currentFormWrapper.find("[data-field='booking-type']:checked").val();
				if (selectedBookingType === 'RTN') {
					outboundDateWrapper.show();
					returnDateWrapper.show();
					// Reset outbound and return date constraints
					outboundDate.datepicker('option', 'maxDate', null);
					returnDate.datepicker('option', 'minDate', outboundDate.datepicker('getDate'));
				}
				if (selectedBookingType === 'SGO') {
					outboundDateWrapper.hide();
					returnDateWrapper.show();
					// Reset outbound maxDate
					outboundDate.datepicker('option', 'maxDate', null);
				}
				if (selectedBookingType === 'SGI') {
					outboundDateWrapper.show();
					returnDateWrapper.hide();
					// Reset return minDate
					returnDate.datepicker('option', 'minDate', null);
				}
			});
			currentForm.submit(function (e) {
				if (validateSameDayTimes(outboundDate.datepicker('getDate'), outboundHours.val() + ':' + outboundMinutes.val(), returnDate.datepicker('getDate'), returnHours.val() + ':' + returnMinutes.val())) {
					var selectedBookingType = currentFormWrapper.find("[data-field='booking-type']:checked").val();
					var taxiUrl =
						'https://www.holidaytaxis.com/en/incoming?ref=' +
						affiliateId.val() +
						'&IATA=' +
						airport.val() +
						'&bookingtypecode=' +
						selectedBookingType +
						'&pax=' +
						adults.val() +
						',' +
						children.val() +
						',' +
						infants.val() +
						(selectedBookingType !== 'SGI' ? '&arrivaldatetime=' + formatDate(outboundDate.datepicker('getDate')) : '') +
						' ' +
						outboundHours.val() +
						':' +
						outboundMinutes.val() +
						(selectedBookingType !== 'SGO' ? '&departuredatetime=' + formatDate(returnDate.datepicker('getDate')) : '') +
						' ' +
						returnHours.val() +
						':' +
						returnMinutes.val();
					window.open(taxiUrl, '_blank');
				}
			});
		});
	}
	function initHotelForms() {
		$("[data-role='hotel-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='hotel-form']");
			var destination = currentFormWrapper.find("[data-field='destination']");
			var startDate = currentFormWrapper.find("[data-field='start-date']");
			var endDate = currentFormWrapper.find("[data-field='end-date']");
			var affiliateId = currentFormWrapper.find("[data-field='affiliate-id']");
			currentForm.submit(function (e) {
				e.preventDefault();
				var formattedStartDate = formatDate(startDate.datepicker('getDate'));
				var formattedEndDate = formatDate(endDate.datepicker('getDate'));
				var bookingUrl =
					'https://www.booking.com/searchresults.html?aid=' +
					affiliateId.val() +
					'&ss=' +
					destination.val() +
					'&si=ci' +
					(formattedStartDate !== '' && formattedEndDate !== ''
						? '&checkin_monthday=' +
						  formattedStartDate.substring(8) +
						  '&checkin_year_month=' +
						  formattedStartDate.substring(0, 7) +
						  '&checkout_monthday=' +
						  formattedEndDate.substring(8) +
						  '&checkout_year_month=' +
						  formattedEndDate.substring(0, 7) +
						  '&do_availability_check=1'
						: '');
				window.open(bookingUrl, '_blank');
			});
			startDate.on('change', function () {
				endDate.datepicker('option', 'minDate', startDate.datepicker('getDate'));
			});
			endDate.on('change', function () {
				startDate.datepicker('option', 'maxDate', endDate.datepicker('getDate'));
			});
		});
	}
	function initFlightForms() {
		$("[data-role='flight-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='flight-form']");
			var starting = currentFormWrapper.find("[data-field='starting']");
			var destination = currentFormWrapper.find("[data-field='flight-destination']");
			var startDate = currentFormWrapper.find("[data-field='start-date']");
			var endDate = currentFormWrapper.find("[data-field='end-date']");
			var people = currentFormWrapper.find("[data-field='people']");
			var associateId = currentFormWrapper.find("[data-field='associate-id']");
			currentForm.submit(function (e) {
				e.preventDefault();
				var formattedStartDate = formatDateShort(startDate.datepicker('getDate'));
				var formattedEndDate = formatDateShort(endDate.datepicker('getDate'));
				var bookingUrl =
					'https://skyscanner.net/g/referrals/v1/flights/day-view/?mediaPartnerId=' +
					associateId.val() +
					'&origin=' +
					starting.val() +
					'&destination=' +
					destination.val() +
					'&adultsv2=' +
					people.val() +
					'&outboundDate=20' +
					formattedStartDate +
					'&inboundDate=20' +
					formattedEndDate;
				window.open(bookingUrl, '_blank');
			});
			startDate.on('change', function () {
				endDate.datepicker('option', 'minDate', startDate.datepicker('getDate'));
			});
			endDate.on('change', function () {
				startDate.datepicker('option', 'maxDate', endDate.datepicker('getDate'));
			});

			// If on a destination page, default dropdowns of all copies of this form
			if (currentFormWrapper.data('default-destination')) {
				$("[data-field='flight-destination']").each(function () {
					$(this).val(currentFormWrapper.data('default-destination'));
					$(this).trigger('change');
				});
			}
		});
	}
	function initTravelInsuranceForms() {
		$("[data-role='insurance-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='insurance-form']");
			var tripType = currentFormWrapper.find("[data-field='trip-type']");
			var destination = currentFormWrapper.find("[data-field='destination']");
			var outboundDate = currentFormWrapper.find("[data-field='outbound-date']");
			var returnDate = currentFormWrapper.find("[data-field='return-date']");
			var coverDate = currentFormWrapper.find("[data-field='cover-date']");
			var people = currentFormWrapper.find("[data-field='travellers']");
			var hiddenDestination = currentFormWrapper.find("[data-field='hidden-destination']");
			var hiddenFromDate = currentFormWrapper.find("[data-field='hidden-from-date']");
			var hiddenToDate = currentFormWrapper.find("[data-field='hidden-to-date']");
			var hiddenPeople = currentFormWrapper.find("[data-field='hidden-people']");
			var hiddenAnnual = currentFormWrapper.find("[data-field='hidden-annual']");
			var singleTripWrapper = currentFormWrapper.find("[data-role='single-trip-wrapper']");
			var annualTripWrapper = currentFormWrapper.find("[data-role='annual-trip-wrapper']");
			outboundDate.on('change', function () {
				returnDate.datepicker('option', 'minDate', outboundDate.datepicker('getDate'));
			});
			returnDate.on('change', function () {
				outboundDate.datepicker('option', 'maxDate', returnDate.datepicker('getDate'));
			});
			tripType.on('change', function () {
				var selectedOption = currentFormWrapper.find("[data-field='trip-type']:checked").val();
				if (selectedOption === '1') {
					singleTripWrapper.hide();
					annualTripWrapper.show();
				}
				if (selectedOption === '0') {
					singleTripWrapper.show();
					annualTripWrapper.hide();
				}
			});
			currentForm.submit(function (e) {
				var selectedOption = currentFormWrapper.find("[data-field='trip-type']:checked").val();
				var fromArr = selectedOption === '0' ? outboundDate.val().split('/') : coverDate.val().split('/');
				var fromDate = fromArr[2] + '-' + fromArr[1] + '-' + fromArr[0];
				var toArr = selectedOption === '0' ? returnDate.val().split('/') : coverDate.val().split('/');
				var toDate = toArr[2] + '-' + toArr[1] + '-' + toArr[0];
				hiddenDestination.val(destination.val());
				hiddenPeople.val(people.val());
				hiddenAnnual.val(selectedOption === '1' ? '1' : '0');
				hiddenFromDate.val(fromDate);
				hiddenToDate.val(toDate);
				var link = this;
				ga(function (tracker) {
					var linker = new window.gaplugins.Linker(tracker);
					linker.decorate(link);
				});
			});
		});
	}
	function initCarHireForms() {
		$("[data-role='carhire-form-wrapper']").each(function () {
			var currentFormWrapper = $(this);
			var currentForm = currentFormWrapper.find("[data-role='carhire-form']");
			var airport = currentFormWrapper.find("[data-field='airport']");
			var outboundDate = currentFormWrapper.find("[data-field='outbound-date']");
			var outboundHours = currentFormWrapper.find("[data-field='outbound-hours']");
			var outboundMinutes = currentFormWrapper.find("[data-field='outbound-minutes']");
			var returnDate = currentFormWrapper.find("[data-field='return-date']");
			var returnHours = currentFormWrapper.find("[data-field='return-hours']");
			var returnMinutes = currentFormWrapper.find("[data-field='return-minutes']");
			var affiliateCode = currentFormWrapper.find("[data-field='hidden-affiliate-code']");
			var outboundDateWrapper = currentFormWrapper.find("[data-role='outbound-date-wrapper']");
			var returnDateWrapper = currentFormWrapper.find("[data-role='return-date-wrapper']");
			outboundDate.on('change', function () {
				returnDate.datepicker('option', 'minDate', outboundDate.datepicker('getDate'));
			});
			returnDate.on('change', function () {
				outboundDate.datepicker('option', 'maxDate', returnDate.datepicker('getDate'));
			});
			currentForm.submit(function (e) {
				if (validateSameDayTimes(outboundDate.datepicker('getDate'), outboundHours.val() + ':' + outboundMinutes.val(), returnDate.datepicker('getDate'), returnHours.val() + ':' + returnMinutes.val())) {
					var carHireUrl =
						'https://www.rentalcars.com/AirportLandingPage.do?' +
						'iata=' +
						airport.val() +
						'&countryCode=' +
						airport.children('option:selected').data('country-code') +
						'&affiliateCode=' +
						affiliateCode.val() +
						'&puDay=' +
						outboundDate.datepicker('getDate').getDate() +
						'&puMonth=' +
						(outboundDate.datepicker('getDate').getMonth() + 1) +
						'&puYear=' +
						outboundDate.datepicker('getDate').getFullYear() +
						'&puHour=' +
						outboundHours.val() +
						'&puMinute=' +
						outboundMinutes.val() +
						'&doDay=' +
						returnDate.datepicker('getDate').getDate() +
						'&doMonth=' +
						(returnDate.datepicker('getDate').getMonth() + 1) +
						'&doYear=' +
						returnDate.datepicker('getDate').getFullYear() +
						'&doHour=' +
						returnHours.val() +
						'&doMinute=' +
						returnMinutes.val();
					window.open(carHireUrl, '_blank');
				}
			});
		});
	}
	function initStickySideBar() {
		var browserWidth = window.innerWidth;
		// Make sure to unbind events to the button so does

		// Exit from this function if nothing sticky in here
		if (!$('[data-sticky_column]').length) {
			return;
		}
		if (browserWidth <= 900) {
			$('[data-sticky_column]').trigger('sticky_kit:detach');
		} else {
			// $('[data-sticky_column]').stick_in_parent();

			$('[data-sticky_column]')
				.stick_in_parent()
				.on('sticky_kit:bottom', function (e) {
					//e.target.parent.css('position', 'static');
					//e.target.addClass("at_bottom").removeClass("is_stuck");
				})
				.on('sticky_kit:unbottom', function (e) {
					//e.target.parent().css('position', 'relative');
					//e.target.removeClass("at_bottom").addClass("is_stuck");
				});
		}
		$('a[data-accordion-link]').click(function (e) {
			e.preventDefault();
			var anchorItem = $($(this).attr('href'));
			var anchorAccordionIndex = anchorItem.index('div.timeline__heading');
			$('#timeline').accordion('option', 'animate', false);
			$('#timeline').accordion('option', 'active', false);
			$('#timeline').accordion('option', 'animate', 200);
			$('#timeline').accordion('option', 'active', anchorAccordionIndex);
			//$(anchorId).trigger('click');
		});

		//$('[data-sticky_column]').stick_in_parent();
	}

	function initStickyFlightAndSideBar() {
		// This is a duplicate of the above but another pinned section is added so not to break this used elsewhere a new class is added to the sidebar
		var browserWidth = window.innerWidth;
		// Make sure to unbind events to the button so does

		// Exit from this function if nothing sticky in here
		if (!$('[data-sticky_sidebar], [data-sticky_timeline-flight]').length) {
			return;
		}
		if (browserWidth <= 900) {
			$('[data-sticky_sidebar]').trigger('sticky_kit:detach');
			$('[data-sticky_timeline-flight]').stick_in_parent({
				offset_top: 0, // room for the top bar to pin
			});
		} else if (browserWidth > 900 && browserWidth < 1024) {
			$('[data-sticky_timeline-flight]')
				.stick_in_parent({
					offset_top: 40, // room for the top bar to pin
				})
				.on('sticky_kit:bottom', function (e) {})
				.on('sticky_kit:unbottom', function (e) {});
			$('[data-sticky_sidebar]')
				.stick_in_parent({
					offset_top: 270, // room for the top bar to pin
				})
				.on('sticky_kit:bottom', function (e) {})
				.on('sticky_kit:unbottom', function (e) {});
		} else {
			$('[data-sticky_timeline-flight]')
				.stick_in_parent({
					offset_top: 40, // room for the top bar to pin
				})
				.on('sticky_kit:bottom', function (e) {})
				.on('sticky_kit:unbottom', function (e) {});
			$('[data-sticky_sidebar]')
				.stick_in_parent({
					offset_top: 190, // room for the top bar to pin
				})
				.on('sticky_kit:bottom', function (e) {})
				.on('sticky_kit:unbottom', function (e) {});
		}
	}
	function initCloseBookingStrip() {
		$(window).on('click', function (event) {
			// if click outside booking strip
			if (!event.target.closest('.booking-module, .ui-datepicker, .ui-corner-all, .ui-menu')) {
				$('.booking-module-pinned .booking-module__panel').hide();
				$('.fixed .booking-module__panel').hide();
				$('.fixed').find('a').removeClass('active');
				$('.booking-module-pinned').find('a').removeClass('active');
			}
		});
	}

	/*Custom Select Dropdown*/
	function initCustomSelect() {
		$('.custom-select').customSelect();
	}

	/*
     function initScrollPane() {
          var browserWidth = window.innerWidth;
           if (browserWidth <= 900) {
                     $('.scroll-pane').jScrollPane({
                         horizontalDragMinWidth: 120,
                         horizontalDragMaxWidth: 120,
                         autoReinitialise: true // this needs to be applied each time you scale your browser window
                     });
                 } else {
                     console.log('not used');
                      {
                         var apis = [];
                         if (apis.length) {
                             $.each(
                                 apis, function(i) {
                                     this.destroy();
                                 }
                             );
                             apis = [];
                         }
                         return false;
                     }
                 }
  
     }
  */

	function initIconSlider() {
		$('.popular-actions:not(.popular-actions--stacked)').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			infinite: false,
			arrows: true,
			dots: false,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 4,
						arrows: false,
						dots: true,
					},
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 3,
						arrows: false,
						dots: true,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						arrows: false,
						dots: true,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						arrows: false,
						dots: true,
					},
				},
			],
		});
	}
	function initFlightCodeShare() {
		// Do not run this on codeshares marked 'dynamic' - there is a call in the angular app for this
		$('.codeshare__flight-no').not('.dynamic').slick({
			vertical: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			arrows: false,
			dots: false,
		});
		$('body').on('click', '.codeshare__number', function (e) {
			e.preventDefault();
			$('.codeshare__popup').toggle();
		});
	}
	function initAlert() {
		var alertBox = Cookies.get('alertBox');
		var alertStringCookie = Cookies.get('alertString');
		var alertTimeout = (1 / 1440) * 30;
		var alertCount = $('body').data('alert-count');
		var alertTexts = $('[data-alert-text]');
		var alertTextsCount = alertTexts.length;
		var alertString = '';
		var i;
		for (i = 0; i < alertTextsCount; i++) {
			alertString = alertString + alertTexts[i].innerText;
		}
		if ((typeof alertBox === 'undefined' || alertBox === null) && $('body').data('alert') === true && Cookies.get('cc_chosen')) {
			$('body').addClass('show-alert');
			Cookies.set('alertBox', '1', {
				expires: alertTimeout,
				sameSite: 'strict',
			});
			Cookies.set('alertString', alertString, {
				expires: alertTimeout,
				sameSite: 'strict',
			});
		}
		if (alertStringCookie !== 'undefined' && $('body').data('alert') === true) {
			if (alertStringCookie != alertString) {
				$('body').addClass('show-alert');
			}
			Cookies.set('alertString', alertString, {
				expires: alertTimeout,
				sameSite: 'strict',
			});
		}
	}
	function initCloseAlertonLoad() {
		if ($('body').hasClass('show-alert')) {
			$('.icon-close').click(function (e) {
				$('body').removeClass('show-alert');
			});
		}
	}
	function initMatchingHeight() {
		// $(".social-panel div").matchHeight({
		// 	byRow: true,
		// });
		$('.flight-status .matchHeight').matchHeight();
		$('.sitemap__col').matchHeight();
		$('.see-and-do__col .big-text').matchHeight();
		$('.shop-dine__col h3').matchHeight();
		$('.timeline-panel__copy h3').matchHeight();
		$('.mega-menu__item').matchHeight();
	}

	/*function initArrivalsDeparturesBoard() {
         var tabBtn = $('.live-flights__btns a');
         var tabs = $('.tabs__tab');
          if (!tabBtn.length) {
             return;
         }
         tabBtn.click(function(e) {
             e.preventDefault();
             var tabTarget = $(this).attr('href');
             var activeTab = $(tabTarget);
              $(this).closest('.live-flights__btns').find('li').removeClass('js-active');
             $(this).parent().addClass('js-active');
             $(this).closest('.live-flights').find('.live-flights__tab').removeClass('js-active');
             activeTab.addClass('js-active');
         });
     }*/

	function initFlightTimetable() {
		var tabBtn = $('.flight-timetable__btns a');
		var tabs = $('.flight-timetable__tab');
		if (!tabBtn.length) {
			return;
		}
		tabBtn.click(function (e) {
			e.preventDefault();
			var tabTarget = $(this).attr('href');
			var activeTab = $(tabTarget);
			$(this).closest('.flight-timetable__btns').find('li').removeClass('js-active');
			$(this).parent().addClass('js-active');
			$(this).closest('.content__timetable').find('.flight-timetable__tab').removeClass('js-active');
			activeTab.addClass('js-active');
		});
	}
	function initSharePopUp() {
		var container = $('.share__links');
		$('.share__cta').click(function (e) {
			container.toggle();
		});
	}
	function initBookingModuleTabs() {
		/*    $('.booking-module__tabs').each(function() {
                  // For each set of tabs, we want to keep track of
                  // which tab is active and it's associated content
                  var $active, $content, $links = $(this).find('a');
                   // If the location.hash matches one of the links, use that as the active tab.
                  // If no match is found, use the first link as the initial active tab.
                  $active = $($links.filter('[href="' + location.hash + '"]')[0] || $links[0]);
                    $content = $($active[0].hash);
                   // Hide the remaining content
                  $links.not($active).each(function() {
                      $(this.hash).hide();
                  });
                   // Bind the click event handler
                  $(this).on('click', 'a', function(e) {
                      // Make the old tab inactive.
                      $active.removeClass('active');
                      $content.hide();
                       // Update the variables with the new link and content
                      $active = $(this);
                      $content = $(this.hash);
                       // Make the tab active.
                      $active.addClass('active');
                      $content.show();
                       // Prevent the anchor's default click action
                      e.preventDefault();
                  });
              });*/

		var pinnedBookingBar = $('.booking-module-pinned');
		var tabsParent = $('.booking-module');
		var tabLinks = tabsParent.find('.booking-module__tabs a');
		var tabs = $('.booking-module__panel');
		tabLinks.click(function (e) {
			if (tabsParent.length && pinnedBookingBar.length) {
				//  e.preventDefault();

				if ($(this).hasClass('active')) {
					var targetOpened = $(this).data('tabTarget');
					tabLinks.removeClass('active');
					$(this).removeClass('active');
					tabs
						.filter(function () {
							return $(this).data('tab') == targetOpened;
						})
						.hide();
				} else {
					var targetClosed = $(this).data('tabTarget');
					tabLinks.removeClass('active');
					$(this).addClass('active');
					tabs.hide();
					tabs
						.filter(function () {
							return $(this).data('tab') == targetClosed;
						})
						.show();
				}
			} else if (tabsParent.length && $('#BookingModuleHome .booking-module').hasClass('fixed')) {
				// On the homepage when the tabs are pinned.

				if ($(this).hasClass('active')) {
					var targetOpenedPinned = $(this).data('tabTarget');
					tabLinks.removeClass('active');
					$(this).removeClass('active');
					tabs
						.filter(function () {
							return $(this).data('tab') == targetOpenedPinned;
						})
						.hide();
				} else {
					var targetClosedPinned = $(this).data('tabTarget');
					tabLinks.removeClass('active');
					$(this).addClass('active');
					tabs.hide();
					tabs
						.filter(function () {
							return $(this).data('tab') == targetClosedPinned;
						})
						.show();
				}
			} else {
				//e.preventDefault();

				if ($(this).hasClass('external-link')) {
					console.log('clicked external');
				} else {
					var target = $(this).data('tabTarget');
					tabLinks.removeClass('active');
					$(this).addClass('active');
					tabs.hide();
					tabs
						.filter(function () {
							return $(this).data('tab') == target;
						})
						.show();
				}
			}
		});
		$('.booking-module-ADT-btns a.flights').click(function (e) {
			//    e.preventDefault();
			$('.booking-module-ADT-btns a').removeClass('active-btn');
			$('#book-flights-and-hotels').removeClass('hotel').removeClass('holidays');
			$('#book-flights-and-hotels').addClass('flights');
			$(this).addClass('active-btn');
		});
		$('.booking-module-ADT-btns a.hotel').click(function (e) {
			// e.preventDefault();
			$('.booking-module-ADT-btns a').removeClass('active-btn');
			$('#book-flights-and-hotels').removeClass('flights').removeClass('holidays');
			$('#book-flights-and-hotels').addClass('hotel');
			$(this).addClass('active-btn');
		});
		$('.booking-module-ADT-btns a.holidays').click(function (e) {
			//  e.preventDefault();
			$('.booking-module-ADT-btns a').removeClass('active-btn');
			// $('#book-flights-and-hotels').removeClass('flights').removeClass('hotel');
			//  $('#book-flights-and-hotels').addClass('holidays');
			//$('#book-flights-and-hotels').addClass('open');
			$(this).addClass('active-btn');
		});
		$('.booking-module__tabs a').click(function () {
			$('.booking-module-ADT-btns a').removeClass('active-btn');
			$('#book-flights-and-hotels').removeClass('open');
		});
		$('.booking-module-ADT-btns a').click(function () {
			$('#book-flights-and-hotels').addClass('open');
		});
	}
	function initBookingModuleExpander() {
		$('.booking-module__expand').click(function () {
			var ul = $(this).siblings('.booking-module__tabs');

			// finish any currently running animations
			ul.finish();

			//  if (ul.hasClass('expanded'))
			//   {
			//  ul.removeClass('expanded');

			// hide the list options above number 3, then animate the slide
			//  ul.find('li:nth-of-type(4) ~ li').hide({ duration: '400', complete: function() { ul.animate({height: '100%'}, 'slow'); }});
			// }
			// else
			//{
			ul.addClass('expanded');
			$(this).hide();
			ul.css({
				height: ul.css('height'),
			});
			ul.find('li').show({
				complete: function complete() {
					ul.animate(
						{
							height: '100%',
						},
						'fast'
					);
				},
			});
			//}

			return false;
		});
	}
	function initOfferCarousel() {
		$('.offer-carousel').slick({
			//  arrows: true,
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			adaptiveHeight: true,
			useTransform: false,
			useCSS: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: true,
					},
				},
				{
					breakpoint: 600,
					settings: {
						arrows: false,
					},
				},
			],
		});
	}
	function initItemCarousel() {
		slidesLen = $('.item-carousel__slide').length;
		defaultLen = 5;
		desktopLen = slidesLen >= defaultLen ? defaultLen : slidesLen;
		$('.item-carousel').slick({
			centerMode: true,
			centerPadding: '120px',
			slidesToShow: desktopLen,
			responsive: [
				{
					breakpoint: 1800,
					settings: {
						slidesToShow: desktopLen,
						centerPadding: '120px',
					},
				},
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 3,
						centerPadding: '120px',
					},
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						centerPadding: '30px',
					},
				},
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2,
						centerPadding: '30px',
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						centerPadding: '30px',
					},
				},
			],
		});
	}

	function initParkingGridCarousel() {
		var windowLimit = 600;
		var $slick_slider = $('.parking-type-list');
		if (!$slick_slider.length) {
			return;
		}
		var settings = {
			infinite: false,
			arrows: false,
			dots: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: windowLimit,
					settings: 'unslick',
				},
				{
					breakpoint: windowLimit - 1,
					settings: {
						slidesToShow: 1,
						centerMode: true,
					},
				},
			],
		};
		function initParkingSlider() {
			if (!$slick_slider.hasClass('slick-initialized')) {
				return $slick_slider.slick(settings);
			}
		}
		if (window.innerWidth < windowLimit) {
			initParkingSlider();
		}
		$(window).on('resize', function () {
			if ($(window).width() < windowLimit) {
				initParkingSlider();
			}
		});
	}
	function initSimilarDestinations() {
		$('.item-slider').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: false,
			arrows: true,
			dots: false,
			responsive: [
				//  {
				//  breakpoint: 600,
				//     settings: {
				//    slidesToShow: 2,
				//   centerMode: true,
				// }
				///  },
				{
					breakpoint: 1024,
					settings: {
						slidesToScroll: 2,
						slidesToShow: 2,
						// dots: true,
						//slidesToScroll: 2,
						//  centerMode: true,
						infinite: true,
					},
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
						// centerMode: true,
						// dots: true
					},
				},
			],
		});
	}

	function initLogoCarousel() {
		var windowLimit = 600;
		// var $slick_slider = $(".logos");
		var $slick_slider = $('.logos-banner__logos-wrapper');
		if (!$slick_slider.length) {
			return;
		}
		var settings = {
			infinite: false,
			arrows: false,
			dots: true,
			mobileFirst: true,
			slidesToShow: 2,
			responsive: [
				{
					breakpoint: windowLimit,
					settings: 'unslick',
				},
				{
					breakpoint: windowLimit - 1,
				},
			],
		};
		function initLogoSlider() {
			if (!$slick_slider.hasClass('slick-initialized')) {
				return $slick_slider.slick(settings);
			}
		}
		if (window.innerWidth < windowLimit) {
			initLogoSlider();
		}
		$(window).on('resize', function () {
			if ($(window).width() < windowLimit) {
				initLogoSlider();
			}
		});
	}
	function initBookingStripPinned() {
		var bookingPinnedBar = $('.booking-module-pinned');
		if (bookingPinnedBar.length) {
			$('body').addClass('hasBookingStrip');
			$(window)
				.resize(function () {
					if ($(window).width() < 767) {
						$('body').removeClass('hasBookingStrip');
					} else {
						$('body').addClass('hasBookingStrip');
					}
				})
				.resize();
		}
	}
	function initViewMoreDestinations() {
		var btn = $('[data-view-more-destinations]');
		var contentBlock = $('.destinations-feed-hidden');
		btn.click(function () {
			contentBlock.css('height', 'auto');
			$('.destinations-feed-hidden__view-more').hide();
		});
	}
	function initContentReadMoreExpander() {
		var btn = $('#content-read-more');
		var contentBlock = $('.content__copy');
		btn.click(function (e) {
			e.preventDefault();
			contentBlock.css('height', 'auto');
			$('.content__read-more').hide();
		});
	}

	// function initStickyBookingModule() {
	//     function handleBookingModuleHeightChange() {
	//         var bookingModuleHeight = $("#BookingModuleHome .booking-module").outerHeight();
	//         $("#BookingModuleHome").css("height", bookingModuleHeight + "px");
	//     }
	//     if (0 !== $("#BookingModuleHome").length) {
	//         var BookingModule = $("#BookingModuleHome .booking-module"),
	//             target_offset = BookingModule.offset().top,
	//             stickyBookingStrip = function() {
	//                 var scroll_top = $(window).scrollTop();
	//                 scroll_top > target_offset + 240 && !BookingModule.hasClass("fixed") && (BookingModule.addClass("fixed"), $("#book-flights-and-hotels").hide(), $(".booking-module__panel").hide(), $(".booking-module__tabs a").removeClass("active")), target_offset + 200 > scroll_top && BookingModule.hasClass("fixed") && (BookingModule.removeClass("fixed"), $(".booking-module__tabs a").hasClass("active") || ($("#BookingModuleHome").css("height", "230px"), $(".booking-module__tabs a.parking").addClass("active"), $("div[data-tab=book-parking]").show()));
	//             };
	//         handleBookingModuleHeightChange(), $("#BookingModuleHome .booking-module__tabs a").click(function() {
	//             handleBookingModuleHeightChange();
	//         }), stickyBookingStrip(), $(window).scroll(function() {
	//             $(window).width() >= 767 && stickyBookingStrip();
	//         });
	//     }
	// }

	function initStickyBookingModule() {
		if ($('#BookingModuleHome').length === 0) {
			return;
		}
		var BookingModule = $('#BookingModuleHome .booking-module');
		var target_offset = BookingModule.offset().top;
		var stickyBookingStrip = function stickyBookingStrip() {
			var scroll_top = $(window).scrollTop(); // our current vertical position from the top
			// when the page has scrolled 300px past the top of the module

			if (scroll_top > target_offset + 240 && !BookingModule.hasClass('fixed')) {
				BookingModule.addClass('fixed');
				$('#book-flights-and-hotels').hide(); // hide any open panels
				$('.booking-module__panel').hide();
				$('.booking-module__tabs a').removeClass('active'); // remove the active state off any btns
			}

			if (scroll_top < target_offset + 200 && BookingModule.hasClass('fixed')) {
				BookingModule.removeClass('fixed');
				$('#ui-datepicker-div').css('display', 'none');
				if (!$('.booking-module__tabs a').hasClass('active')) {
					$('#BookingModuleHome').css('height', '230px');
					$('.booking-module__tabs a.parking').addClass('active');
					$('.booking-module__tabs a.parking').click();
					$('div[data-tab=book-parking]').show();
				}
			}
		};

		// handleBookingModuleHeightChange();

		$('#BookingModuleHome .booking-module__tabs a').click(function (e) {
			handleBookingModuleHeightChange();
			// e.preventDefault();
		});

		$(window).on('load', function () {
			handleBookingModuleHeightChange();
		});

		/* Chris D added on 3rd September trying to fix GLA-601
          $('#BookingModuleHome .booking-module__tabs a.holidays').click(function(event) {
               setTimeout(function(){
                handleBookingModuleHeightChange();
              }, 10);
          });
           $('.booking-module-ADT-btns').click(function(event) {
              handleBookingModuleHeightChange();
          });
    */

		function handleBookingModuleHeightChange() {
			// find the height of the booking module wrapper
			var bookingModuleHeight = $('#BookingModuleHome .booking-module').outerHeight();
			// add the height to the wrapper so there is no jump when it becomes fixed
			$('#BookingModuleHome').css('height', bookingModuleHeight + 'px');
		}

		// run our function on load
		stickyBookingStrip();

		// and run it again every time you scroll
		$(window).scroll(function () {
			if ($(window).width() >= 767) {
				stickyBookingStrip();
			}
		});
	}
	function initClipPath() {
		var areClipPathShapesSupported = function areClipPathShapesSupported() {
			var base = 'clipPath',
				prefixes = ['webkit', 'moz', 'ms', 'o'],
				properties = [base],
				testElement = document.createElement('testelement'),
				attribute = 'polygon(50% 0%, 0% 100%, 100% 100%)';

			// Push the prefixed properties into the array of properties.
			for (var i = 0, l = prefixes.length; i < l; i++) {
				var prefixedProperty = prefixes[i] + base.charAt(0).toUpperCase() + base.slice(1); // remember to capitalize!
				properties.push(prefixedProperty);
			}

			// Interate over the properties and see if they pass two tests.
			for (var v = 0, leng = properties.length; v < leng; v++) {
				var property = properties[v];

				// First, they need to even support clip-path (IE <= 11 does not)...
				if (testElement.style[property] === '') {
					// Second, we need to see what happens when we try to create a CSS shape...
					testElement.style[property] = attribute;
					if (testElement.style[property] !== '') {
						return true;
					}
				}
			}
			return false;
		};
		if (!areClipPathShapesSupported()) {
			$('html').addClass('no-clip-path-shapes');
		}
	}
	function initMobileGetInspiredFilter() {
		// var getInspiredModal = $('#get-inspired-selection');
		var filterBtn = $('.get-inspired-results__filter-btn');
		var filterItem = $('.get-inspired-mobile-filter li a');

		//   filterBtn.click(function(e) {
		//  e.preventDefault();
		//   getInspiredModal.removeClass('modal-closed');
		//  });
		//open up the modal, but first remove the class on the modal as it is forced hidden as the modal is not closed with the 'x'

		// Click on one of the filters in the mobile menu
		filterItem.click(function (e) {
			//  e.preventDefault();
			// removes all instances that have an active class
			filterItem.removeClass('active');
			// adds the class to the one clicked
			$(this).addClass('active');
			// removes the attributes on the modal and the class
			// getInspiredModal.attr('aria-hidden','true').removeClass('is-active');
			// removes the overlay class which is causing the overlay to be shown
			//$('html').removeClass('has-overlay');
			//
			var FilterSelected = $(this).data('name');
			filterBtn.html(FilterSelected);
			// getInspiredModal.addClass('modal-closed');
		});
	}

	function initHeroSlider() {
		$('#view-gallery').detach().appendTo(document.body); // Move any gallery slides to the end

		$('.hero-slider').slick({
			dots: true,
			appendDots: $('.hero-slider__dots'),
			arrows: true,
			appendArrows: $('.hero-slider__nav'),
			autoplay: true,
			draggable: true,
			swipe: true,
			/*
                       responsive: [{
                                  breakpoint: 900,
                                  settings: {
                                      arrows: false,
                                  }
                              }
                             {
                                  breakpoint: 767,
                                  settings: {
                                      draggable: true
                                  }
                              }
                          ]*/
		});
	}

	function initHeroReviewSwiperSlider() {
		$('.hero-slider-review-swiper').slick({
			dots: true,
			appendDots: $('.hero-slider-review-swiper__dots'),
			arrows: true,
			appendArrows: $('.hero-slider-review-swiper__nav'),
			autoplay: true,
			draggable: true,
			swipe: true,
		});
	}
	function initResponsiveNav() {
		var header = $('.header');
		var toggleMenuBtn = $('.header__hamburger');
		var toggleServicesBtn = $('.header__services');
		var menuBtnIcon = $('.header__hamburger span');
		var servicesBtnIcon = $('.header__services span');
		toggleMenuBtn.click(function (event) {
			if (header.hasClass('header--menu-open')) {
				header.removeClass('header--menu-open');
				menuBtnIcon.removeClass('icon-close').addClass('icon-menu');
				$('.search__field').attr('placeholder', 'Search');
				//   $('.header__nav-search').removeClass('is-active');
				//   $('.header__nav-search').hide();
				//   toggleMenuBtn.removeClass('closed');
				//$('.services-bar').hide();
				// $('body').css('overflow', 'visible');
				//$(this).closest('.header').removeClass('js-mobile-nav-active');
				$('body').removeClass('overflow-hidden');
				$('.nav-mobile').fadeOut(300);
				// event.stopPropagation();
			} else {
				header.addClass('header--menu-open');
				header.removeClass('header--services-open');
				$('.search__field').attr('placeholder', 'Search');
				//   $('.header__nav-search').show();
				//   $('.header__nav-search').addClass('is-active');
				// $('.services-bar').hide();
				menuBtnIcon.removeClass('icon-menu').addClass('icon-close');
				servicesBtnIcon.removeClass('icon-close').addClass('icon-basket');
				//    toggleMenuBtn.addClass('closed');
				//$('body').css('overflow', 'hidden');
				//$(this).closest('.header').addClass('js-mobile-nav-active');
				$('body').addClass('overflow-hidden');
				$('.nav-mobile').fadeIn(300);
				//  event.stopPropagation();
			}
		});

		toggleServicesBtn.click(function (event) {
			if (header.hasClass('header--services-open')) {
				header.removeClass('header--services-open');
				header.removeClass('header--menu-open');
				servicesBtnIcon.removeClass('icon-close').addClass('icon-basket');
				//   header.addClass('header--services-open');
				//    btnIcon.removeClass('icon-close').addClass('icon-menu');
				//   $('.header__nav-search').removeClass('is-active');
				//   $('.header__nav-search').hide();
				//   toggleMenuBtn.removeClass('closed');
				//$('.services-bar').hide();
				//$('body').css('overflow', 'visible');
				//  $(this).closest('.header').removeClass('js-mobile-nav-active');
				$('body').removeClass('overflow-hidden');
				// event.stopPropagation();
			} else {
				header.removeClass('header--menu-open');
				$('.nav-mobile').fadeOut(300);
				header.addClass('header--services-open');
				//   $('.header__nav-search').show();
				//   $('.header__nav-search').addClass('is-active');
				// $('.services-bar').hide();
				menuBtnIcon.removeClass('icon-close').addClass('icon-menu');
				servicesBtnIcon.addClass('icon-close').removeClass('icon-basket');
				//    toggleMenuBtn.addClass('closed');
				// $('body').css('overflow', 'hidden');
				//  $(this).closest('.header').removeClass('js-mobile-nav-active');
				$('body').addClass('overflow-hidden');
				//  event.stopPropagation();
			}
		});

		/*    toggleServicesBtn.click(function(event) {
                  if (header.hasClass('header--expanded')) {
                      header.removeClass('header--expanded');
                      toggleServicesBtn.removeClass('closed');
                      $('.header__nav-search').removeClass('is-active');
                      $('.header__nav-search').hide();
                      $('.services-bar').hide();
                      $('body').css('overflow', 'visible');
                      event.stopPropagation();
                  } else {
                      header.addClass('header--expanded');
                      $('.services-bar').show();
                      btnIcon.removeClass('icon-close').addClass('icon-menu');
                      toggleServicesBtn.addClass('closed');
                      $('body').css('overflow', 'hidden');
                      event.stopPropagation();
                  }
              });
              */
		/*
                  toggleServicesBtn.click(function(event) {
                      if ($('.header__nav-search').hasClass('is-active')) {
                          $('.header__nav-search').hide();
                          $('.services-bar').show();
                      } else {
                          $('.services-bar').hide();
                      }
                  });
          */
		// New Mobile Menu Added
		$('.nav-mobile__top-level li').click(function (e) {
			// console.log(e.target);
			$(this).siblings().find('.nav-mobile__sub-wrap').filter(':visible').slideUp();
			$(this)
				.find('.nav-mobile__sub-wrap')
				.slideToggle(function () {
					var sliding = $(this);

					// if (sliding.is(':visible')) {
					//     // console.log('Finished down');
					//     var position = sliding.parent().position().top + $('.nav-mobile').scrollTop() - $('.header__hamburger').outerHeight() - $('.header__nav-search').outerHeight() -1;
					//     console.log(position);
					//     $('.nav-mobile').animate({
					//         scrollTop: position
					//     }, 'fast');
					// } else {
					//     // console.log('Finished up');
					// }
				});
		});
	}

	function initSearchMobile() {
		var searchForm = $('.search');
		var animatedLine = $('.search__line');
		$(function () {
			searchForm.click(function (e) {
				animatedLine.addClass('active');
				$('.search__icon').css('opacity', '1');
				e.stopPropagation();
			});
			$(document).click(function (e) {
				if ($(e.target).is('.search') === false) {
					animatedLine.removeClass('active');
					$('.search__icon').css('opacity', '.4');
				}
			});
		});
	}
	function initDatePicker() {
		$('#datepicker').datepicker({
			dateFormat: 'dd-mm-yy',
			beforeShow: function beforeShow() {
				$('body').append("<div class='ui-datepicker-bg'></div>");
			},
			onClose: function onClose() {
				$('div').remove('.ui-datepicker-bg');
			},
		});
		var excludeList = ['entryDateParking', 'exitDateParking', 'entryDateParkingEdit', 'exitDateParkingEdit'];
		// Moved this global datepicker init here as it is being used in way more than just ADT
		$('.datepicker')
			.not('.datepicker-ignore')
			.each(function () {
				var datePickerElIds = $(this).attr('id');
				if (excludeList.includes(datePickerElIds)) return;
				$(this).datepicker({
					dateFormat: 'dd/mm/yy',
					minDate: $(this).data('minDate') ? $(this).data('minDate') : 0,
					changeMonth: $(this).data('changeMonth') ? $(this).data('changeMonth') : false,
					changeYear: $(this).data('changeYear') ? $(this).data('changeYear') : false,
				});
			});
	}

	// function initParkingDatepickers() {
	// $("#entryDate, #exitDate, #loungeEntryDate, #entryDateMobile, #exitDateMobile, #loungeEntryDateMobile").datepicker({
	//  dateFormat: 'dd-mm-yy'

	/*   beforeShow: function() {
            $("body").append("<div class='ui-datepicker-bg'></div>");
        },
        onClose: function() {
            $("div").remove(".ui-datepicker-bg");
        }*/
	//  });
	// }

	function initSelectBoxes() {
		$('.selectbox').select2({
			minimumResultsForSearch: Infinity,
			width: '100%',
		});
		$('.selectbox-time').select2({
			minimumResultsForSearch: Infinity,
			width: '100%',
			placeholder: 'Time',
			dropdownPosition: 'below',
		});
	}
	function initADTSelectBoxes() {
		$('.customSelect--arrows, .customSelect--dates, .customSelect--time, .custom-select, .customSelect--dropdown').customSelect();

		// Datepicker init moved from here to 'initdatepickers' as it is being used globally and not just for ADT
		// ---

		/*$(".datepicker").not(".datepicker-ignore").datepicker({
              dateFormat: "dd/mm/yy",
              minDate: 0,
              changeMonth: false,
              changeYear: false
          });*/

		var startDate = new Date();
		startDate.setDate(startDate.getDate() + 1);
		$('.tomorrow').datepicker('setDate', startDate);
		$('.ui-datepicker').on('click', function (event) {
			event.stopPropagation();
		});
	}
	/*
         function initMoreLessBookingTabs() {
              $('#booking-module-more').click(function(e) {
                 e.preventDefault();
                 $('.booking-module__tabs-inview').hide();
                 $('.booking-module__tabs-more').show();
                 $('.booking-module__tabs-more .hotel').addClass('active');
                 $('#book-flights-and-hotels').show();
              });
              $('#booking-module-less').click(function(e) {
                 e.preventDefault();
                 $('.booking-module__tabs-more').hide();
                 $('.booking-module__tabs-inview').show();
                 $('.booking-module__tabs-more a').removeClass('active');
                 $('#book-flights-and-hotels').hide();
                 $('.booking-module__tabs-inview .parking').addClass('active');
                 $('#book-flights-and-hotels').show();
              });
          }
     */
	function initSearchDesktop() {
		var searchIcon = $('.search__desktop-icon');
		var closeIcon = $('.search__desktop-close');
		var searchBar = $('.search');
		searchIcon.click(function () {
			$('.header').addClass('search-active');
			$('.search__field').attr('placeholder', 'Search for flight numbers, destinations, airport services or other keywords');
			searchBar.show();
		});
		closeIcon.click(function () {
			searchBar.hide();
			$('.header').removeClass('search-active');
		});
	}
	function initSearchSite() {
		var searchBtn = $('#search-the-site');
		searchBtn.click(function (e) {
			e.preventDefault();
			$('.header').addClass('search-active');
			$('.search__field').attr('placeholder', 'Search for flight numbers, destinations, airport services or other keywords');
			$('.search').show();
			document.querySelector('.header').scrollIntoView({
				behavior: 'smooth',
			});
		});
	}
	function initSearchFlight() {
		// Change to only load in the data for the search the first time a bar is clicked, as otherwise it is never needed
		$('[data-search-flight-field]').click(function () {
			if ($(this).data('ui-autocomplete') === undefined) {
				var searchFields = $('[data-search-flight-field]');
				if (searchFields.length) {
					// Get the data only once
					var jsonUrlElement = searchFields.filter('[data-root]').first(); // Take the URL from the first matched element on the page
					var jsonUrl = jsonUrlElement.data('root') ? jsonUrlElement.data('root') : '/assets/base/js/data/flightsjson.json';
					$.getJSON(jsonUrl, function (flightList) {
						searchFields.each(function () {
							bindSearchFlight($(this), flightList, false, false);
						});
					});
				}
			}
		});
	}
	function initSearchFlightTimetable() {
		// Change to only load in the data for the search the first time a bar is clicked, as otherwise it is never needed
		$('[data-search-flight-field-timetable]').click(function () {
			var dropdownClassname = $(this).attr('data-dropdown-classname') || false;
			if ($(this).data('ui-autocomplete') === undefined) {
				var searchFields = $('[data-search-flight-field-timetable]');
				if (searchFields.length) {
					// Get the data only once
					var jsonUrlElement = searchFields.filter('[data-root]').first(); // Take the URL from the first matched element on the page
					var jsonUrl = jsonUrlElement.data('root') ? jsonUrlElement.data('root') : '/assets/base/js/data/flightsjsontimetable.json';
					$.getJSON(jsonUrl, function (flightList) {
						searchFields.each(function () {
							bindSearchFlight($(this), flightList, true, dropdownClassname);
						});
					});
				}
			}
		});
	}
	function bindSearchFlight(searchField, flightList, timetable, dropdownClassname) {
		var isParkingCheckOutTimeTable = !!dropdownClassname;
		var searchBtn = searchField.closest('form').find('[data-search-flight-btn]'); // Find nearest button
		var searchPage = searchField.data('searchPage');
		var dropdownList = timetable ? buildFlightDataTimetable(searchField, flightList) : buildFlightData(searchField, flightList);
		var returnKey = false;
		var resultCount = 0;
		var noResults = true;
		searchBtn.click(function (e) {
			location.href = searchPage + '?search=' + searchField.val();
		});
		searchField
			.keydown(function (e) {
				if (e.keyCode == 13) {
					if (resultCount === 0) {
						// No results possible, so redirect here as the main ui event won't fire
						e.preventDefault(); // Needed or redirect fails
						location.href = searchPage + '?search=' + searchField.val();
					} else {
						returnKey = true;
					}
				}
			})
			.autocomplete({
				minLength: 0,
				autoFocus: true,
				//  source: dropdownList, // uses the above feed from the items pulled in
				source: function source(request, response) {
					var results = $.ui.autocomplete.filter(dropdownList, request.term);
					var sliceSize = timetable ? 60 : 3;
					var resultSlice = results.slice(0, sliceSize);
					if (isParkingCheckOutTimeTable) {
						var parkingEntryDate = searchField.attr('data-parking-entrydate');
						var departingFilteredResults = dropdownList.filter(function (item) {
							return item.flightTypeOriginal === 'Departure';
						});
						var sameDayFilteredResults = departingFilteredResults.filter(function (item) {
							return validateSameDay(new Date(item.flightDate), new Date(parkingEntryDate));
						});
						var matchCityOnlyResults = sameDayFilteredResults.filter(function (item) {
							var lowerCaseTerm = request.term.toLowerCase();
							return item.flightArrivalCity.toLowerCase().startsWith(lowerCaseTerm) || item.flightNumber.toLowerCase().startsWith(lowerCaseTerm);
						});
						resultSlice = matchCityOnlyResults.slice(0, sliceSize);
						resultSlice.push({
							flightDestination: "I don't see my flight",
							flightNumber: '',
							flightTime: '',
						});
					}
					response(resultSlice);
				},
				open: function open(event, ui) {
					$('.ui-autocomplete').append(
						"<div class='search-flight-result__more'><a href='" + searchPage + '?search=' + searchField.val() + "' class='btn " + (searchField.data('button-class') || 'btn--secondary') + "'>All results</a></div>"
					); // this adds the extra html at the end

					if (isParkingCheckOutTimeTable) {
						$('.ui-autocomplete').addClass(dropdownClassname);
					}
				},
				response: function response(event, ui) {
					resultCount = ui.content.length;
				},
				focus: function focus(event, ui) {
					return false;
				},
				select: function select(e, selected) {
					var inputVal = selected.item.flightNumber;
					if (isParkingCheckOutTimeTable) {
						inputVal = [selected.item.flightDestination, selected.item.flightNumber, selected.item.flightTime].filter(Boolean).join(', ');
						searchField.attr('data-flightnumber', selected.item.flightNumber || selected.item.flightDestination);
						var hiddenFieldName = searchField.attr('data-hiddenFieldName');
						$('#' + hiddenFieldName).val(selected.item.flightNumber || selected.item.flightDestination);
					}
					searchField.val(inputVal);
					searchField.data('flight-date', selected.item.flightDate);
					searchField.trigger('change');
					if (returnKey) {
						// Returnkey behaviour
						if (!timetable) {
							if (resultCount === 1) {
								location.href = selected.item.flightLink;
							} else {
								location.href = searchPage + '?search=' + searchField.val();
							}
						}
					} else if (!timetable) {
						// Click behaviour
						location.href = selected.item.flightLink;
					}
					e.preventDefault();
				},
			})
			.autocomplete('instance')._renderItem = function (ul, item) {
			// this builds the autocomplete content to be shown, using the fields above
			return $("<li class='search-flight-result'>")
				.append(
					"<a href='" +
						item.flightLink +
						"' title=' Find out more about " +
						item.flightDestination +
						'-' +
						item.flightNumber +
						"' >" +
						"<div class='search-flight-result__date'>" +
						item.flightType +
						'</div>' +
						"<div class='search-flight-result__time'>" +
						item.flightTime +
						'</div>' +
						"<div class='search-flight-result__airline'>" +
						"<img src='" +
						item.flightAirline +
						"'>" +
						'</div>' +
						"<div class='search-flight-result__number'>" +
						item.flightNumber +
						'</div>' +
						"<div class='search-flight-result__destination'>" +
						item.flightDestination +
						'</div>' +
						"<div  class='search-flight-result__icon'><i class='icon-arrow'></i></div>" +
						'</a>'
				)
				.appendTo(ul);
		};

		// Add on extra settings, mostly for mobile modal version
		var targetElement = searchField.closest('form').find('[data-search-flight-target-element]');
		if (targetElement.length) {
			//console.log("Found target", targetElement);
			searchField.autocomplete('option', 'appendTo', targetElement);
		}
		if (searchField.data('extra-classes')) {
			//console.log("Found extra classes" , searchField.data("extra-classes"));
			searchField.autocomplete('option', 'classes.ui-autocomplete', searchField.data('extra-classes'));
		}
		if (isParkingCheckOutTimeTable) {
			jQuery.ui.autocomplete.prototype._resizeMenu = function isParkingCheckOutTimeTable() {
				var ul = this.menu.element;
				ul.outerWidth(this.element.outerWidth());
			};
		}
	}
	function buildFlightData(searchField, flightList) {
		var dropdownList = [];
		flightList.arrivals.concat(flightList.departures).forEach(function (item) {
			var newDropdownItem = {
				value:
					item.flightNumber +
					' ' +
					item.location +
					' ' +
					item.airlineName +
					(item.intermediateSteps
						? item.intermediateSteps
								.map(function (step) {
									return step.location;
								})
								.join(' ')
						: ''),
				flightType: item.arriving ? 'Arrival' : 'Departure',
				flightNumber: item.flightNumber,
				flightDate: new Date(item.aggregatedDateTime).getDate() + '/' + (new Date(item.aggregatedDateTime).getMonth() + 1) + '/' + new Date(item.aggregatedDateTime).getFullYear(),
				flightTime: ('0' + new Date(item.aggregatedDateTime).getHours()).slice(-2) + ':' + ('0' + new Date(item.aggregatedDateTime).getMinutes()).slice(-2),
				flightDestination: item.location,
				flightAirline: item.airlineLogo,
				flightLink: item.flightDetailsPageUrl || searchField.data('detailPage') + '?flightCode=' + item.flightNumber + '&flightDateTime=' + item.scheduledDateTime,
			};
			dropdownList.push(newDropdownItem);
		});
		return dropdownList;
	}
	function buildFlightDataTimetable(searchField, flightList) {
		var dropdownList = [];
		flightList.forEach(function (item) {
			item.flightDates.forEach(function (flightDate) {
				var flightDateFormatted = formatDateUk(new Date(flightDate));
				var iataCode = searchField.data('iataCode');
				var isArrival = item.arrivalAirportCode === iataCode;
				var departureAirportName = item.departureAirportName || item.arrivalAirportName; // departureAirportName doesnt exist in JSON so this is a fallback
				var destinationName = isArrival ? departureAirportName : item.arrivalAirportName;
				var newDropdownItem = {
					value: item.flightNumber + ' ' + destinationName + ' ' + item.carrierName,
					flightType: flightDateFormatted,
					flightTypeOriginal: isArrival ? 'Arrival' : 'Departure',
					flightArrivalCity: item.arrivalCityName,
					flightNumber: item.flightNumber,
					flightDate: flightDate,
					flightTime: item.departureTime,
					flightDestination: destinationName,
					flightAirline: item.carrierLogo,
					flightLink: '#',
				};
				dropdownList.push(newDropdownItem);
			});
		});
		return dropdownList;
	}
	function initTimeline() {
		$('#timeline').accordion({
			heightStyle: 'content',
			collapsible: true,
			activate: function activate(event, ui) {
				if (ui.newHeader.length) {
					var headerTop = ui.newHeader.offset().top;
					$('html, body').animate(
						{
							scrollTop: headerTop - 50,
						},
						300
					);
				}
			},
			classes: {
				'ui-accordion': 'timeline',
				'ui-accordion-header': 'timeline__heading',
				'ui-accordion-content': 'timeline__content',
			},
		});
	}
	function initAccordion() {
		$('.accordion').accordion({
			heightStyle: 'content',
			collapsible: true,
			activate: function activate(event, ui) {
				if (ui.newHeader.length) {
					var headerTop = ui.newHeader.offset().top;
					$('html, body').animate(
						{
							scrollTop: headerTop - 50,
						},
						300
					);
				}
			},
			classes: {
				'ui-accordion': 'accordion',
				'ui-accordion-header': 'accordion__heading',
				'ui-accordion-content': 'accordion__content',
			},
		});
		$('.accordion-alt').accordion({
			heightStyle: 'content',
			collapsible: true,
			active: false,
			activate: function activate(event, ui) {
				if (ui.newHeader.length) {
					var headerTop = ui.newHeader.offset().top;
					$('html, body').animate(
						{
							scrollTop: headerTop - 50,
						},
						300
					);
				}
			},
			classes: {
				'ui-accordion': 'accordion',
				'ui-accordion-header': 'accordion__heading',
				'ui-accordion-content': 'accordion__content',
			},
		});
		$('.faq-accordion').accordion({
			heightStyle: 'content',
			collapsible: true,
			classes: {
				'ui-accordion': 'faq-accordion',
				'ui-accordion-header': 'faq-accordion__heading',
				'ui-accordion-content': 'faq-accordion__content',
			},
		});
	}
	function initTopBrands() {
		var $grid = $('.top-brands').masonry({
			// options
			itemSelector: '.top-brands-item',
			gutter: '.grid-gutter',
		});
		// layout Masonry after each image loads
		$grid.imagesLoaded().progress(function () {
			$grid.masonry('layout');
		});
	}
	function initNewsletterForm() {
		// Sets a known check
		$('#newsletterTsCheck').val(Math.floor(Date.now() / 1000));
		$('#newsletterTsResponse').val($('#newsletterTsCheck').val() * 2 - 10);
		$('#newsletter-form').submit(function () {
			var submittedForm = $(this);
			if (!submittedForm.find('#newsletterTerms').is(':checked')) {
				submittedForm.find('#newsletter-form-error').text('You must accept the terms and conditions.');
				submittedForm.find('#newsletter-form-error').show();
			} else {
				if ($(this).valid() && $(this).hasClass('form-submitted') !== true) {
					$(this).addClass('form-submitted');
					var data = JSON.stringify(submittedForm.serializeJSON());
					//alert("valid");
					$.ajax({
						url: '/umbraco/api/FormApi/SendNewsletterForm',
						data: data,
						contentType: 'application/json; charset=utf-8',
						type: 'POST',
					})
						.done(function (response) {
							if (response.valid === true) {
								if (submittedForm.data('thanksPage') !== '') {
									window.location.replace(submittedForm.data('thanksPage'));
								} else {
									submittedForm.find('#newsletter-form-error').text('Thank you for your submission.');
									submittedForm.find('#newsletter-form-error').show();
									submittedForm.removeClass('form-submitted');
								}
							} else {
								submittedForm.find('#newsletter-form-error').text('There was a problem sending your form through just now.');
								submittedForm.find('#newsletter-form-error').show();
								submittedForm.removeClass('form-submitted');
							}
						})
						.fail(function () {
							submittedForm.find('#newsletter-form-error').text('There was a problem with sending your form through just now.');
							submittedForm.find('#newsletter-form-error').show();
							submittedForm.removeClass('form-submitted');
						});
				}
			}
		});
	}
	function initFlexibleForm() {
		$('[data-flexible-form-wrapper]').each(function () {
			// Sets a known check
			var submittedForm = $(this);
			var ts = Math.floor(Date.now() / 1000);
			submittedForm.find("[data-field='tsCheck']").val(ts);
			submittedForm.find("[data-field='tsResponse']").val(ts * 2 - 10);
			submittedForm.submit(function (e) {
				if ($(this).valid() && $(this).hasClass('form-submitted') !== true) {
					$(this).addClass('form-submitted');
					var errorField = submittedForm.find("[data-field='error']");
					var serializedForm = submittedForm.serializeJSON();
					var fieldNameArray = Object.values(serializedForm.fieldName);
					var fieldValueArray = Object.values(serializedForm.fieldValue);
					var fieldMappingArray = Object.values(serializedForm.fieldMapping);
					serializedForm.fieldName = fieldNameArray;
					serializedForm.fieldValue = fieldValueArray;
					serializedForm.fieldMapping = fieldMappingArray;
					var data = JSON.stringify(serializedForm);
					//alert("valid");
					$.ajax({
						url: '/umbraco/api/FormApi/SendFlexibleForm',
						data: data,
						contentType: 'application/json; charset=utf-8',
						type: 'POST',
					})
						.done(function (response) {
							if (response.valid === true) {
								if (submittedForm.data('thanksPage') !== '') {
									window.location.replace(submittedForm.data('thanksPage'));
								} else {
									errorField.text('Thank you for your submission.');
									errorField.show();
									submittedForm.removeClass('form-submitted');
								}
							} else {
								errorField.text('There was a problem sending your form through just now.');
								errorField.show();
								submittedForm.removeClass('form-submitted');
							}
						})
						.fail(function () {
							errorField.text('There was a problem with sending your form through just now.');
							errorField.show();
							submittedForm.removeClass('form-submitted');
						});
				}
			});
		});
	}
	function initContactForm() {
		// Sets a known check
		$('#tsCheck').val(Math.floor(Date.now() / 1000));
		$('#tsResponse').val($('#tsCheck').val() * 2 - 10);
		$('#contactCategory').change(function () {
			var category = $(this).val();
			$('#contactSubcategory').empty();
			var subcategories = $(this).children('option:selected').data('subcategories').split(',');
			subcategories.forEach(function (option) {
				console.log(option);
				$('#contactSubcategory').append("<option value='" + option + "'>" + option + '</option>');
			});
		});
		$('#contact-form').submit(function () {
			if ($(this).valid() && $(this).hasClass('form-submitted') !== true) {
				$(this).addClass('form-submitted');
				var submittedForm = $(this);
				var data = JSON.stringify(submittedForm.serializeJSON());
				//alert("valid");
				$.ajax({
					url: '/umbraco/api/FormApi/SendContactForm',
					data: data,
					contentType: 'application/json; charset=utf-8',
					type: 'POST',
				})
					.done(function (response) {
						if (response.valid === true) {
							if (submittedForm.data('thanksPage') !== '') {
								window.location.replace(submittedForm.data('thanksPage'));
							} else {
								submittedForm.find('#form-error').text('Thank you for your submission.');
								submittedForm.find('#form-error').show();
								submittedForm.removeClass('form-submitted');
							}
						} else {
							submittedForm.find('#form-error').text('There was a problem sending your form through just now.');
							submittedForm.find('#form-error').show();
							submittedForm.removeClass('form-submitted');
						}
					})
					.fail(function () {
						submittedForm.find('#form-error').text('There was a problem with sending your form through just now.');
						submittedForm.find('#form-error').show();
						submittedForm.removeClass('form-submitted');
					});
			}
		});
	}
	function initValidation() {
		// Define a custom template for our error html. By default the plugin adds <label class="error">xyz</label>

		$.validator.setDefaults({
			errorPlacement: function errorPlacement(error, element) {
				error.addClass('form__alert');

				// Special handling for the select dropdown too as normally it is placed directly after the erroring element
				if (element.is('select')) {
					error.insertAfter(element.next('span'));
				} else {
					error.insertAfter(element);
				}
			},
		});

		// Tell jquery.validate to fire on any form tag we have 'data-validate=true' on
		$("[data-validate='true']").validate();
	}
	function initAirportMaps() {
		$('.airport-map').airportMap();
	}
	function initDestinationMapsFilters() {
		$('#filterDay a').click(function (e) {
			e.preventDefault();
			$('#filterDay a').removeClass('deselected');
			console.log('Filter click');
			var titleTag = $('.routes-filter').children('h2');
			//$(this).toggleClass("selected");
			if ($(this).hasClass('selected')) {
				$(this).removeClass('selected');
				$(this).addClass('deselected');
			} else {
				$(this).addClass('selected');
			}
			var selectedDays = $('#filterDay a.selected');
			titleTag.text(selectedDays.length ? titleTag.data('filtered').replace('[day]', selectedDays.data('value')) : titleTag.data('default'));
			$('#filterDay a').not(this).removeClass('selected');
			//debugger;
			//console.log("Changed");
			initDestinationMaps();
		});
		$('#filterDestination').change(function () {
			if ($(this).val().indexOf('/') > -1) {
				location.href = $(this).val();
			}
		});
	}
	function initDestinationMaps() {
		// Google Maps

		var clickedMarker = null;
		var openInfoBubbles = [];
		var map;
		var map_canvas = $('#destination_gmap');
		if (map_canvas.length) {
			var airportLat = map_canvas.data('latitude');
			var airportLong = map_canvas.data('longitude');
			var airportLatLng = new google.maps.LatLng(airportLat, airportLong);
			var airportMapStyling = [
				{
					featureType: 'administrative',
					elementType: 'geometry',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'administrative.country',
					stylers: [
						{
							visibility: 'on',
						},
					],
				},
				{
					featureType: 'administrative.land_parcel',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'administrative.neighborhood',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'landscape.natural',
					elementType: 'geometry.fill',
					stylers: [
						{
							color: '#e1e1e1',
						},
					],
				},
				{
					featureType: 'poi',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'poi',
					elementType: 'labels.text',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'labels',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'transit',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'water',
					elementType: 'geometry',
					stylers: [
						{
							visibility: 'simplified',
						},
					],
				},
				{
					featureType: 'water',
					elementType: 'labels.text',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
			];
			var mapCities = [];
			var filterDay = $('#filterDay a.selected').length ? $('#filterDay a.selected').data('value') : '';
			var jsonUrl = map_canvas.data('root') ? map_canvas.data('root') + '?dayOfWeek=' + filterDay : '/assets/base/js/data/destinations.json';
			$.getJSON(jsonUrl, function (response) {
				mapCities = response;
				//LatLng(mapCities[0].Lat, mapCities[0].Lon);

				var map_options = {
					scrollwheel: false,
					center: airportLatLng,
					zoom: 5,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					styles: airportMapStyling,
					streetViewControl: false,
					mapTypeControl: false,
				};
				map = new google.maps.Map(map_canvas[0], map_options);
				var marker = new RichMarker({
					position: airportLatLng,
					map: map,
					content: '<div class="routes__map-pointer airport"></div>',
					shadow: '0',
				});
				var bounds = new google.maps.LatLngBounds();
				bounds.extend(airportLatLng);

				//debugger;
				for (var i = 0; i < mapCities.length; i++) {
					marker = new RichMarker({
						position: new google.maps.LatLng(mapCities[i].latitude, mapCities[i].longitude),
						map: map,
						content: '<div class="routes__map-pointer"></div>',
						shadow: '0',
						imageUrl: mapCities[i].imageUrl,
						url: mapCities[i].url,
						countryName: mapCities[i].countryName,
						cityName: mapCities[i].cityName,
					});
					bounds.extend(new google.maps.LatLng(mapCities[i].latitude, mapCities[i].longitude));

					//console.log("calling events");
					google.maps.event.addListener(marker, 'click', mapTooltipClick);
					google.maps.event.addListener(marker, 'mouseover', mapTooltipMouseover);
					google.maps.event.addListener(marker, 'mouseout', mapTooltipMouseout);
					google.maps.event.addListener(map, 'zoom_changed', mapZoomChanged);
				}

				// Only try and fit the map to the bounds if you've filtered it
				if (filterDay !== ' ' && mapCities.length > 0) {
					map.fitBounds(bounds);
				}

				// Finally populate the dropdown (mobile) and list of a tags with the same list

				$('#filterDestination').empty();
				$('#listDestination').empty();
				$('#filterDestination').append("<option selected='selected'>-- Select Destination --</option>");
				$('#listDestination').append('<h2>Take me to…</h2>');
				for (i = 0; i < mapCities.length; i++) {
					$('#filterDestination').append("<option value='" + mapCities[i].url + "'>" + mapCities[i].cityName + '</option>');
					$('#listDestination').append("<a href='" + mapCities[i].url + "' class='btn btn--secondary-alt' title='" + mapCities[i].cityName + "'>" + mapCities[i].cityName + '</a>');
				}
				if ($(window).width() < 768) {
					$('#listDestination').fadeOut('fast');
					$('#listDestination').fadeIn('fast', function () {
						$('#listDestination').css('display', '');
					});
				}
			});
		}

		// Nested map function. Do not add new functions here
		function mapZoomChanged() {
			var smallerZoomLevel = 5;
			$('.routes__map-pointer').removeClass('zoom');
			if (map.getZoom() <= smallerZoomLevel) {
				$('.routes__map-pointer').addClass('zoom');
			} else {
				$('.routes__map-pointer').removeClass('zoom');
			}

			//console.log(map.getZoom());
		}

		// Nested map function. Do not add new functions here
		function mapTooltipClick() {
			clickedMarker = clickedMarker == this ? null : this;
			if (typeof this.infoBubble == 'undefined') {
				this.infoBubble = new InfoBubble({
					content: getMapTooltipTemplate()
						.replace(/\{imageUrl}/g, this.imageUrl)
						.replace(/\{url}/g, this.url)
						.replace(/\{countryName}/g, this.countryName)
						.replace(/\{cityName}/g, this.cityName),
					disableAutoPan: true,
					map: map,
					position: new google.maps.LatLng(this.position.lat(), this.position.lng()),
					shadowStyle: 0,
					padding: 0,
					backgroundColor: '#fff',
					borderRadius: 4,
					arrowSize: 0,
					borderWidth: 0,
					borderColor: '#2c2c2c',
					minWidth: 250,
					hideCloseButton: false,
					disableAnimation: true,
					arrowPosition: 0,
					backgroundClassName: 'map-tooltip-bg',
					arrowStyle: 2,
				});
				$(this.infoBubble.getPanes().floatPane).css('margin', '120px 0 0 15px');
				$(this.infoBubble.getPanes().floatShadow).css('margin', '120px 0 0 15px');
			}
			while (openInfoBubbles.length > 0) {
				openInfoBubbles.pop().close();
			}
			if (clickedMarker !== null) {
				openInfoBubbles.push(this.infoBubble);
				this.infoBubble.open();
			}
		}

		// Nested map function. Do not add new functions here
		function mapTooltipMouseover() {
			if (typeof this.flightPathLine == 'undefined') {
				this.flightPathLine = new google.maps.Polyline({
					path: [new google.maps.LatLng(this.position.lat(), this.position.lng()), airportLatLng],
					geodesic: true,
					strokeColor: '#ffffff',
					strokeOpacity: 1.0,
					strokeWeight: 3,
				});
			}
			if (clickedMarker !== null) {
				clickedMarker.flightPathLine.setMap(null);
			}
			this.flightPathLine.setMap(map);
		}

		// Nested map function. Do not add new functions here
		function mapTooltipMouseout() {
			if (this == clickedMarker) {
				return;
			}
			this.flightPathLine.setMap(null);
			if (clickedMarker !== null) {
				clickedMarker.flightPathLine.setMap(map);
			}
		}

		// Nested map function. Do not add new functions here
		function getMapTooltipTemplate() {
			var template =
				'<div>' +
				'<a href="{url}" title="{cityName}" class="item item--destination">' +
				'<div class="item__img" style="background-image: url({imageUrl}?width=500);"></div>' +
				'<h3 class="big-text">{cityName}</h3>' +
				'<p>{countryName}</p>' +
				'<span class="btn btn--keyline btn--small">View the information</span>' +
				'</a>' +
				'</div>';
			return template;
		}
	}
	function initTimelineTabs() {
		$("[data-role='tabbed']").easyResponsiveTabs({
			type: 'default',
			//Types: default, vertical, accordion
			width: 'auto',
			//auto or any width like 600px
			fit: true, // 100% fit in a container
		});

		$('.sticky-timeline-flight')
			.stick_in_parent()
			.on('sticky_kit:stick', function (e) {
				//  console.log("has stuck!", e.target);
				$(this).addClass('condensed');
			})
			.on('sticky_kit:unstick', function (e) {
				//   console.log("has unstuck!", e.target);
				$(this).removeClass('condensed');
			});
	}
	function initSmoothLink() {
		$('a[data-smooth-link]').click(function () {
			var linkId = $(this).attr('href').replace('#', '');
			var linkElement = $('#' + linkId + ":visible:first, [name='" + linkId + "']:visible:first");
			var headerTop = linkElement.offset().top;
			var additionalOffset = 0;
			if ($(this).data('offset-element')) {
				var offsetElement = $(this).data('offset-element');
				additionalOffset = $(offsetElement + ':visible:first').height();
			}
			$('html, body').animate(
				{
					scrollTop: headerTop - 50 - additionalOffset,
				},
				300
			);
		});
	}
	function initDestinationInspirationFilters() {
		var url = window.location.href;
		if (url.includes('?cat=')) {
			var tagId = url.split('?cat=')[1];
			$("[data-tag-id='" + tagId + "']").addClass('selected');
		}
		$('[data-destination-filter] > li > a').click(function (e) {
			e.preventDefault();
			var tagId = $(this).data('tag-id');
			var url = window.location.href;
			window.location = url.split('?')[0] + '?cat=' + tagId;
		});
	}
	function initNewsListingFilters() {
		var url = window.location.href;
		if (url.includes('?category=')) {
			var categoryId = url.split('?category=')[1];
			$("[data-category-id='" + categoryId + "']").addClass('selected');
		}
		$('[data-news-listing-category-filter] > li > a').click(function (e) {
			e.preventDefault();
			var categoryId = $(this).data('category-id');
			var url = window.location.href;
			window.location = url.split('?')[0] + '?category=' + categoryId;
		});
	}
	function initAirlineFilters() {
		$('[data-airline-filter]').submit(function (e) {
			e.preventDefault();

			// Work out the hidden/shown blocks in a 'mirror' then copy them, due to nth styling issues otherwise
			var mirror = $('.airlines').not('[data-airline-holder]');
			var holder = $('[data-airline-holder].airlines');
			var noResults = $('[data-airline-noresults]');
			mirror.children('.airlines__col').hide();
			var searchTerm = $(this).children('input').val();
			var filteredResults = mirror.children('.airlines__col').filter(function () {
				return $(this).data('airline-name').toLowerCase().indexOf(searchTerm) > -1;
			});
			filteredResults.show();
			mirror.show();
			var visibleAirlines = mirror.children('.airlines__col:visible');
			if (visibleAirlines.length > 0) {
				holder.empty();
				holder.append(visibleAirlines.clone());
				mirror.hide();
				holder.show();
				noResults.hide();
			} else {
				mirror.hide();
				holder.hide();
				noResults.show();
			}
		});
	}
	function initRetailerFilters() {
		if ('[data-filter-retailer]'.length) {
			// Filter Events

			$('[data-filter-type]').click(function (e) {
				e.preventDefault();
				$('[data-pagination]').data('pagination-current', 1);
				$('[data-filter-type').removeClass('active');
				$(this).addClass('active');
				filterRetailers();
			});
			$('[data-filter-location], [data-filter-brand]').change(function (e) {
				e.preventDefault();
				$('[data-pagination]').data('pagination-current', 1);
				$('[data-brand-popup-trigger] > span').text($('[data-filter-brand] option:selected').text());
				filterRetailers();
			});

			// Open/close desktop brand list
			$('[data-brand-popup-trigger]').click(function (e) {
				e.preventDefault();
				$('[data-brand-popup]').toggle();
				$(this).toggleClass('brand-filter-btn--open');
			});
			$('[data-filter-brand-value]').click(function (e) {
				e.preventDefault();
				$('[data-filter-brand]').val($(this).data('filter-brand-value')).change();
				$('[data-brand-popup]').toggle();
				$('[data-brand-popup-trigger]').removeClass('brand-filter-btn--open');
			});
			buildPagination($('[data-retailer-mirror]').children('.shop-dine__col:visible').length);
			filterRetailers();
		}
		function filterRetailers() {
			var mirror = $('[data-retailer-mirror]');
			var holder = $('[data-retailer-holder]');
			var noResults = $('[data-retailer-noresults]');
			mirror.children('.shop-dine__col').hide();
			var filterType = $('[data-filter-type].active').data('filter-type');
			var filterBrand = $('[data-filter-brand]').val();
			var filterLocation = $('[data-filter-location]').val();
			var filteredResults = mirror.children('.shop-dine__col').filter(function () {
				return (
					$(this).data('type').toLowerCase().indexOf(filterType) > -1 &&
					$(this).attr('data-brands').toLowerCase().indexOf(filterBrand) > -1 &&
					(filterLocation === '' || (filterLocation.toLowerCase() === 'before' && $(this).data('before-security') === 'True') || (filterLocation.toLowerCase() === 'after' && $(this).data('after-security') === 'True'))
				);
			});
			filteredResults.show();
			mirror.show();
			var visibleRetailers = mirror.children('.shop-dine__col:visible');
			if (visibleRetailers.length > 0) {
				var currentPage = $('[data-pagination]').data('pagination-current');
				var pageSize = $('[data-pagination]').data('pagination-size');
				var startCount = (currentPage - 1) * pageSize;
				var endCount = startCount + pageSize;
				holder.empty();
				holder.append(visibleRetailers.clone().slice(startCount, endCount));
				mirror.hide();
				holder.show();
				noResults.hide();
				holder.find('.shop-dine__col h3').matchHeight();
				holder.find('.shop-dine__col .item').matchHeight();
				buildPagination(visibleRetailers.length);
			} else {
				mirror.hide();
				holder.hide();
				noResults.show();
			}
		}
		function buildPagination(totalCount) {
			if ($('[data-pagination]')) {
				var currentPage = $('[data-pagination]').data('pagination-current');
				var prevButton = $('[data-pagination-prev]');
				var nextButton = $('[data-pagination-next]');
				var pagesHolder = $('[data-pagination-pages]');
				var pageSize = $('[data-pagination]').data('pagination-size');
				var pageCount = Math.ceil(totalCount / pageSize);
				pagesHolder.empty();
				if (pageCount > 1) {
					pagesHolder.append("<li class='pagination__prev'><a href='#' class='btn btn--keyline-alt " + (currentPage == 1 ? 'disabled' : '') + "' data-pagination-number='" + (currentPage - 1) + "'>Prev</a></li>");
					for (i = 1; i <= pageCount; i++) {
						pagesHolder.append("<li><a href='#' data-pagination-number='" + i + "' class='" + (i == currentPage ? 'pagination__current' : '') + "'>" + i + '</a></li>');
					}
					pagesHolder.append("<li class='pagination__next'><a href='#' class='btn btn--primary " + (currentPage == pageCount ? 'disabled' : '') + "' data-pagination-number='" + (currentPage + 1) + "'>Next</a></li>");
				}
				$('[data-pagination-number]').click(function (e) {
					var newCurrentPage = $(this).data('pagination-number');
					$(this).closest('[data-pagination]').data('pagination-current', newCurrentPage);
					filterRetailers();
					var headerTop = $('[data-retailer-filter]').offset().top;
					$('html, body').animate(
						{
							scrollTop: headerTop - 50,
						},
						300
					);
				});
			}
		}
	}
	function initDestinationTimetable() {
		if ($('#timetableFilterMain').length) {
			var timetableFilterMain = $('#timetableFilterMain');
			var timetableFilterCustom = $('#timetableFilterCustom');
			timetableFilterMain.change(function () {
				if (timetableFilterMain.val() === '') {
					showAll();
				}
				if (timetableFilterMain.val() === '1') {
					showPredefinedRange();
				}
				if (timetableFilterMain.val() === '2') {
					timetableFilterCustom.show();
					showFree();
				}
			});
			timetableFilterCustom.find('input').change(function () {
				showFree();
			});

			//Initial run - show 30, unless there's no flights in this range
			showPredefinedRange();
			if ($("tr[data-valid='true']").length === 0) {
				timetableFilterMain.val('').trigger('change');
			}
		}
		function showAll() {
			timetableFilterCustom.hide();
			filterTimetable();
		}
		function showPredefinedRange() {
			timetableFilterCustom.hide();
			var fromDate = Date.now();
			var toDate = new Date();
			toDate = toDate.setDate(toDate.getDate() + 30);
			filterTimetable(fromDate, toDate);
		}
		function showFree() {
			var timetableFrom = $('#timetableFrom').val();
			var timetableTo = $('#timetableTo').val();
			if (timetableFrom !== '' && timetableTo !== '') {
				filterTimetable(getTimestamp(timetableFrom), getTimestamp(timetableTo));
			}
		}
		function getTimestamp(dateString) {
			var dateSplit = dateString.split('/');
			var toReturn = new Date(parseInt(dateSplit[2]), parseInt(dateSplit[1]) - 1, parseInt(dateSplit[0])).getTime();
			return toReturn;
		}
		function filterTimetable(fromDate, toDate) {
			$('tr[data-from]').each(function () {
				var toReturn = false;
				if (typeof fromDate === 'undefined') {
					toReturn = true;
				} else {
					toReturn = fromDate <= $(this).data('to') && toDate >= $(this).data('from');
				}
				if (toReturn) {
					$(this).attr('data-valid', true);
				} else {
					$(this).attr('data-valid', false);
				}
			});
			$("tr[data-valid='false']").hide();
			$("tr[data-valid='true']").show();
			$('#timetableCounter').text($("tr[data-valid='true']").length);
		}
	}

	// Some date utility functions

	function formatDate(date) {
		return date.getFullYear() + '-' + padLeft(date.getMonth() + 1, 2, '0') + '-' + padLeft(date.getDate(), 2, '0');
	}
	function formatDateUk(date) {
		return padLeft(date.getDate(), 2, '0') + '/' + padLeft(date.getMonth() + 1, 2, '0') + '/' + date.getFullYear();
	}
	function formatDateShort(date) {
		return date.getFullYear().toString().substr(-2) + '-' + padLeft(date.getMonth() + 1, 2, '0') + '-' + padLeft(date.getDate(), 2, '0');
	}
	function formatTime(time) {
		if (time === null) {
			console.log('Time was null');
			return time;
		}
		if (typeof time.getMonth === 'function') {
			return padLeft(time.getHours(), 2, '0') + ':' + padLeft(time.getMinutes(), 2, '0');
		}
		if (time.length == 5 && time.indexOf(':') != -1) return time;
		return time.substr(0, 2) + ':' + time.substr(2, 2);
	}
	function padLeft(input, length, character) {
		var result = input + '';
		while (result.length < length) {
			result = character + result;
		}
		return result;
	}
	function getDateTimeNow() {
		var now = new Date();
		var year = now.getFullYear();
		var month = now.getMonth() + 1;
		var day = now.getDate();
		var hour = now.getHours();
		var minute = now.getMinutes();
		var second = now.getSeconds();
		if (month.toString().length == 1) {
			month = '0' + month;
		}
		if (day.toString().length == 1) {
			day = '0' + day;
		}
		if (hour.toString().length == 1) {
			hour = '0' + hour;
		}
		if (minute.toString().length == 1) {
			minute = '0' + minute;
		}
		if (second.toString().length == 1) {
			second = '0' + second;
		}
		//var dateTime = year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second;
		// return dateTime;

		return new Date(year, month, day, hour, minute);
	}
	function getDateTime(date, time) {
		var d = date.datepicker('getDate');
		var t = time.val().split(':');
		return new Date(d.getFullYear(), d.getMonth(), d.getDate(), parseInt(t[0]), parseInt(t[1]));
	}
	function validateSameDay(first, second) {
		return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
	}
	function validateSameDayTimes(entryDate, entryTime, exitDate, exitTime, errorField) {
		if (entryDate === null || entryTime === null || exitDate === null || exitTime === null || entryDate === '' || entryTime === '' || exitDate === '' || exitTime === '') {
			return false;
		}
		var entryDateTime = new Date(entryDate.getFullYear(), entryDate.getMonth(), entryDate.getDate(), parseInt(entryTime.split(':')[0]), parseInt(entryTime.split(':')[1]));
		var exitDateTime = new Date(exitDate.getFullYear(), exitDate.getMonth(), exitDate.getDate(), parseInt(exitTime.split(':')[0]), parseInt(exitTime.split(':')[1]));
		if (entryDateTime >= exitDateTime) {
			if (errorField) {
				errorField.html('Return time must be later than depart time').show();
			} else {
				alert('Return time must be later than depart time');
			}
			return false;
		}
		return true;
	}
	function initLazyLoading() {
		$('.destination-item__image, .image-block__image').Lazy({
			// your configuration goes here
			//   scrollDirection: 'vertical',
			effect: 'fadeIn',
			effectTime: 600,
			threshold: 100,
			afterLoad: function afterLoad(element) {
				setTimeout(function () {
					element.parent('.destination-item, .image-block').addClass('loaded');
				}, 500);
			},

			// visibleOnly: true,
			// threshold: 0,
			//  onError: function(element) {
			// console.log('error loading ' + element.data('src'));
			//   }
		});
	}

	function initMegaMenu() {
		$('.hasMenu').hover(function () {
			var tab = $(this).data('tabid');
			$('.hasMenu').removeClass('hasMenu--active');
			$(this).addClass('hasMenu--active');
			$('.mega-menu__wrap').removeClass('visible');
			// $('.navigation .hasMenu').removeClass('link--active');
			//  $(this).addClass('link--active');
			$('.mega-menu__wrap').stop().hide();
			// $(".mega-menu > div").hide();
			$('.mega-menu').show();
			$(tab).addClass('visible');
			$(tab).fadeIn(100);
		});

		// If no mega menu
		$('.navigation li a:not(".hasMenu")').hover(function () {
			$('.hasMenu').removeClass('hasMenu--active');
		});
		$('.hasMenu, .mega-menu').click(function (e) {
			e.stopPropagation(); // stop the click function below being called if we click in the mega menu or a link
		});

		$('.hasMenu, .mega-menu').mouseover(function (e) {
			e.stopPropagation(); // stop the click function below being called if we click in the mega menu or a link
		});

		/*$("body").click(function()
          {
                  $(".mega-menu").hide(); // hide the mega menu if we click on the body
          });*/

		$('.mega-menu').mouseleave(function () {
			$('.mega-menu').hide();
			$('.navigation .hasMenu').removeClass('hasMenu--active');
		});
		$('header').mouseover(function () {
			$('.mega-menu').hide(); // hide the mega menu if we click on the body
			$('.navigation .hasMenu').removeClass('hasMenu--active');
		});

		// This hides the mega menu when clicking away

		$('html').on('touchstart', function (e) {
			$('.mega-menu').hide();
			$('.navigation .hasMenu').removeClass('hasMenu--active');
		});
		$('.mega-menu').on('touchstart', function (e) {
			e.stopPropagation();
		});
	}
	function initBannerAlerts() {
		var bannerAlert = $('.banner-alerts__content');
		var alertArrow = $('.banner-alerts__btn-text');
		var alertText = $('.banner-alerts__btn-text span');
		$('.banner-alerts__btn').click(function (e) {
			bannerAlert.toggleClass('show');
			alertArrow.toggleClass('active');
			if (alertText.text() == 'Hide Alerts') {
				alertText.text('Show Alerts');
			} else {
				alertText.text('Hide Alerts');
			}
		});
	}
	function initDestinationsBtnsMobileFilter() {
		var filterTabs = $('.destinations-btns ul');
		var expandIcon = $('#destinations-btns-mobile span');
		var url = window.location.href;
		if (url.includes('?cat=')) {
			expandIcon.html('-');
			filterTabs.addClass('open');
			filterTabs.css('display', 'block');
		}
		$('#destinations-btns-mobile').click(function (e) {
			e.preventDefault();
			if (filterTabs.hasClass('open')) {
				filterTabs.slideUp(300).removeClass('open');
				expandIcon.html('+');
			} else {
				filterTabs.slideDown(300).addClass('open');
				expandIcon.html('-');
			}
		});
	}
	// initFadingGalleryCarousels();

	function initGallery() {
		var carousel = $('[data-role="fading-gallery-carousel"]');
		if (!carousel.data('state')) {
			carousel.fadingGalleryCarousel();
		}
	}
	function pinnedParkingStrip() {
		if ($('.pinned-parking').length === 0) {
			$('.pinned-parking').hide();
			//alert("Pinned Return");
			return;
		}
		var slideInPoint = 0;
		if ($('.hero-parking, .hero').length) {
			slideInPoint = $('.hero-parking, .hero').offset().top;
			console.log('the value is' + slideInPoint);
		} else {
			slideInPoint = $('main').offset().top;
		}
		var stickyParkingBookingStrip = function stickyParkingBookingStrip() {
			var heroBannerHeight = $('.hero-parking, .hero').outerHeight() + 50; // after the hero banner show the pinned bar
			var scroll_top = $(window).scrollTop(); // our current vertical position from the top
			if (scroll_top > slideInPoint + heroBannerHeight) {
				if (!$('.pinned-parking').hasClass('pinned-parking--fixed')) {
					$('.pinned-parking').addClass('pinned-parking--fixed');
				}
			} else {
				if ($('.pinned-parking').hasClass('pinned-parking--fixed')) {
					$('input.hasDatepicker', '.pinned-parking').datepicker('hide');
					$('input.btn', '.pinned-parking').focus();
					$('.pinned-parking').removeClass('pinned-parking--fixed');
				}
			}
		};

		// run our function on load
		stickyParkingBookingStrip();

		// and run it again every time you scroll
		$(window).scroll(function () {
			if ($(window).width() >= 1024) {
				stickyParkingBookingStrip();
			}
		});
	}
	function initPinnedParkingStrip() {
		if (window.location.href.indexOf('localhost') > -1) {
			setTimeout(function () {
				pinnedParkingStrip();
			}, 5000);
		} else {
			pinnedParkingStrip();
		}
	}
	function initUserPersonalisation() {
		// Look for data attributes in html to decide whether to use this.
		if ($('[data-user-distance-data]').length) {
			// Geo enabled - get this from browser once
			if (navigator.geolocation) {
				navigator.geolocation.watchPosition(updatePosition);
			}
		}

		// Run rules on content itself
		//console.log("Running rules");

		// Run geo rules
		$('[data-user-distance-data]').each(function () {
			//console.log("Found component");

			var display = false;
			var distanceData = $(this).data('user-distance-data');
			var distanceFrom = distanceData.distanceFrom;
			var distanceTo = distanceData.distanceTo;
			var targetLat = distanceData.targetLat;
			var targetLong = distanceData.targetLong;
			var sourceLat = Cookies.get('la') || -1;
			var sourceLong = Cookies.get('lo') || -1;
			var calculatedDistance = 0;
			if (sourceLat == -1 || sourceLong == -1) {
				calculatedDistance = -1;
			} else {
				calculatedDistance = distanceBetweenCoordinates(sourceLat, sourceLong, targetLat, targetLong);
			}

			//console.log("distance - " + calculatedDistance);

			if (calculatedDistance >= distanceFrom && calculatedDistance < distanceTo) {
				display = true;
			}
			if (!display) {
				$(this).css('display', 'none');
			}
		});
		function updatePosition(position) {
			console.log('Updating position');
			Cookies.set('lo', position.coords.longitude, {
				expires: 0.1,
				sameSite: 'strict',
			});
			Cookies.set('la', position.coords.latitude, {
				expires: 0.1,
				sameSite: 'strict',
			});
		}
		function distanceBetweenCoordinates(sourceLat, sourceLong, targetLat, targetLong) {
			//console.log("SourceLat = " + sourceLat);
			//console.log("SourceLong = " + sourceLong);
			//console.log("TargetLat = " + targetLat);
			//console.log("TargetLong = " + targetLong);

			var earthRadius = 6371;
			var diffLat = degreesToRadians(targetLat - sourceLat);
			var diffLon = degreesToRadians(targetLong - sourceLong);
			sourceLat = degreesToRadians(sourceLat);
			sourceLong = degreesToRadians(sourceLong);
			var a = Math.sin(diffLat / 2) * Math.sin(diffLat / 2) + Math.sin(diffLon / 2) * Math.sin(diffLon / 2) * Math.cos(sourceLat) * Math.cos(targetLat);
			var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			return (earthRadius * c) / 1.60934;
		}
		function degreesToRadians(degrees) {
			return (degrees * Math.PI) / 180;
		}
	}
	function initAirlineHandlerSwitcher() {
		$('[data-airline-handler-select]').change(function () {
			var airline = $(this).val();
			var container = $(this).closest('.select-handling-agent');
			container.find('[data-airline-handler-content]').hide();
			container.find("[data-airline-handler-content='" + airline + "']").show();
		});
	}
	function initCreateAccountForm() {
		//FE ONLY
		//  $("#create-account-next").click(function(){
		//     $('.create-account-1').fadeOut('3000', function() {
		//         $('.create-account-2').fadeIn('3000');
		//         $(this).closest('.sso-form__form').find('.form-breadcrumb li').removeClass('active').next().addClass('active');
		//     });
		// });
		//END FE ONLY

		$('#create-account-back').click(function () {
			$('.create-account-2').fadeOut('3000', function () {
				$('.create-account-1').fadeIn('3000');
				$(this).closest('.sso-form__form').find('.form-breadcrumb li').removeClass('active').prev().addClass('active');
			});
		});
		var password = $('#password-create-form');
		var confirm_password = $('#confirm-password');
		var email = $('#email');
		function validateUserInfo() {
			if (validateEmail(email.val())) {
				if (!validatePassword(password.val()) && !validatePassword(confirm_password.val())) {
					$('#create-account-step1-error').html('Password Must be at least 6 characters, At least 1 number, 1 lowercase, 1 uppercase letter').show();
					return false;
				} else {
					if (password.val() != confirm_password.val()) {
						$('#create-account-step1-error').html("Passwords Don't Match").show();
						return false;
					} else {
						$('#create-account-step1-error').hide();
						return true;
					}
				}
			} else {
				$('#create-account-step1-error').html('Invalid Fields Below, please amend and try again').show();
				return false;
			}
		}
		function validateEmail(input) {
			var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			return pattern.test(input);
		}
		function validatePassword(input) {
			var pattern = /^.*(?=.{6,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;
			if (pattern.test(input)) {
				return true;
			} else {
				return false;
			}
		}
		$('#optin-chbx').on('change', function () {
			var self = $(this);
			if ($(self).is(':checked')) {
				$('#optin').val('true');
			} else {
				$('#optin').val('false');
			}
		});
		$('#create-account-form').submit(function (args) {
			args.preventDefault();
			var submittedForm = $(this);
			var action = submittedForm.data('action');
			var redirectPage = submittedForm.data('redirect-page');
			var data = JSON.stringify(submittedForm.serializeJSON());

			/* Back End Changes Only (Below) */

			if (submittedForm.hasClass('form-submitted') !== true) {
				if (validateUserInfo()) {
					$('.create-account-1').fadeOut('3000', function () {
						$('.create-account-2').fadeIn('3000');
						$(this).closest('.sso-form__form').find('.form-breadcrumb li').removeClass('active').next().addClass('active');
					});
				}
			}
			if ($(this).valid() && validateUserInfo()) {
				var firstName = $('#firstname');
				if (firstName !== null && firstName.val().length > 2) {
					$.ajax({
						url: action,
						data: data,
						contentType: 'application/json; charset=utf-8',
						type: 'POST',
					})
						.done(function () {
							window.location.replace(redirectPage);
						})
						.fail(function (xhr, status, error) {
							var errorMessage = JSON.parse(xhr.responseText).message;
							if (errorMessage == 'userexists') {
								errorMessage = submittedForm.data('user-exists-error-message');
								$('#create-account-step1-error').html(errorMessage).show();
								$('.create-account-2').fadeOut('3000', function () {
									$('.create-account-1').fadeIn('3000');
									$(this).closest('.sso-form__form').find('.form-breadcrumb li').removeClass('active').prev().addClass('active');
								});
								$('#create-account-next').val('Create Account');
							} else {
								$('#create-account-summary-error').html(errorMessage).show();
							}
							submittedForm.addClass('form-submitted');
						});
				}
			}

			//* END Back End Changes Only (Below) */
		});
	}

	function initLoginPage() {
		$('#login-form').submit(function (args) {
			args.preventDefault();
			if ($(this).validate()) {
				var submittedForm = $(this);
				var action = submittedForm.data('action');
				var redirectPage = submittedForm.data('redirect-page');
				var data = JSON.stringify(submittedForm.serializeJSON());
				$.ajax({
					url: action,
					data: data,
					contentType: 'application/json; charset=utf-8',
					type: 'POST',
				})
					.done(function () {
						window.location.replace(redirectPage);
					})
					.fail(function (xhr, status, error) {
						var errorMessage = JSON.parse(xhr.responseText).message;
						$('#login-form-error').html(errorMessage).show();
					});
			}
		});
	}
	function initEditAccountPage() {
		//Front End Only

		// var formdata = {
		//     "title":null,
		//     "firstname":"Richard",
		//     "lastname":"Round",
		//     "phonenumber":"+440771111111",
		//     "addressline1":"47 Some Road",
		//     "addressline2":"Line 2",
		//     "town":"Stockport",
		//     "county":"Cheshire",
		//     "country":"United Kingdom",
		//     "postcode":"SK1 3BJ",
		//     "optin":true,
		//     "siteCode":null
		// }

		// $('#edit-account-form *').filter(':input:not(input[type=submit])').val(function(index, value){
		//     return formdata[this.name];
		// });

		//END FRONT END ONLY

		//START BE ONLY

		var action = $('#edit-account-form').data('populate-action');
		if (action !== undefined) {
			var sitecode = $('#edit-account-form').data('sitecode');

			//Get Values
			$.ajax({
				url: action + '?siteCode=' + sitecode,
				contentType: 'application/json; charset=utf-8',
				type: 'GET',
			})
				.done(function (data) {
					if (data) {
						$('#edit-account-form *')
							.filter(':input:not(input[type=submit])')
							.val(function () {
								return data[this.name];
							});
					}
				})
				.fail(function (xhr, status, error) {
					var errorMessage = JSON.parse(xhr.responseText).message;
					$('#edit-account-summary-error').html(errorMessage).show();
				});
		}

		//END BE ONLY

		$('#edit-account-form').submit(function (args) {
			args.preventDefault();
			if ($(this).valid()) {
				var submittedForm = $(this);
				var action = submittedForm.data('action');
				var data = JSON.stringify(submittedForm.serializeJSON());
				$.ajax({
					url: action,
					data: data,
					contentType: 'application/json; charset=utf-8',
					type: 'POST',
				})
					.done(function () {
						$('#edit-account-summary-success').show();
					})
					.fail(function (xhr, status, error) {
						var errorMessage = JSON.parse(xhr.responseText).message;
						$('#edit-account-summary-error').html(errorMessage).show();
					});
			}
		});
	}
	function initLoginCheck() {
		$.ajax({
			url: '/umbraco/api/AeroparkerUserApi/CheckRefreshToken',
			contentType: 'application/json; charset=utf-8',
			type: 'POST',
		})
			.done(function () {
				initAuthorised();
			})
			.fail(function (xhr, status, error) {
				var errorMessage = JSON.parse(xhr.responseText).message;
				console.log(errorMessage);
			});
	}
	function initLogOut() {
		$('.logout').click(function () {
			$.ajax({
				url: '/umbraco/api/AeroparkerUserApi/Logout',
				contentType: 'application/json; charset=utf-8',
				type: 'POST',
			})
				.done(function () {
					window.location.replace('/');
				})
				.fail(function (xhr, status, error) {
					var errorMessage = JSON.parse(xhr.responseText).message;
					console.log(errorMessage);
				});
		});
	}
	function initAuthorised() {
		//$("#sso").show();

		$.ajax({
			url: '/umbraco/api/AeroparkerUserApi/IsAuthenticated',
			contentType: 'application/json; charset=utf-8',
			type: 'GET',
		})
			.done(function (data) {
				if (data && ssoEnabled()) {
					$('#liNavlogin').html(loginTemplate()).addClass('logged-in');
					initMegaMenu();
					buildMyFlightWidget();
					initAuthFields();
					initLogOut();
					$('[data-authorized]').show();
				}
			})
			.fail(function (xhr, status, error) {
				var errorMessage = JSON.parse(xhr.responseText).message;
				console.log(errorMessage);
			});
		function loginTemplate() {
			var template =
				'<a href="#" title="Login" id="loginLink" itemprop="url" data-tabid="#sso" class="hasMenu">\r\n      <i class="fa fa-user" aria-hidden="true"></i>\r\n      <i class="icon icon-account-arrow" aria-hidden="true"></i>\r\n    </a>';
			return template;
		}
		function buildMyFlightWidget() {
			var template = $('#sso-widget-login-view-with-flight').html();
			$.ajax({
				url: '/umbraco/api/AeroparkerUserApi/GetUserFlights',
				contentType: 'application/json; charset=utf-8',
				type: 'GET',
			})
				.done(function (data) {
					if (data) {
						if (data.length > 0) {
							var destinationWithStopovers = '<li>' + data[0].OriginOrDestination + '</li>';
							if (data[0].IntermediateSteps.length) {
								data[0].IntermediateSteps.forEach(function (step) {
									destinationWithStopovers += '<li>' + step.Location + '</li>';
								});
							}
							var flightTemplate = '';
							flightTemplate = template
								.replace('${number}$', data[0].Number)
								.replace('${destinationWithStopovers}$', destinationWithStopovers)
								.replace('${flightTime}$', data[0].DisplayTime)
								.replace('${status}$', data[0].Status)
								.replace('${statusColor}$', data[0].StatusColor);
							$('#sso-widget-flight-placeholder').html(flightTemplate);
							$('#airline-logo').html('<img src="' + data[0].AirlineLogoUrl + '" alt="' + data[0].Airline + '" />');
							$('#flightId').val(data[0].Id);
							$('#sso-widget-flight-placeholder-mob').html($('#sso-widget-flight-placeholder').html());
							$('[data-hasflights]').show();
						} else {
							$('[data-hasflights]').hide();
						}
					}
				})
				.fail(function (xhr, status, error) {
					var errorMessage = JSON.parse(xhr.responseText).message;
					console.log(errorMessage);
				});
		}
		//

		function initAuthFields() {
			$.ajax({
				url: '/Umbraco/api/AeroparkerUserApi/GetUserInformation',
				contentType: 'application/json; charset=utf-8',
				type: 'GET',
			})
				.done(function (data) {
					if (data) {
						$('#loginNamePlaceholder').html(data.FirstName);
						$('#nav-mobile-li-Login').parent().hide();
					}
				})
				.fail(function (xhr, status, error) {
					var errorMessage = JSON.parse(xhr.responseText).message;
					console.log(errorMessage);
				});
		}
	}
	function ssoEnabled() {
		var isEnabled = $('body').data('sso-enabled');
		return isEnabled == 'True' ? true : false;
	}
	function initInternationalPhoneNumberHelper() {
		var input = $('#phonenumber, [data-telephone]');
		input.each(function () {
			if ($(this)[0] !== null) {
				window.intlTelInput($(this)[0], {
					// any initialisation options go here
					nationalMode: false,
					autoHideDialCode: false,
					initialCountry: 'gb',
				});
			}
		});
	}
	function initPasswordValidation() {
		var myInput = $('[data-password-validation]');
		var letter = $("[data-validation='letter']");
		var capital = $("[data-validation='capital']");
		var length = $("[data-validation='length']");
		var number = $("[data-validation='number']");
		var specialChars = $("[data-validation='specialChars']");

		// When the user clicks on the password field, show the message box
		myInput.focus(function () {
			$('[data-password-helper]').addClass('active');
		});

		// When the user clicks outside of the password field, hide the message box
		myInput.blur(function () {
			$('[data-password-helper]').removeClass('active');
		});

		// When the user starts to type something inside the password field
		myInput.keyup(function () {
			var val = $(this).val(); // Gets the value within the input
			var lowerCaseLetters = /[a-z]/g; // Validate lowercase letters
			var upperCaseLetters = /[A-Z]/g; // Validate capital letters

			var numbers = /[0-9]/g; // Validate numbers

			if (lowerCaseLetters.test(val)) {
				letter.removeClass('fa-exclamation-triangle');
				letter.addClass('fa-check');
			} else {
				letter.removeClass('fa-check');
				letter.addClass('fa-exclamation-triangle');
			}
			if (upperCaseLetters.test(val)) {
				capital.removeClass('fa-exclamation-triangle');
				capital.addClass('fa-check');
			} else {
				capital.removeClass('fa-check');
				capital.addClass('fa-exclamation-triangle');
			}
			if (numbers.test(val)) {
				number.removeClass('fa-exclamation-triangle');
				number.addClass('fa-check');
			} else {
				number.removeClass('fa-check');
				number.addClass('fa-exclamation-triangle');
			}

			// Validate length
			if (val.length >= 8) {
				length.removeClass('fa-exclamation-triangle');
				length.addClass('fa-check');
			} else {
				length.removeClass('fa-check');
				length.addClass('fa-exclamation-triangle');
			}
		});
	}
	function initRemoveFlightForm() {
		$('#remove-flight-form').submit(function (args) {
			args.preventDefault();
			var submittedForm = $(this);
			var action = submittedForm.data('action');
			$.ajax({
				url: action,
				contentType: 'application/json; charset=utf-8',
				type: 'POST',
			})
				.done(function () {
					$('#delete-flight').hide();
					window.location.replace(window.location.href.split('#')[0]);
				})
				.fail(function (xhr, status, error) {
					var errorMessage = JSON.parse(xhr.responseText).message;
					console.log(errorMessage);
				});
		});
	}
	function initFAQs() {
		$('.faqs__btns li').click(function () {
			var tabId = $(this).attr('data-tab');
			var faqSelect = $(this).closest('[data-faqs-wrapper]').find('.faqs__select');
			faqSelect.val(tabId); // update the mobile dropdown to match then trigger 'change' event to update all ui in there. CustomSelect is buggy and doesn't update otherwise
			faqSelect.change();
		});
		$('.faqs__select').on('change', function () {
			var tabId = $(this).find(':selected').attr('data-tab');
			var faqWrapper = $(this).closest('[data-faqs-wrapper]');
			faqWrapper.find('.faqs__btns li').removeClass('current');
			faqWrapper.find('.faqs__content').removeClass('current');
			faqWrapper.find(".faqs__btns li[data-tab='" + tabId + "']").addClass('current');
			$('#' + tabId).addClass('current');
		});
		$(function () {
			var bookmark = window.location.hash;
			if (bookmark !== null && bookmark.indexOf('faq_') !== -1) {
				// Only look for anchor tags which start faq_#
				if ($(bookmark).data('role') === 'tab') {
					// Its a tab so click first child question
					switchQuestion($(bookmark).find('[data-id]').first().data('id'));
				} else {
					switchQuestion(bookmark.replace('#', ''));
				}
			}
		});
		var searchFields = $('[data-faqs-search]');
		if (searchFields.length) {
			searchFields.each(function () {
				// traverse to parent to find content
				var faqWrapper = $(this).closest('[data-faqs-wrapper]');
				var faqElements = faqWrapper.find('[data-question]');
				var faqList = faqElements.map(function () {
					return {
						value: $(this).data('question') + ' ' + $(this).data('synonym'),
						id: $(this).data('id'),
						text: $(this).data('question'),
					};
				});
				buildFAQDropdown($(this), faqList, faqWrapper);
			});
		}
		function switchQuestion(selectedQuestionId) {
			var selectedQuestion = $("[data-id='" + selectedQuestionId + "']");
			var selectedTab = selectedQuestion.parent().closest("[data-role='tab']");
			var faqWrapper = selectedQuestion.closest('[data-faqs-wrapper]');
			var faqSelect = faqWrapper.find('.faqs__select');
			faqSelect.val(selectedTab.attr('id')); // update the mobile dropdown to match then trigger change to update all ui in there, due to odd behaviour of customSelect plugin events
			faqSelect.change();
			if (selectedQuestion.attr('aria-expanded') === 'false') {
				faqWrapper.find('#' + selectedQuestionId).click(); // fire accordion link (if not already open)
			}

			$('html, body').animate(
				{
					scrollTop: $('#' + selectedQuestionId).offset().top - 50,
				},
				100
			);
		}
		function buildFAQDropdown(searchField, dropdownList, faqWrapper) {
			var returnKey = false;
			var resultCount = 0;
			var noResults = true;
			searchField
				.autocomplete({
					minLength: 3,
					autoFocus: true,
					source: function source(request, response) {
						var results = $.ui.autocomplete.filter(dropdownList, request.term);
						response(results.slice(0, 3));
					},
					focus: function focus(event, ui) {
						return false;
					},
					select: function select(e, selected) {
						searchField.val(selected.item.text);
						switchQuestion(selected.item.id);
						e.preventDefault();
					},
				})
				// this builds the autocomplete content to be shown, using the fields above
				.autocomplete('instance')._renderItem = function (ul, item) {
				return $("<li class='faq-result'>")
					.append("<a href='#' title='" + item.text + "' >" + '<h3>' + item.text + '</h3>' + '</a>')
					.appendTo(ul);
			};

			// Add on extra settings for targetting/classes/placeholder text
			var targetElement = faqWrapper.find('[data-faqs-search-target-element]');
			if (targetElement.length) {
				searchField.autocomplete('option', 'appendTo', targetElement);
			}
			if (searchField.data('extra-classes')) {
				searchField.autocomplete('option', 'classes.ui-autocomplete', searchField.data('extra-classes'));
			}

			// Switch placeholder labels for mobile/desktop
			$(window)
				.resize(function () {
					if ($(window).width() >= 900) {
						searchField.attr('placeholder', searchField.data('desktop-placeholder'));
					} else {
						searchField.attr('placeholder', searchField.data('mobile-placeholder'));
					}
				})
				.resize();
		}
	}
	function initWebChat() {
		$('.chat-icon, .ags-chat-header__close').click(function () {
			$('#agschat, .ags-chat-header').toggle();
			if ($('#agschat').is(':visible')) {
				var token = Cookies.get('agsChatToken') || '';
				if (token === '') {
					$.get('/umbraco/api/UserApi/GenerateChatToken').done(function (response) {
						if (response.length) {
							var token = response;
							Cookies.set('agsChatToken', token, {
								expires: 1 / 24,
								sameSite: 'strict',
							});
							renderWebChat(token);
						}
					});
				} else {
					renderWebChat(token);
				}
			}
		});
	}
	function renderWebChat(token) {
		var store = window.WebChat.createStore({}, function (_ref) {
			var dispatch = _ref.dispatch;
			return function (next) {
				return function (action) {
					var accessCookie = Cookies.get('gla_cognito_access') || Cookies.get('abz_cognito_access') || Cookies.get('sou_cognito_access') || false;
					if (action.type === 'DIRECT_LINE/POST_ACTIVITY' && accessCookie) {
						action = window.simpleUpdateIn(action, ['payload', 'activity', 'channelData', 'ags_cognito_access'], function () {
							return accessCookie;
						});
					}
					return next(action);
				};
			};
		});
		window.WebChat.renderWebChat(
			{
				directLine: window.WebChat.createDirectLine({
					token: token,
				}),
				store: store,
				styleOptions: {
					hideUploadButton: true,
					emojiSet: false,
				},
			},
			document.getElementById('agschat')
		);
	}
	function initItemListSearch() {
		$('[data-item-list-search]').each(function () {
			var search = $(this);
			$(this)
				.find('[data-filter]')
				.click(function (e) {
					e.preventDefault();
					$(this).toggleClass('btn--keyline-alt');
					$(this).toggleClass('btn--primary');
					$(this).blur();
					itemListFilter(search);
				});
			$(this)
				.find('[data-filter-button]')
				.click(function (e) {
					e.preventDefault();
					itemListFilter(search);
				});
		});
		function itemListFilter(search) {
			var listElements = search.parent().find('.item-list');
			var searchText = search.find("input[type='text']").val().toLowerCase();
			listElements.hide();
			search.find('.btn--primary[data-filter]').each(function () {
				listElements = listElements.filter("[data-filter*='" + $(this).data('filter') + "']");
			});
			if (searchText !== '') {
				listElements = listElements.filter("[data-title*='" + searchText + "']");
			}
			listElements.fadeIn('fast');
		}
	}
	function initParkingGrid() {
		$('[data-parking-type-reveal-btn]').click(function () {
			$(this).parent().next().slideToggle();
			$(this).toggleClass('expanded');
		});
	}
	function initFormFlow() {
		// Hook on to fields marked 'data-autoskip' and auto pass on to the next one when certain things (dropdowns etc) are chosen
		$('[data-autoskip]').each(function () {
			$(this).change(function () {
				var currentField = $(this)[0];
				var validFields = $(this).closest('[data-autoskip-wrapper').find('[data-autoskip]');
				var currentFieldIndex = validFields.get().findIndex(function (field) {
					return field == currentField;
				});
				if (currentFieldIndex + 1 < validFields.length) {
					var nextField = $(validFields[currentFieldIndex + 1]);
					//nextField.select();
					nextField.focus();
					if (nextField.hasClass('select2-hidden-accessible')) {
						nextField.select2('open');
					}
				}
			});
		});
	}
	function initPurchaseFlow() {
		var phoneNumberLimit = {
			'+44': 10,
			'+33': 10,
			'+1': 10,
		};
		$('#phone-number-prefix').on('change', function () {
			$('#phoneNumber').val('');
			var prefix = $(this).val();
			var limit = phoneNumberLimit[prefix];
			if (limit) {
				$('#phoneNumber').attr({
					minlength: limit,
					maxlength: limit,
				});
			} else {
				$('#phoneNumber').removeAttr('minlength maxlength');
			}
		});
		$('[data-phone-number-trigger]').on('input', function () {
			var value = $(this).val();
			var sanitizedValue = value.replace(/[^0-9+]/g, '');
			$(this).val(sanitizedValue);
		});
		$("[data-role='purchase-flow-wrapper']").each(function () {
			var currentWrapper = $(this);
			var currentForm = $(this).find('form[data-booking-form]');
			var updateTriggers = currentWrapper.find('[data-update-trigger]');
			var vehicleTriggers = currentWrapper.find('[data-vehicle-lookup-trigger]');
			var postcodeTriggers = currentWrapper.find('[data-postcode-lookup-trigger]');
			var phoneNumberTriggers = currentWrapper.find('[data-phone-number-trigger]');
			var sortByTriggers = currentWrapper.find('[data-sortby-trigger]');
			var editButton = currentWrapper.find('[data-parking-details-edit]');
			var loginTriggers = currentWrapper.find('[data-login-trigger]');
			var promotiontriggers = currentWrapper.find('[data-promo-code-trigger]');
			var braintreeClientToken = currentForm.find("[data-field='braintreeClientToken']");
			var paymentNounce = currentForm.find("[data-field='paymentnonce']");
			var paymentType = currentForm.find("[data-field='paymentType']");
			var paymentbasketTotal = currentForm.find("[data-field='paymentbasketTotal']");
			var googlemerchantId = currentForm.find("[data-field='googlemerchantId']");
			var apiBaseUrl = currentWrapper.data('api-base');
			var subTotalPriceWrapper = $('#subTotalPriceWrapper');
			var totalDiscountWrapper = $('#totalDiscountWrapper');
			var hdDiscountApplied = $('#hdDiscountApplied');
			var upgradeTriggers = currentWrapper.find('[data-upgrade-trigger]');
			upgradeTriggers.on('click', function (e) {
				e.preventDefault();
				var parkingUpgrade = $(this).closest("[data-role='parking-upgrade']");
				//Fields
				var upgradeProductId = parkingUpgrade.find('[data-upgrade-productid]');
				var parkingAvailabilityWindowId = parkingUpgrade.find('[data-parking-availability-windowid]');
				var redirectUrl = '/Checkout/?stage=3&productId=' + upgradeProductId.val() + '&productType=Parking&variantQuantity=1&parkingAvailabilityWindowId=' + parkingAvailabilityWindowId.val();
				saveBasket(redirectUrl);
			});
			if (hdDiscountApplied.val() !== 'true') {
				subTotalPriceWrapper.hide();
				totalDiscountWrapper.hide();
			}
			var purchaseFlowTitles = document.querySelectorAll('.purchase-flow__flight-summary__title');
			purchaseFlowTitles.forEach(function (purchaseFlowTitle) {
				purchaseFlowTitle.addEventListener('click', function (event) {
					event.preventDefault();
					$(this).closest('[data-parking-details]').addClass('purchase-flow__flight-summary__row--edit');
				});
			});
			editButton.click(function (event) {
				event.preventDefault();
				$(this).closest('[data-parking-details]').addClass('purchase-flow__flight-summary__row--edit');
			});
			phoneNumberTriggers.on('focusout', function () {
				var phoneNumberPrefix = $('#phone-number-prefix').val();
				var phoneNumberValue = $('#phoneNumber').val();
				var txtPhoneVal = phoneNumberValue;
				if (phoneNumberPrefix !== 'other') {
					txtPhoneVal = phoneNumberPrefix + txtPhoneVal;
				}
				$('#txtPhone').val(txtPhoneVal);
			});

			loginTriggers.on('click', function () {
				var endpointUrl = $(this).closest('[data-endpoint]').data('endpoint');
				var login = $(this).closest("[data-role='login']");
				var userName = login.find("[data-field='user-name']");
				var password = login.find("[data-field='password']");
				var siteCode = login.find("[data-field='site-code']");
				var data = {
					userName: userName.val(),
					password: password.val(),
					siteCode: siteCode.val(),
				};
				$.ajax({
					url: apiBaseUrl + endpointUrl + '?' + new URLSearchParams(data),
					data: data,
					contentType: 'application/json; charset=utf-8',
					type: 'POST',
				})
					.done(function () {
						window.location.href = window.location.href;
					})
					.fail(function (xhr, status, error) {
						$('#login-form-error').show();
						var errorMessage = JSON.parse(xhr.responseText).message;
						console.log(errorMessage);
					});
			});
			var urlParms = new URLSearchParams(location.search);
			var sortByParm = urlParms.get('sortBy');
			if (sortByParm !== null) {
				$(sortByTriggers).val(sortByParm).change();
			}
			postcodeTriggers.click(function () {
				var formpostcodeErrorText = currentWrapper.find('[data-validate-postcode-error]');
				var formpostcodeErrorSummary = document.getElementById('postCodeField');
				var addressPostcode = currentForm.find("[data-field='address-postcode']").val() || '';
				var postcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}|[A-Z]{1,2}\d{1,2} \d[A-Z]{2})$/i;

				if (addressPostcode !== '' && postcodeRegex.test(addressPostcode)) {
					formpostcodeErrorText.removeClass('postcode-validation-error-active');
					formpostcodeErrorText.addClass('postcode-validation-error');
					formpostcodeErrorSummary.classList.remove('validation-error-wrapper');

					var key = currentForm.data('postcode-lookup-token');
					var pc = CraftyPostcodeCreate();
					pc.set('access_token', key);
					pc.set('form', currentForm.attr('id'));
					var addressResultsHolder = currentForm.find("[data-role='address-results-holder']");

					//$("[data-address-fields]").show();

					pc.set('result_elem_id', addressResultsHolder.attr('id'));
					pc.set('elem_street1', 'addressstreet');
					pc.set('elem_town', 'addresstown');
					pc.set('elem_county', 'addresscounty');
					pc.set('elem_postcode', 'addresspostcode');
					pc.set('debug_mode', '1');
					pc.set('res_autoselect', '0');
					pc.set('pre_populate_common_address_parts', '0');
					pc.set('hide_result', '1');
					pc.set('on_result_ready', function () {
						$('.manual-address').hide();
						$('#txtAddressStreet').val('');
						$('#txtAddressTown').val('');
						$('#txtAddressCounty').val('');
					});
					pc.set('on_result_selected', function () {
						$('.manual-address').hide();
						$('[data-address-fields]').show();
					});
					pc.set('on_error', function (e) {
						//Reset fields
						$('#txtAddressStreet').val('');
						$('#txtAddressTown').val('');
						$('#txtAddressCounty').val('');
						$('.manual-address').hide();
						$('[data-address-fields]').show();
					});
					pc.doLookup();
				} else {
					formpostcodeErrorText.removeClass('postcode-validation-error');
					formpostcodeErrorText.addClass('postcode-validation-error-active');
					formpostcodeErrorSummary.classList.add('validation-error-wrapper');
				}
			});
			updateTriggers.change(function () {
				var product = $(this).closest("[data-role='product']");
				var variant = $(this).closest("[data-role='variant']");
				var purchaseFlowWrapper = $(this).closest("[data-role='purchase-flow-wrapper']");
				var updateMessage = purchaseFlowWrapper.find("[data-role='update-message']");
				var basketSummary = purchaseFlowWrapper.find("[data-role='basket-summary']");
				var productId = product.find("[data-field='product-id']");
				var productType = product.find("[data-field='product-type']");
				var variantId = variant.find("[data-field='variant-id']");
				var variantName = variant.find("[data-field='variant-name']");
				var variantQuantity = variant.find("[data-field='variant-quantity']");
				var endpointUrl = $(this).closest('[data-endpoint]').data('endpoint');
				var data = {
					productId: productId.val(),
					productType: productType.val(),
					variantQuantity: variantQuantity.val(),
					variantId: variantId.val() || '',
					variantName: variantName.val() || '',
				};
				$.ajax({
					url: apiBaseUrl + endpointUrl + '?' + new URLSearchParams(data),
					type: 'GET',
				})
					.done(function (data) {
						if (data === true) {
							updateMessage
								.fadeIn('fast')
								.delay(1000)
								.fadeOut('fast', function () {
									location.reload();
								});

							/** TODO - dynamically change basket without reload
            $.ajax({
            		url: endpoint + "/GetOrderSummary",
            		type: "GET"
            	})
            .done(function(summary)
            {
            	console.log(summary);
            });**/
						}
					})
					.fail(function (xhr, status, error) {
						var errorMessage = JSON.parse(xhr.responseText).message;
						console.log(errorMessage);
					});
			});

			var vehicleManualInputToggle = document.querySelector('[data-car-details-toggle]');
			if (vehicleManualInputToggle !== null) {
				vehicleManualInputToggle.addEventListener('click', function (e) {
					e.preventDefault();

					var vehicleLookUpForm = document.querySelector('[data-vehicle-lookup-form]');
					vehicleLookUpForm.style.display = 'block';
					vehicleManualInputToggle.style.display = 'none';
				});
			}

			var vehicleReg = currentForm.find("[data-field='vehicle-registration']");

			if (vehicleReg && vehicleReg.val()) {
				var vehicleLookUpForm = document.querySelector('[data-vehicle-lookup-form]');

				if (vehicleReg.val().length > 0) {
					vehicleLookUpForm.style.display = 'none';

					var make = currentForm.find("[data-field='vehicle-make']").val();
					var colour = currentForm.find("[data-field='vehicle-colour']").val();

					var vehicleDetailsInner =
						'<div class="car-details__details" data-car-details>' +
						'<span class="car-details__registration" style="font-size: 2rem;">' +
						vehicleReg.val() +
						' - ' +
						'<span class="car-details__make">' +
						make +
						' </span>' +
						'<span class="car-details__color">' +
						colour +
						'</span>' +
						'</div>';

					var vehicleDetails = document.querySelector('[data-car-details]');

					vehicleDetails.innerHTML = vehicleDetailsInner;
					vehicleManualInputToggle.style.display = 'block';
				} else {
					vehicleLookUpForm.style.display = 'block';
				}
			}

			vehicleTriggers.on('click', function (e) {
				var vehicleFind = $(this);
				var endpointUrl = vehicleFind.closest('[data-endpoint]').data('endpoint');
				var vehicleRegistration = currentForm.find("[data-field='vehicle-registration']");
				var vehicleWait = currentForm.find('[data-vehicle-lookup-wait]');
				var vehicleError = currentForm.find('[data-vehicle-lookup-error]');
				if (vehicleRegistration && vehicleRegistration.val()) {
					vehicleFind.prop('disabled', true);
					vehicleRegistration.prop('disabled', true);
					vehicleWait.show();
					vehicleError.hide();
					$.ajax({
						url: apiBaseUrl + endpointUrl + '?vehicleRegistration=' + vehicleRegistration.val(),
						type: 'GET',
					})
						.done(function (data) {
							if (data !== null && data !== undefined) {
								var vehicleLookUpForm = document.querySelector('[data-vehicle-lookup-form]');
								var vehicleDetails = document.querySelector('[data-car-details]');

								var vehicleDetailsInner =
									'<div class="car-details__details" data-car-details>' + '<span class="car-details__registration" style="font-size: 2rem;">' + vehicleRegistration.val() + ' - ' + data.colour + ' ' + data.make + '</span>' + '</div>';

								currentForm.find("[data-field='vehicle-make']").val(data.make);
								currentForm.find("[data-field='vehicle-model']").val(data.model);
								currentForm.find("[data-field='vehicle-colour']").val(data.colour);

								vehicleLookUpForm.style.display = 'none';
								vehicleDetails.innerHTML = vehicleDetailsInner;

								var vehicleManualInputToggle = document.querySelector('[data-car-details-toggle]');
								vehicleManualInputToggle.style.display = 'block';
							}
							if (data.make !== null && data.model !== null && data.colour !== null) {
								vehicleFind.prop('disabled', false);
								vehicleRegistration.prop('disabled', false);
								vehicleWait.hide();
							} else {
								vehicleFind.prop('disabled', false);
								vehicleRegistration.prop('disabled', false);
								vehicleWait.hide();
								vehicleError.show();
							}
						})
						.fail(function (xhr, status, error) {
							vehicleFind.prop('disabled', false);
							vehicleRegistration.prop('disabled', false);
							vehicleWait.hide();
							vehicleError.show();
							var errorMessage = JSON.parse(xhr.responseText).message;
							console.error(errorMessage);
						});
				}
			});
			promotiontriggers.on('click', function (e) {
				var promoCodeButton = $(this);
				var promoCodeWrapper = promoCodeButton.closest('[data-promo-code]');
				var endpointUrl = promoCodeWrapper.data('endpoint');
				var promoCodeInput = promoCodeWrapper.find('[data-promo-code-input]');
				var promoCodeWait = promoCodeWrapper.find('[data-promo-code-wait]');
				var promoCodeMessage = promoCodeWrapper.find('[data-promo-code-message]');
				var entryDateTime = promoCodeWrapper.find("[data-field='entryDateTime']");
				var exitDateTime = promoCodeWrapper.find("[data-field='exitDateTime']");
				var subTotalPrice = $('#txtBasketSubTotalPrice');
				var totalDiscount = $('#txtBasketTotalDiscount');
				var basketTotal = $('#txtBasketTotal');
				var basketPromoCode = $('#basketPromoCode');
				var pbasketTotal = $('#pbasketTotal');
				var divDiscountAppliedOnBasket = $('#divDiscountAppliedOnBasket');
				var hdDiscountAppliedOnBasket = $('#hdDiscountAppliedOnBasket');
				var hiddenCmd = $("[data-field='hidden-cmd']");

				if (endpointUrl && promoCodeInput.val()) {
					promoCodeButton.prop('disabled', true);
					promoCodeInput.prop('disabled', true);
					promoCodeWait.show();
					promoCodeMessage.hide();
					var data = {
						promoCode: promoCodeInput.val(),
						entryDateTime: entryDateTime.val(),
						exitDateTime: exitDateTime.val(),
					};
					var formData = {
						firstname: $('#txtFirstName').val(),
						lastname: $('#txtLastName').val(),
						emailaddress: $('#txtEmail').val(),
						phone: $('#phoneNumber').val(),
						addresspostcode: $('#txtAddressPostcode').val(),
						addressstreet: $('#txtAddressStreet').val(),
						addresstown: $('#txtAddressTown').val(),
						addresscounty: $('#txtAddressCounty').val(),
						vehicleregistration: $('#txtVehicleReg').val(),
						vehiclemake: currentForm.find("[data-field='vehicle-make']").val(),
						vehiclemodel: currentForm.find("[data-field='vehicle-model']").val(),
						vehiclecolour: currentForm.find("[data-field='vehicle-colour']").val(),
						outboundflightcode: $('#hdflightDetails').val(),
						reasonforjourney: $('input[name="reason"]:checked').val(),
						cmd: hiddenCmd.val(),
					};
					Cookies.set('pfcustomerDetailsForm', formData, {
						expires: 0.1,
						sameSite: 'strict',
					});
					$.ajax({
						url: apiBaseUrl + endpointUrl + '?' + new URLSearchParams(data),
						type: 'POST',
					})
						.done(function (result) {
							if (result !== null && result !== undefined && result.promotionIsValid) {
								promoCodeMessage.text("Promo code '" + promoCodeInput.val() + "' has been successfully applied").show();
							}
							promoCodeButton.prop('disabled', false);
							promoCodeInput.prop('disabled', false);
							promoCodeWait.hide();
							if (result.promotionIsValid) {
								window.location.reload(true);
							} else {
								promoCodeButton.prop('disabled', false);
								promoCodeInput.prop('disabled', false);
								promoCodeWait.hide();
								promoCodeMessage.text(result.errorMessage).show();
							}
						})
						.fail(function (xhr, status, error) {
							promoCodeButton.prop('disabled', false);
							promoCodeInput.prop('disabled', false);
							promoCodeWait.hide();
							promoCodeMessage.text("Promo code '" + promoCodeInput.val() + "' is not valid").show();
							var errorMessage = JSON.parse(xhr.responseText).message;
							console.error(errorMessage);
						});
				}
			});

			sortByTriggers.on('change', function () {
				var self = this;
				var selectedValue = $(self).find(':selected').val();
				var reloadUrl = updateQueryStringParameter(location.href, 'sortBy', selectedValue);
				location.href = reloadUrl;
			});
			function updateQueryStringParameter(uri, key, value) {
				var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
				var separator = uri.indexOf('?') !== -1 ? '&' : '?';
				if (uri.match(re)) {
					return uri.replace(re, '$1' + key + '=' + value + '$2');
				} else {
					return uri + separator + key + '=' + value;
				}
			}

			var basketTotal = 0.0;

			if (!isNaN(paymentbasketTotal.val())) {
				basketTotal = parseFloat(paymentbasketTotal.val());
			}

			if (basketTotal > 0.0) {
				braintree.dropin.create(
					{
						authorization: braintreeClientToken.val(),
						container: '#bt-dropin',
						threeDSecure: true,
						paypal: {
							flow: 'checkout',
							amount: paymentbasketTotal.val(),
							currency: 'GBP',
						},
						applePay: {
							displayName: 'AGS Parking',
							paymentRequest: {
								total: {
									label: 'AGS Parking',
									amount: paymentbasketTotal.val(),
								},
								requiredBillingContactFields: ['postalAddress'],
							},
						},
						googlePay: {
							googlePayVersion: 2,
							merchantId: googlemerchantId.val(),
							transactionInfo: {
								totalPriceStatus: 'FINAL',
								totalPrice: paymentbasketTotal.val(),
								currencyCode: 'GBP',
							},
							allowedPaymentMethods: [
								{
									type: 'CARD',
									parameters: {
										billingAddressRequired: true,
										billingAddressParameters: {
											format: 'FULL',
										},
									},
								},
							],
						},
					},
					submitFormCallBack
				);
			} else {
				submitFormCallBack(null, null);
			}

			function submitFormCallBack(createErr, dropinInstance) {
				currentForm.on('submit', function (e) {
					// prevent the form submitting
					e.preventDefault();
					var self = $(this);
					if (!self.data('submitting')) {
						self.data('submitting', true);
						var $submitButton = self.find(':input[type="submit"]');
						var $formErrorSummary = self.find('[data-validate-errors-summary]');
						var $formErrorList = self.find('[data-validate-errors-list]');
						var formErrors = [];

						// disable submit button
						$submitButton.prop('disabled', true);
						$submitButton.addClass('wait');

						// for each field with validation
						self.find('[data-validate-field]').each(function () {
							var errorType = validateField($(this));
							if (errorType) {
								// push the error to form error list
								formErrors.push({
									errorType: errorType,
									id: $(this).attr('id'),
									label: $(this).data('validate-label') ? $(this).data('validate-label') : $('[for="' + $(this).attr('id') + '"]').text(),
								});
							}
						});

						// if form is not valid
						if (formErrors.length) {
							// find form error items

							// clear and old form errors
							$formErrorList.empty();

							// loop the errors and build the error list
							$.each(formErrors, function (key, value) {
								$formErrorList.append(
									'<li class="validation-error-summary__item"><a class="validation-error-summary__link" href="#' +
										value.id +
										'">' +
										value.label +
										'</a> ' +
										(value.errorType === 'invalid' ? 'is invalid' : value.errorType === 'required' ? 'is a required field' : 'is mandatory') +
										'</li>'
								);
							});

							// show the error summary
							$formErrorSummary.addClass('validation-error-summary--active');

							// scroll to the top of the form
							self[0].scrollIntoView({
								behavior: 'smooth',
								block: 'start',
							});

							// enable submit
							self.data('submitting', false);
							$submitButton.prop('disabled', false);
							$submitButton.removeClass('wait');
						} else {
							var endpointUrl = self.closest('[data-endpoint]').data('endpoint');
							var threeDSecureParameters = {
								amount: paymentbasketTotal.val(),
								email: $('#txtEmail').val(),
								billingAddress: {
									givenName: $('#txtFirstName').val(),
									// ASCII-printable characters required, else will throw a validation error
									surname: $('#txtLastName').val(),
									// ASCII-printable characters required, else will throw a validation error
									phoneNumber: $('#txtPhone').val(),
									streetAddress: $('#txtAddressStreet').val(),
									locality: $('#txtAddressTown').val(),
									postalCode: $('#txtAddressPostcode').val(),
									countryCodeAlpha2: 'UK',
								},
								collectDeviceData: true,
								additionalInformation: {
									shippingGivenName: $('#txtFirstName').val(),
									shippingSurname: $('#txtLastName').val(),
									shippingPhone: $('#txtPhone').val(),
									shippingAddress: {
										streetAddress: $('#txtAddressStreet').val(),
										locality: $('#txtAddressTown').val(),
										postalCode: $('#txtAddressPostcode').val(),
										countryCodeAlpha2: 'UK',
									},
								},
							};

							if (dropinInstance !== null) {
								dropinInstance.requestPaymentMethod(
									{
										threeDSecure: threeDSecureParameters,
									},
									function (err, payload) {
										if (err) {
											//console.log('Braintree Error', err);
											dropinInstance.clearSelectedPaymentMethod();
											$('#payment_error_message').show();
											// enable submit
											self.data('submitting', false);
											$submitButton.prop('disabled', false);
											$submitButton.removeClass('wait');
											return;
										} else {
											$('#payment_error_message').hide();
										}
										//Add the nonce to the form
										paymentNounce.val(payload.nonce);
										paymentType.val(payload.type);
										var data = JSON.stringify(currentForm.serializeJSON());
										$.ajax({
											url: apiBaseUrl + endpointUrl + '?' + new URLSearchParams(data),
											data: data,
											contentType: 'application/json; charset=utf-8',
											type: 'POST',
										})
											.done(function (data) {
												if (data.success === true) {
													Cookies.remove('pfcustomerDetailsForm');
													window.location.href = '/Checkout?stage=5';
												} else {
													formErrors = [];
													for (var i = 0; i < data.errors.length; i++) {
														formErrors.push(data.errors[i]);
													}
													$formErrorList.empty();
													$.each(formErrors, function (key, value) {
														$formErrorList.append('<li class="validation-error-summary__item">' + value + '<li>');
													});

													// show the error summary
													$formErrorSummary.addClass('validation-error-summary--active');

													// scroll to the top of the form
													self[0].scrollIntoView({
														behavior: 'smooth',
														block: 'start',
													});

													// enable submit
													self.data('submitting', false);
													$submitButton.prop('disabled', false);
													$submitButton.removeClass('wait');
												}
											})
											.fail(function (xhr, status, error) {
												// enable submit
												self.data('submitting', false);
												$submitButton.prop('disabled', false);
												$submitButton.removeClass('wait');
												var errorMessage = JSON.parse(xhr.responseText).message;
												console.error(errorMessage);
											});
									}
								);
							} else {
								var data = JSON.stringify(currentForm.serializeJSON());
								$.ajax({
									url: apiBaseUrl + endpointUrl + '?' + new URLSearchParams(data),
									data: data,
									contentType: 'application/json; charset=utf-8',
									type: 'POST',
								})
									.done(function (data) {
										if (data.success === true) {
											Cookies.remove('pfcustomerDetailsForm');
											window.location.href = '/Checkout?stage=5';
										} else {
											formErrors = [];
											for (var i = 0; i < data.errors.length; i++) {
												formErrors.push(data.errors[i]);
											}
											$formErrorList.empty();
											$.each(formErrors, function (key, value) {
												$formErrorList.append('<li class="validation-error-summary__item">' + value + '<li>');
											});

											// show the error summary
											$formErrorSummary.addClass('validation-error-summary--active');

											// scroll to the top of the form
											self[0].scrollIntoView({
												behavior: 'smooth',
												block: 'start',
											});

											// enable submit
											self.data('submitting', false);
											$submitButton.prop('disabled', false);
											$submitButton.removeClass('wait');
										}
									})
									.fail(function (xhr, status, error) {
										// enable submit
										self.data('submitting', false);
										$submitButton.prop('disabled', false);
										$submitButton.removeClass('wait');
										var errorMessage = JSON.parse(xhr.responseText).message;
										console.error(errorMessage);
									});
							}
						}
					}
				});
			}
		});

		$('[data-modal-open]').click(function (e) {
			e.preventDefault();
			$('body').addClass('no-overflow');
			$('[data-modal="' + $(this).data('modal-open') + '"]').addClass('purchase-flow__modal--open');
		});
		$('[data-modal-close]').click(function (e) {
			e.preventDefault();
			$('body').removeClass('no-overflow');
			$('[data-modal="' + $(this).data('modal-close') + '"]').removeClass('purchase-flow__modal--open');
		});
		$('[data-toggle] > *:first-child').click(function () {
			$(this).parent().toggleClass($(this).parent().data('toggle'));
		});
		$('[data-scroll-to]').click(function (e) {
			e.preventDefault();
			$('html, body').animate(
				{
					scrollTop: $($(this).data('scroll-to')).offset().top,
				},
				500
			);
		});
		$('#upperDeckAdults').on('select2:select', function (e) {
			if (e.params.data.id === '0') {
				$('#upperDeckExtras').hide();
			} else {
				$('#upperDeckExtras').show();
			}
		});
		$('#chkCreateAccount').on('click', function () {
			$('#passwordBox').toggle();
		});
		$('.manual-address').on('click', function (e) {
			e.preventDefault();
			$(this).hide();
			$('[data-address-fields]').show();
		});
		$('.purchase-flow__flight-summary').on('click', function (e) {
			var browserWidth = document.documentElement.clientWidth;
			if (browserWidth > 1023) return;
			if ($(e.target).closest('.purchase-flow__flight-summary__column:first-child, .purchase-flow__flight-summary__column:nth-child(2)').length) {
				$('.purchase-flow__flight-summary__edit-button').trigger('click');
			}
		});
	}
	function validateField($field) {
		var errorType;
		var $wrapper = $field.parent();
		if ($field.val() && $field.data('validate-field').includes('email')) {
			var validEmailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
			if (!$field.val().match(validEmailRegex)) {
				errorType = 'invalid';
				if ($wrapper.data('validate-error') !== 'email') {
					if ($wrapper.data('validate-error')) {
						$wrapper.find('.validation-error').remove();
					}

					// add the error
					$wrapper.data('validate-error', 'email');
					$wrapper.addClass('validation-error-wrapper');
					$wrapper.append('<p class="validation-error">Invalid email</p>');
				}
			}
		}
		if (!$field.val() && $field.data('validate-field').includes('required')) {
			errorType = 'required';
			if ($wrapper.data('validate-error') !== 'required') {
				if ($wrapper.data('validate-error')) {
					$wrapper.find('.validation-error').remove();
				}

				// add the error
				$wrapper.addClass('validation-error-wrapper');
				$wrapper.data('validate-error', 'required');
				$wrapper.append('<p class="validation-error">Required field</p>');
			}
		}
		if (!$field.prop('checked') && $field.data('validate-field').includes('checked')) {
			errorType = 'checked';
			if ($wrapper.data('validate-error') !== 'checked') {
				if ($wrapper.data('validate-error')) {
					$wrapper.find('.validation-error').remove();
				}

				// add the error
				$wrapper.addClass('validation-error-wrapper');
				$wrapper.data('validate-error', 'checked');
				$wrapper.append('<p class="validation-error">This input is mandatory</p>');
			}
		}
		if (!errorType) {
			// remove the error
			$wrapper.removeClass('validation-error-wrapper');
			$wrapper.removeData('validate-error');
			$wrapper.find('.validation-error').remove();
			var formpostcodeErrorText = document.getElementById('formpostcodeErrorText');
			formpostcodeErrorText.classList.remove('postcode-validation-error-active');
			formpostcodeErrorText.classList.add('postcode-validation-error');
		}
		return errorType;
	}
	function initValidateField() {
		// for each field that needs to be validated
		$('[data-validate-field]').each(function () {
			// add validate field events
			$(this).on('blur keyup', function () {
				validateField($(this));
			});
		});
	}
	function updateExtrasBasketData() {
		var summaryForm = $('#extrasBasketform');
		var $basketData = summaryForm.find('[data-basket-data]');
		var $basketPromotionCodes = $('[data-basket-promotion]');
		var basketData = [];
		$('input[data-basket-price]').each(function () {
			if (!isNaN($(this).val()) && (parseInt($(this).val()) > 0 || parseInt($(this).val()) !== parseInt($(this).data('basketValue')))) {
				basketData.push({
					productId: getProductId($(this).data('basketProductId')),
					productType: $(this).data('basketProductType'),
					variantQuantity: parseInt($(this).val()),
					variantId: $(this).data('basketVariantId') ? $(this).data('basketVariantId') : '',
					variantName: $(this).data('basketVariantName') ? $(this).data('basketVariantName') : '',
					promotionCode: $basketPromotionCodes.val(),
				});
			}
		});
		$basketData.val(JSON.stringify(basketData));
	}
	function getProductId(productId) {
		var results = productId.toString().split('|');
		return results[0];
	}
	function updateExtrasBasketTotal() {
		var $basketTotal = $('[data-basket-total]');
		var total = parseFloat($basketTotal.data('basketTotal'));
		var $discountTotal = $('[data-basket-total-discount]');
		var totalDiscount = parseFloat($discountTotal.data('basketTotalDiscount'));
		$('[data-basket-group]').each(function () {
			var groupHasItems = false;
			var groupTotal = 0;
			$(this)
				.find('[data-basket-item]')
				.each(function () {
					if (!isNaN($(this).data('total'))) {
						if (!isNaN(totalDiscount)) {
							groupTotal += parseFloat($(this).data('total')) + totalDiscount;
						} else {
							groupTotal += parseFloat($(this).data('total'));
						}

						total += parseFloat($(this).data('total'));
					}
					if (!isNaN($(this).data('discount'))) {
						if (parseFloat($(this).data('discount') !== totalDiscount)) {
							totalDiscount += parseFloat($(this).data('discount'));
						}
					}
					if (parseInt($(this).data('quantity')) > 0) {
						groupHasItems = true;
					}
				});
			if (groupHasItems) {
				$(this)
					.find('[data-basket-group-total]')
					.html(
						groupTotal.toLocaleString('en-GB', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						})
					);
				$(this).show();
			} else {
				$(this).hide();
			}
		});

		var basketSubTotalPrice = $("#basketSubTotalPrice").html();

		if(basketSubTotalPrice !== null || basketSubTotalPrice !== undefined){

			if(basketSubTotalPrice) {
				if(!isNaN(basketSubTotalPrice.substring(1))){
							total = parseFloat(basketSubTotalPrice.substring(1)) - totalDiscount;
				} 
			}
		}

		$basketTotal.html(
			total.toLocaleString('en-GB', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			})
		);
		$discountTotal.html(
			totalDiscount.toLocaleString('en-GB', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			})
		);
	}
	function updateExtrasBasketItem($basketInput) {
		var price = parseFloat($basketInput.data('basketPrice'));
		var discount = parseFloat($basketInput.data('basketDiscount'));
		var quantity = isNaN($basketInput.val()) ? 0 : parseInt($basketInput.val());
		var total = price * quantity;
		var discountTotal = discount * quantity;
		var $basketGroup = $('[data-basket-group="' + $basketInput.data('basketProductId') + '"]');
		var $basketItem = $basketInput.data('basketVariantName') ? $basketGroup.find('[data-basket-item="' + $basketInput.data('basketVariantName') + '"]') : $basketGroup.find('[data-basket-item]');
		$basketItem.data('quantity', quantity);
		$basketItem.data('total', total);
		$basketItem.data('discount', discountTotal);
		$basketItem.html(quantity);
		var inputIsAdult = ($basketInput.data('basketVariantName') || '').toLowerCase() === 'adult' || ($basketInput.data('basketVariantName') || '').toLowerCase() === 'simple';
		if (inputIsAdult) {
			var extrasId = $basketInput.data('extras-id');
			if (!extrasId) return;
			var $extrasObj = $('#' + extrasId);
			if (quantity > 0) {
				$extrasObj.show();
			} else {
				$extrasObj.hide();
			}
		}
		if (quantity > 0) {
			$basketItem.parent().show();
		} else {
			$basketItem.parent().hide();
		}
	}
	function changeExtrasBasketItem() {
		// check validation rules
		var quantity = isNaN($(this).val()) ? 0 : parseInt($(this).val());
		var validateSelector = '[data-basket-product-id="' + $(this).data('basketValidationProductId') + '"]';
		if (quantity > 0 && $(this).data('basketValidationProductId') && $(this).data('basketValidationMessage')) {
			if ($(this).data('basketValidationVariantName')) {
				validateSelector += '[data-basket-variant-name="' + $(this).data('basketValidationVariantName') + '"]';
			}
			var $validateItem = $(validateSelector);
			if ($validateItem) {
				var validateValue = isNaN($validateItem.val()) ? 0 : parseInt($validateItem.val());
				var stepcmd = $validateItem.data('step-cmd');

				//Override this valiation if priority step as returns 2 inputs
				if (stepcmd !== null && stepcmd == 'priority') {
					validateValue = isNaN($validateItem[1].value) ? 0 : parseInt($validateItem[1].value);
				}

				if (validateValue === 0) {
					alert($(this).data('basketValidationMessage'));
					$(this).val(0);
					return;
				}
			}
		}

		// check validation rules on other inputs
		if (quantity === 0) {
			validateSelector = '[data-basket-validation-product-id="' + $(this).data('basketProductId') + '"]';
			if ($(this).data('basketVariantName')) {
				validateSelector += '[data-basket-validation-variant-name="' + $(this).data('basketVariantName') + '"]';
			}
			$(validateSelector).each(function () {
				if ($(this).val() !== 0) {
					$(this).val(0);
					$(this).trigger('change');
				}
			});
		}
		updateExtrasBasketItem($(this));
		updateExtrasBasketTotal();
		updateExtrasBasketData();
	}
	function initExtrasBasket() {
		// loop every input with a price
		$('input[data-basket-price]').each(function () {
			updateExtrasBasketItem($(this));
			$(this).on('change', changeExtrasBasketItem);
		});
		updateExtrasBasketTotal();
		updateExtrasBasketData();
		$('#extrasBasketform').submit(function (e) {
			e.preventDefault();

			var hiddenCmd = $("[data-field='hidden-cmd']");
			var hiddenAdultsTickets = $("[data-field='hidden-adult-tickets']");
			var hiddenChildTickets = $("[data-field='hidden-child-tickets']");
			var hiddenInbound = $("[data-field='hidden-inbound']");
			var hiddenEachWay = $("[data-field='hidden-eachway']");

			if (hiddenCmd !== null && hiddenCmd.val() !== '') {
				if (hiddenCmd.val() == 'multiSelectProducts') {
					saveBasket('/Checkout?stage=3&cmd=' + hiddenCmd.val() + '&numberAdults=' + hiddenAdultsTickets.val() + '&numberChildren=' + hiddenChildTickets.val());
				} else if (hiddenCmd.val() == 'proceedToCheckout') {
					saveBasket('/Checkout?stage=4&cmd=multiSelectProducts' + '&numberAdults=' + hiddenAdultsTickets.val() + '&numberChildren=' + hiddenChildTickets.val());
				} else if (hiddenCmd.val() == 'proceedToCheckoutSecurity') {
					saveBasket('/Checkout?stage=4&cmd=security' + '&tickets=' + hiddenAdultsTickets.val());
				} else if (hiddenCmd.val() == 'proceedToCheckoutPriority') {
					saveBasket('/Checkout?stage=4&cmd=priority&tickets=' + hiddenAdultsTickets.val() + '&isInbound=' + hiddenInbound.val() + '&eachway=' + hiddenEachWay.val());
				} else {
					saveBasket('/Checkout?stage=4');
				}
			} else {
				saveBasket('/Checkout?stage=4');
			}
		});
		$('#btnCheckout').on('click', function (e) {
			e.preventDefault();

			var hiddenPreviousCmd = $("[data-field='hidden-previous-cmd']");
			var hiddenAdultsTickets = $("[data-field='hidden-previous-adult-tickets']");
			var hiddenChildTickets = $("[data-field='hidden-previous-child-tickets']");
			var hiddenInbound = $("[data-field='hidden-inbound']");

			if (hiddenPreviousCmd !== null && hiddenPreviousCmd.val() !== '' && hiddenPreviousCmd.val() == 'security') {
				saveBasket('/Checkout?stage=4&cmd=' + hiddenPreviousCmd.val() + '&tickets=' + hiddenAdultsTickets.val());
			} else if (hiddenPreviousCmd !== null && hiddenPreviousCmd.val() !== '' && hiddenPreviousCmd.val() !== 'undefined') {
				saveBasket('/Checkout?stage=4&cmd=' + hiddenPreviousCmd.val() + '&numberAdults=' + hiddenAdultsTickets.val() + '&numberChildren=' + hiddenChildTickets.val());
			} else {
				saveBasket('/Checkout?stage=4');
			}
		});
		$('#btnChooseProduct').on('click', function (e) {
			e.preventDefault();

			var hiddenPreviousCmd = $("[data-field='hidden-previous-cmd']");
			var hiddenAdultsTickets = $("[data-field='hidden-previous-adult-tickets']");
			var hiddenChildTickets = $("[data-field='hidden-previous-child-tickets']");

			if (hiddenPreviousCmd !== null && hiddenPreviousCmd.val() !== '' && hiddenPreviousCmd.val() == 'security') {
				saveBasket('/Checkout?stage=2&cmd=security&tickets=' + hiddenAdultsTickets.val());
			} else if (hiddenPreviousCmd !== null && hiddenPreviousCmd.val() !== '') {
				saveBasket('/Checkout?stage=2&cmd=' + hiddenPreviousCmd.val() + '&numberAdults=' + hiddenAdultsTickets.val() + '&numberChildren=' + hiddenChildTickets.val());
			} else {
				saveBasket('/Checkout?stage=2');
			}
		});

		$('#btn-stage3-back').on('click', function (e) {
			var btncmd = $(this).attr('data-btncmd');
			if (btncmd !== null && btncmd == 'multiSelectProducts') {
				e.preventDefault();
				var href = $(this).attr('href');
				saveBasket(href);
			}
		});
	}
	function saveBasket(redirectUrl) {
		var $basketData = $('[data-basket-data]');
		var data = $basketData.val();
		$.ajax({
			url: '/umbraco/api/PurchaseFlowApi/AddOrUpdateBasketDetails',
			data: data,
			contentType: 'application/json; charset=utf-8',
			type: 'POST',
		})
			.done(function (data) {
				if (data === true) {
					window.location.href = redirectUrl;
				} else {
					//To Return Errors
					return;
				}
			})
			.fail(function (xhr, status, error) {
				var errorMessage = JSON.parse(xhr.responseText).message;
				console.error(errorMessage);
			});
	}

	// CookieBot Functions
	var launchButtonTemplate =
		'<button class="cookiebot-modal__open-modal CookiebotWidget-logo" data-cookiebot-modal-open><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><circle cx="12" cy="12" r="12"></circle><path d="M15.094 13.978c-1.146 0-1.946-.813-1.946-1.978s.8-1.978 1.946-1.978c1.145 0 1.945.813 1.945 1.978s-.8 1.978-1.945 1.978M9.07 10.022h3.883l-.094.09c-.537.515-.844 1.203-.844 1.888 0 1.738 1.294 3 3.079 3 1.786 0 3.082-1.262 3.082-3s-1.296-3-3.082-3H9.079C7.295 9 6 10.262 6 12s1.295 3 3.079 3h2.144v-1.022H9.07c-1.136 0-1.932-.813-1.937-1.978 0-1.146.815-1.978 1.937-1.978" fill="#000"></path></g></svg></button>';

	var modalTemplate =
		'<div class="cookiebot-modal" data-cookiebot-modal><div class="cookiebot-modal__inner"><div class="cookiebot-modal__intro cookiebot-modal__intro--open" data-cookiebot-modal-intro><div class="cookiebot-modal__header"><span class="cookiebot-modal__header-title">This website uses cookies</span></div><p class="cookiebot-modal__intro-body">We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.</p><div class="cookiebot-modal__intro-footer"><div class="cookiebot-modal__intro-footer-manage"><button class="cookiebot-modal__button cookiebot-modal__button--outline" data-cookiebot-modal-manage-button>Manage all cookies</button></div><div class="cookiebot-modal__intro-footer-submit"><button class="cookiebot-modal__button cookiebot-modal__button--solid" data-cookiebot-modal-accept-all>Accept all cookies</button></div></div></div><div class="cookiebot-modal__prefs" data-cookiebot-modal-prefs><div class="cookiebot-modal__header"><span class="cookiebot-modal__header-title">Cookie Settings</span><button class="cookiebot-modal__back" data-cookiebot-modal-back-button>back</button></div><p class="cookiebot-modal__intro-body">By clicking "Accept all cookies", you agree to the storing of cookies on your device to enhance site navigation, analyse site usage and assiste in our marketing efforts</p><div class="cookiebot-modal__prefs-footer"><div class="cookiebot-modal__toggles"><div class="cookiebot-modal__toggle"><span class="cookiebot-modal__label">Necessary</span><input type="checkbox" id="necessary" class="cookiebot-modal__switch cookiebot-modal__switch--disabled" data-cookiebot-switch="necessary" /><label for="necessary" class="cookiebot-modal__switch-icon">Necessary</label></div><div class="cookiebot-modal__toggle"><span class="cookiebot-modal__label">Preferences</span><input type="checkbox" id="preferences" class="cookiebot-modal__switch" data-cookiebot-switch="preferences" /><label for="preferences" class="cookiebot-modal__switch-icon">Preferences</label></div><div class="cookiebot-modal__toggle"><span class="cookiebot-modal__label">Statistics</span><input type="checkbox" id="statistics" class="cookiebot-modal__switch" data-cookiebot-switch="statistics" /><label for="statistics" class="cookiebot-modal__switch-icon">Statistics</label></div><div class="cookiebot-modal__toggle"><span class="cookiebot-modal__label">Marketing</span><input type="checkbox" id="marketing" class="cookiebot-modal__switch" data-cookiebot-switch="marketing" /><label for="marketing" class="cookiebot-modal__switch-icon">Marketing</label></div></div><div class="cookiebot-modal__prefs-submit"><button class="cookiebot-modal__button cookiebot-modal__button--solid" data-cookiebot-submit-prefs>Submit</button></div></div></div></div>';

	document.addEventListener('DOMContentLoaded', function () {
		var cookieBot = window.Cookiebot;
		if (!cookieBot) return;

		// Add the button template to the page
		var createCookiebotButton = document.createElement('div');
		createCookiebotButton.innerHTML = launchButtonTemplate;
		document.body.appendChild(createCookiebotButton);

		// Add the button template to the page
		var createCookiebotModal = document.createElement('div');
		createCookiebotModal.innerHTML = modalTemplate;
		document.body.appendChild(createCookiebotModal);
		var cookieModal = document.querySelector('[data-cookiebot-modal]');
		var cookieModalIntro = cookieModal.querySelector('[data-cookiebot-modal-intro]');
		var cookieModalPrefs = cookieModal.querySelector('[data-cookiebot-modal-prefs]');
		var manageButton = cookieModal.querySelector('[data-cookiebot-modal-manage-button]');
		var backButton = cookieModal.querySelector('[data-cookiebot-modal-back-button]');
		var consentSwitches = cookieModal.querySelectorAll('[data-cookiebot-switch]');
		var acceptAllButton = cookieModal.querySelector('[data-cookiebot-modal-accept-all]');
		var submitPrefsButton = cookieModal.querySelector('[data-cookiebot-submit-prefs]');
		var openModalButton = document.querySelector('[data-cookiebot-modal-open]');
		var body = document.querySelector('body');
		var toggleBodyOverflow = function toggleBodyOverflow() {
			if (body.classList.contains('cookiebotbanner-open')) {
				body.classList.remove('cookiebotbanner-open');
			} else {
				body.classList.add('cookiebotbanner-open');
			}
		};
		var initializeModal = function initializeModal() {
			var cookieConsentValue = checkCookieConsent();

			if (cookieConsentValue === null) {
				body.classList.add('cookiebotbanner-open');
				cookieModal.classList.add('cookiebot-modal--open');
			}
		};

		function checkCookieConsent() {
			var cookies = document.cookie.split(';');
			for (var i = 0; i < cookies.length; i++) {
				var cookie = cookies[i].trim();
				if (cookie.startsWith('CookieConsent=')) {
					return cookie.split('=')[1];
				}
			}
			return null;
		}
		var toggleVisibility = function toggleVisibility(hideElement, showElement) {
			hideElement.classList.remove('cookiebot-modal__intro--open', 'cookiebot-modal__prefs--open');
			showElement.classList.add('cookiebot-modal__intro--open', 'cookiebot-modal__prefs--open');
		};
		var setInitialSwitchState = function setInitialSwitchState(cookiePreferences) {
			consentSwitches.forEach(function (switchElement) {
				var attributeName = switchElement.getAttribute('data-cookiebot-switch');
				switchElement.checked = cookiePreferences[attributeName] || false;
			});
		};
		var handleConsentChange = function handleConsentChange(e) {
			var switchElement = e.target;
			var attributeName = switchElement.getAttribute('data-cookiebot-switch');
			cookiePreferences[attributeName] = switchElement.checked;
		};
		var updateCookiePreferences = function updateCookiePreferences(preferences) {
			Object.assign(cookiePreferences, preferences);
			consentSwitches.forEach(function (switchElement) {
				var attributeName = switchElement.getAttribute('data-cookiebot-switch');
				switchElement.checked = preferences[attributeName];
			});
		};
		var submitPreferences = function submitPreferences() {
			var preferences = cookiePreferences.preferences,
				statistics = cookiePreferences.statistics,
				marketing = cookiePreferences.marketing;
			cookieBot.submitCustomConsent(preferences, statistics, marketing);
			toggleVisibility(cookieModalPrefs, cookieModalIntro);
			cookieModal.classList.remove('cookiebot-modal--open');
			toggleBodyOverflow();
		};
		var cookiePreferences = {
			necessary: cookieBot.consent.necessary,
			preferences: cookieBot.consent.preferences,
			statistics: cookieBot.consent.statistics,
			marketing: cookieBot.consent.marketing,
		};
		initializeModal();
		openModalButton.addEventListener('click', function () {
			toggleBodyOverflow();
			cookieModal.classList.add('cookiebot-modal--open');
		});
		manageButton.addEventListener('click', function () {
			return toggleVisibility(cookieModalIntro, cookieModalPrefs);
		});
		backButton.addEventListener('click', function () {
			return toggleVisibility(cookieModalPrefs, cookieModalIntro);
		});
		consentSwitches.forEach(function (item) {
			return item.addEventListener('change', handleConsentChange);
		});
		submitPrefsButton.addEventListener('click', submitPreferences);
		acceptAllButton.addEventListener('click', function () {
			var allConsent = {
				necessary: true,
				preferences: true,
				statistics: true,
				marketing: true,
			};
			cookieBot.submitCustomConsent(true, true, true);
			updateCookiePreferences(allConsent);
			cookieModal.classList.remove('cookiebot-modal--open');
			toggleBodyOverflow();
		});
		setInitialSwitchState(cookiePreferences);
	});
	var purchaseFlowToggleRowButton = document.querySelector('[data-purchase-flow-toggle-row]');
	var purchaseFlowToggleColumnButton = document.querySelector('[data-purchase-flow-toggle-column]');
	var purchaseFlowProductList = document.querySelector('[data-purcahse-flow-product-list]');
	var purchaseFlowProducts = document.querySelectorAll('[data-purcahse-flow-product]');
	function toggleGrid(isRowView) {
		if (!isRowView) {
			purchaseFlowToggleColumnButton.classList.add('purchase-flow__grid-sort-button--active');
			purchaseFlowToggleRowButton.classList.remove('purchase-flow__grid-sort-button--active');
			purchaseFlowProductList.classList.remove('purchase-flow__product-list--row');
			purchaseFlowProducts.forEach(function (product) {
				product.classList.remove('purchase-flow__product--column');
			});
		} else {
			purchaseFlowToggleColumnButton.classList.remove('purchase-flow__grid-sort-button--active');
			purchaseFlowToggleRowButton.classList.add('purchase-flow__grid-sort-button--active');
			purchaseFlowProductList.classList.add('purchase-flow__product-list--row');
			purchaseFlowProducts.forEach(function (product) {
				product.classList.add('purchase-flow__product--column');
			});
		}
	}
	if (purchaseFlowToggleColumnButton) {
		purchaseFlowToggleColumnButton.addEventListener('click', function () {
			toggleGrid(false);
			$('[data-purchase-flow-title]').matchHeight({ remove: true });
			$('[data-purchase-flow-content]').matchHeight({ remove: true });
		});
	}
	if (purchaseFlowToggleRowButton) {
		purchaseFlowToggleRowButton.addEventListener('click', function () {
			toggleGrid(true);
			$('[data-purchase-flow-title]').matchHeight({ byRow: false });
			$('[data-purchase-flow-content]').matchHeight({ byRow: false });
		});
	}

	function sightseeingFunctions() {
		$('[data-sightseeing-title]').matchHeight({ byRow: false });
		$('[data-sightseeing-description]').matchHeight({ byRow: false });
		$('[data-sightseeing-footer]').matchHeight({ byRow: false });

		var sightseeingCarousel = $('[data-sightseeing-carousel]');

		function initSlick() {
			sightseeingCarousel.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
				arrows: false,
				fade: true,
			});
		}

		function destroySlick() {
			if (sightseeingCarousel.hasClass('slick-initialized')) {
				sightseeingCarousel.slick('unslick');
			}
		}

		function handleResize() {
			var width = $(window).width();
			if (width < 600) {
				if (!sightseeingCarousel.hasClass('slick-initialized')) {
					initSlick();
				}
			} else {
				destroySlick();
			}
		}

		$(window).on('resize', handleResize);
		if ($(window).width() < 600) {
			initSlick();
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		slidesLen = $('[data-destinations-carousel] .item-carousel__slide').length;
		defaultLen = 5;
		desktopLen = slidesLen >= defaultLen ? defaultLen : slidesLen;
		$('[data-destinations-carousel]').slick({
			centerMode: true,
			centerPadding: '120px',
			slidesToShow: desktopLen,
			responsive: [
				{
					breakpoint: 1800,
					settings: {
						slidesToShow: desktopLen,
						centerPadding: '120px',
					},
				},
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 3,
						centerPadding: '120px',
					},
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						centerPadding: '30px',
					},
				},
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2,
						centerPadding: '30px',
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						centerPadding: '30px',
					},
				},
			],
		});
	});

	function initInstaFeed() {
		$('[data-insta-feed-carousel]').slick({
			centerMode: true,
			centerPadding: '120px',
			slidesToShow: 1,
			infinite: true,
			arrows: false,
			fade: true,
			dots: true,
			autoplay: true,
			autoplaySpeed: 2000,
		});

		$('[data-insta-feed-carousel-prev]').click(function () {
			$('[data-insta-feed-carousel]').slick('slickPrev');
		});

		$('[data-insta-feed-carousel-next]').click(function () {
			$('[data-insta-feed-carousel]').slick('slickNext');
		});
	}

	function initParkingProductMediaFeed() {
		var parcingLoungesCarousels = document.querySelectorAll('[data-parking-product-carousel]');

		if (parcingLoungesCarousels.length < 1) return;

		parcingLoungesCarousels.forEach(function (carousel) {
			var swiper = new Swiper(carousel, {
				loop: true,
				autoplay: {
					delay: 2000,
				},
				slidesPerView: 1,
				effect: 'fade',
			});
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		var LOUNGES = [];
		var PRIORITY = [];
		var EXTRAS = [];

		function initLounges() {
			populateInputs();
			checkItemsInBasket();
			initLoungesFormInputsChange();
			updateAddBasketButtons();
			addToBasketButton();
		}
		initLounges();

		var updateUrlParams = function (url, params) {
			var newUrl = new URL(url);

			for (var key in params) {
				if (params.hasOwnProperty(key)) {
					newUrl.searchParams.set(key, params[key]);
				}
			}

			newUrl.toString();
			window.history.pushState({}, '', newUrl);

			var urlParams = new URLSearchParams(window.location.search);

			var numberAdults = parseInt(urlParams.get('numberAdults'), 10) || 0;
			var numberChildren = parseInt(urlParams.get('numberChildren'), 10) || 0;
			var numberInfants = parseInt(urlParams.get('numberInfants'), 10) || 0;

			if ((numberAdults === 0 && numberChildren >= 1) || (numberAdults === 0 && numberInfants >= 1)) {
				newUrl.searchParams.set('numberAdults', '0');
				newUrl.searchParams.set('numberChildren', '0');
				newUrl.searchParams.set('numberInfants', '0');
				var inputElement = document.querySelector('.purchase-flow__form-number__input');

				if (inputElement) {
					var validationMessage = inputElement.getAttribute('data-basket-validation-message');
					alert(validationMessage);
				} else {
					alert('You cannot add this item without first selecting an adult ticket.');
				}
			}

			if (numberAdults === 0 && numberChildren === 0 && numberInfants === 0) {
				toggleBasketVisibility();
			}

			newUrl.toString();
			window.history.pushState({}, '', newUrl);
		};

		function getUrlParams() {
			var url = window.location.search;
			var params = new URLSearchParams(url);

			return {
				numberAdults: params.get('numberAdults'),
				numberChildren: params.get('numberChildren'),
				numberPriority: params.get('priorityTickets'),
				numberInfants: params.get('numberInfants'),
				priorityTickets: params.get('priorityTickets'),
			};
		}

		function populateInputs() {
			var params = getUrlParams();

			var numberAdults;
			var numberChildren;
			var numberPriority;
			var numberInfants;

			if (params.numberAdults === null) {
				numberAdults = 0;
			} else {
				numberAdults = parseInt(params.numberAdults);
			}

			if (params.numberChildren === null) {
				numberChildren = 0;
			} else {
				numberChildren = parseInt(params.numberChildren);
			}

			if (params.numberInfants === null) {
				numberInfants = 0;
			} else {
				numberInfants = parseInt(params.numberInfants);
			}

			if (params.numberPriority === null) {
				numberPriority = 0;
			} else {
				numberPriority = parseInt(params.numberPriority);
			}

			var adultInputs = document.querySelectorAll('[data-basket-variant-name="adult"]');
			var childInputs = document.querySelectorAll('[data-basket-variant-name="child"]');
			var infantInputs = document.querySelectorAll('[data-basket-variant-name="infant"]');
			var priorityInputs = document.querySelectorAll('[data-basket-variant-name="simple"]');

			if (adultInputs) {
				adultInputs.forEach(function (input) {
					input.value = parseInt(numberAdults);
				});
			}

			if (childInputs) {
				childInputs.forEach(function (input) {
					input.value = parseInt(numberChildren);
				});
			}

			if (infantInputs) {
				infantInputs.forEach(function (input) {
					input.value = parseInt(numberInfants);
				});
			}
			if (priorityInputs) {
				priorityInputs.forEach(function (input) {
					input.value = parseInt(numberPriority);
				});
			}
		}

		function lowercaseVariantNames(products) {
			for (var i = 0; i < products.length; i++) {
				if (products[i].variantName) {
					products[i].variantName = products[i].variantName.toLowerCase();
				}
			}
			return products;
		}

		function checkItemsInBasket() {
			var basketData = $('#hdBasketDatalounges');
			if (!basketData) return;

			var data;

			if (!basketData.val()) {
				data = [];
			} else {
				var lowercaseBasket = lowercaseVariantNames(JSON.parse(basketData.val()));
				basketData[0].setAttribute('value', JSON.stringify(lowercaseBasket));
				data = lowercaseBasket;
			}

			var output = {
				lounges: [],
				priority: [],
				extras: [],
			};

			var loungeMap = {};

			data.forEach(function (item) {
				if (item.variantQuantity === '0') return;

				if (item.productName && item.productName.indexOf('Priority Security') !== -1) {
					output.priority.push({
						productId: item.productId,
						item: item.productName,
						tickets: [
							{
								name: item.variantName,
								quantity: item.variantQuantity,
								price: item.productPrice,
								discount: item.productDiscount,
							},
						],
					});
				} else if (item.productName && item.productName.indexOf('Lounge') !== -1) {
					if (!loungeMap[item.productName]) {
						loungeMap[item.productName] = {
							productId: item.productId,
							item: item.productName,
							tickets: [],
						};
					}
					loungeMap[item.productName].tickets.push({
						name: item.variantName,
						quantity: item.variantQuantity,
						price: item.productPrice,
						discount: item.productDiscount,
					});
				} else if (item.productType === 'AncillaryExtra') {
					output.extras.push({
						productId: item.productId,
						item: item.variantName,
						tickets: [
							{
								name: item.variantName,
								quantity: item.variantQuantity.toString(),
								price: item.variantPrice,
								discount: item.productDiscount,
							},
						],
					});
				}
			});

			output.lounges = Object.keys(loungeMap).map(function (key) {
				return loungeMap[key];
			});

			output.lounges.forEach(function (lounge) {
				var ticketMap = {};
				lounge.tickets.forEach(function (ticket) {
					if (ticketMap[ticket.name]) {
						ticketMap[ticket.name] += parseInt(ticket.quantity, 10);
					} else {
						ticketMap[ticket.name] = parseInt(ticket.quantity, 10);
					}
				});
				lounge.tickets = Object.keys(ticketMap).map(function (name) {
					var originalTicket = lounge.tickets.find(function (ticket) {
						return ticket.name === name;
					});

					return {
						name: name,
						quantity: ticketMap[name].toString(),
						price: originalTicket ? originalTicket.price : '',
						discount: originalTicket ? originalTicket.discount : '',
					};
				});
			});

			LOUNGES = output.lounges;
			PRIORITY = output.priority;
			EXTRAS = output.extras;

			buildTemplates();
			toggleButtonStates();
			toggleBasketVisibility();
		}

		function buildTemplates() {
			var allLoungesSummary = document.querySelector('[data-all-lounges]');
			if (!allLoungesSummary) return;

			var calculateTotal = function (data) {
				var total = data.reduce(function (total, ticket) {
					return total + parseFloat(ticket.quantity) * parseFloat(ticket.price);
				}, 0);
				return total.toFixed(2);
			};

			function calculateExtrasTotal(products) {
				var total = 0;
				products.forEach(function (product) {
					product.tickets.forEach(function (ticket) {
						total += parseInt(ticket.quantity) * parseFloat(ticket.price);
					});
				});
				return total.toFixed(2);
			}

			function capitalizeFirstLetter(string) {
				return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
			}

			allLoungesSummary.innerHTML = '';
			LOUNGES.forEach(function (item) {
				var items = item.tickets
					.map(function (ticket, i) {
						if (ticket.quantity > 0) {
							return '<span class="purchase-flow__basket-summary__item">' + ticket.quantity + ' x ' + capitalizeFirstLetter(ticket.name) + '</span>';
						}
					})
					.join('');

				allLoungesSummary.innerHTML +=
					'<div class="purchase-flow__basket-summary__lounges-lounge">' +
					'<button class="title" data-basket-items-toggle>' +
					item.item +
					'<span class="price">£' +
					calculateTotal(item.tickets) +
					'</span>' +
					'</button>' +
					'<div class="body">' +
					'<div class="items">' +
					items +
					'</div>' +
					'<div class="footer">' +
					'<button class="btn btn--secondary" data-remove-lounges-basket="' +
					item.item +
					'">Remove</button>' +
					'</div>' +
					'</div>' +
					'</div>';
			});

			var allPrioitySummary = document.querySelector('[data-all-priority]');
			if (!allPrioitySummary) return;

			allPrioitySummary.innerHTML = '';
			PRIORITY.forEach(function (item) {
				var items = item.tickets
					.map(function (ticket) {
						return '<span class="purchase-flow__basket-summary__item">' + ticket.quantity + ' x Ticket</span>';
					})
					.join('');

				allPrioitySummary.innerHTML +=
					'<div class="purchase-flow__basket-summary__lounges-lounge">' +
					'<button class="title" data-basket-items-toggle>' +
					item.item +
					'<span class="price">£' +
					calculateTotal(item.tickets) +
					'</span>' +
					'</button>' +
					'<div class="body">' +
					'<div class="items">' +
					items +
					'</div>' +
					'<div class="footer">' +
					'<button class="btn btn--secondary" data-remove-lounges-basket="' +
					item.item +
					'">Remove</button>' +
					'</div>' +
					'</div>' +
					'</div>';
			});

			var allExtrasSummary = document.querySelector('[data-all-extras]');
			if (!allExtrasSummary) return;

			var showExtras = true;
			var items = EXTRAS.map(function (item) {
				if (parseInt(item.tickets[0].quantity) > 0) {
					return '<span class="purchase-flow__basket-summary__item">' + item.tickets[0].quantity + ' x ' + item.item + '</span>';
				} else {
					showExtras = false;
					return '';
				}
			}).join('');

			allExtrasSummary.innerHTML = '';

			if (EXTRAS.length > 0 && showExtras) {
				allExtrasSummary.innerHTML =
					'<div class="purchase-flow__basket-summary__lounges-lounge">' +
					'<button class="title" data-basket-items-toggle>' +
					'Extras' +
					'<span class="price">£' +
					calculateExtrasTotal(EXTRAS) +
					'</span>' +
					'</button>' +
					'<div class="body">' +
					'<div class="items">' +
					items +
					'</div>' +
					'<div class="footer">' +
					'<button class="btn btn--secondary" data-remove-lounges-extras="2">Remove</button>' +
					'</div>' +
					'</div>' +
					'</div>';
			}

			var removeExtrasFromBasketButton = document.querySelector('[data-remove-lounges-extras]');

			if (removeExtrasFromBasketButton) {
				removeExtrasFromBasketButton.addEventListener('click', function (e) {
					removeExtrasFromBasket();
				});
			}

			var basketItemsToggle = document.querySelectorAll('[data-basket-items-toggle]');
			basketItemsToggle.forEach(function (toggle) {
				toggle.addEventListener('click', function () {
					toggle.classList.toggle('title--open');
					const body = toggle.nextElementSibling;
					body.classList.toggle('body--open');
				});
			});

			function calculateSubtotal() {
				var subtotal = [];

				if (LOUNGES.length > 0) {
					LOUNGES.forEach(function (lounge) {
						subtotal.push(calculateTotal(lounge.tickets));
					});
				}
				if (PRIORITY.length > 0) {
					subtotal.push(calculateTotal(PRIORITY[0].tickets));
				}
				if (EXTRAS.length > 0) {
					subtotal.push(calculateExtrasTotal(EXTRAS));
				}

				var total = subtotal.reduce(function (acc, curr) {
					return acc + parseFloat(curr);
				}, 0);

				return total.toFixed(2);
			}

			function calculateDiscounts() {
				var totalDiscount = 0;

				if (LOUNGES.length > 0) {
					LOUNGES.forEach(function (lounge) {
						totalDiscount += calculateTotalDiscount(lounge.tickets);
					});
				}
				if (PRIORITY.length > 0) {
					totalDiscount += calculateTotalDiscount(PRIORITY[0].tickets);
				}
				if (EXTRAS.length > 0) {
					totalDiscount += calculateExtrasDiscount(EXTRAS);
				}

				if (totalDiscount > 0) {
					return totalDiscount.toFixed(2);
				} else {
					return 0;
				}
			}

			function calculateTotalDiscount(tickets) {
				return tickets.reduce(function (acc, ticket) {
					return acc + parseFloat(ticket.discount) * parseInt(ticket.quantity);
				}, 0);
			}

			function calculateExtrasDiscount(extras) {
				return extras.reduce(function (acc, extra) {
					return acc + calculateTotalDiscount(extra.tickets);
				}, 0);
			}

			var basketSummaryTotals = document.querySelector('[data-all-totals]');
			if (!basketSummaryTotals) return;

			function getPromoCode() {
				var promoCode = document.querySelector('[data-basket-dscount-code]');
				if (!promoCode) return;

				return promoCode.value;
			}

			var discountTemplate =
				'<div class="totals__discount">' +
				'<div data-basket-remove-discount class="promo-code-container">' +
				'<span class="close">' +
				getPromoCode() +
				'</span>' +
				'</div>' +
				'<span class="value">-£' +
				(calculateDiscounts() > 0 ? calculateDiscounts() : '') +
				'</span>' +
				'</div>';

			basketSummaryTotals.innerHTML = '';

			if (LOUNGES.length > 0 || PRIORITY.length > 0 || EXTRAS.length > 0) {
				basketSummaryTotals.innerHTML =
					'<div class="purchase-flow__basket-summary__lounges-lounge">' +
					'<div class="totals">' +
					(calculateDiscounts() > 0 ? discountTemplate : '') +
					'<div class="totals__total">' +
					'<span class="title">Total</span>' +
					'<span class="value">£' +
					(calculateSubtotal() - calculateDiscounts()).toFixed(2) +
					'</span>' +
					'</div>' +
					'</div>' +
					'</div>';
			}

			if (calculateDiscounts() > 0) {
				initRemovePromocode();
			}

			var removeButtons = document.querySelectorAll('[data-remove-lounges-basket]');

			removeButtons.forEach(function (button) {
				button.addEventListener('click', function () {
					var id = button.dataset.removeLoungesBasket;
					removeFromBasket(id);

					if (LOUNGES.length === 0) {
						var lounges = document.querySelectorAll('div[data-lounge-name*="Lounge"]');
						lounges.forEach(function (lounge) {
							lounge.querySelector('[data-lounge-item]').removeAttribute('disabled');
						});
					}
					if (PRIORITY.length === 0) {
						var priority = document.querySelectorAll('div[data-lounge-name*="Priority"]');
						priority.forEach(function (priority) {
							priority.querySelector('[data-lounge-item]').removeAttribute('disabled');
						});
					}
				});
			});

			var summaryForm = document.querySelector('[data-lounges-continue-form]');

			if (LOUNGES.length > 0 || PRIORITY.length > 0 || EXTRAS.length > 0) {
				summaryForm.classList.add('purchase-flow__extras-layout__lounges-form--open');
			} else {
				summaryForm.classList.remove('purchase-flow__extras-layout__lounges-form--open');
			}

			updateDateInBasketSummary();
		}

		function removeExtrasFromBasket() {
			var basketData = document.querySelector('[data-basket-data]');
			var data = JSON.parse(basketData.value);

			var dataAncillaryExtra = data.filter(function (e) {
				return e.productType == 'AncillaryExtra';
			});

			//Filter it
			var updatedAncillaryExtras = [];

			for (var i = 0; i < dataAncillaryExtra.length; i++) {
				var item = dataAncillaryExtra[i];
				item.variantQuantity = 0;
				updatedAncillaryExtras.push(item);
			}

			var basketItemsExcludingAncillaryExtras = data.filter(function (e) {
				return e.productType !== 'AncillaryExtra';
			});

			for (var j = 0; j < updatedAncillaryExtras.length; j++) {
				var basketItem = updatedAncillaryExtras[j];
				basketItemsExcludingAncillaryExtras.push(basketItem);
			}

			basketData.value = JSON.stringify(basketItemsExcludingAncillaryExtras);
			basketData.value = basketData.value;
			checkItemsInBasket();
			toggleButtonStates();
		}

		function updateDateInBasketSummary() {
			var entryDateNode = document.querySelector('[data-entry-date-node]');

			if (LOUNGES.length > 0 || PRIORITY.length > 0 || EXTRAS.length > 0) {
				var entryDate = document.querySelector('[data-entry-date]');
				entryDateNode.classList.add('booking-dates--open');
				entryDateNode.querySelector('[data-lounges-entry-date]').textContent = entryDate.innerHTML;
			} else {
				entryDateNode.querySelector('[data-lounges-entry-date]').textContent = '';
				entryDateNode.classList.remove('booking-dates--open');
			}
		}

		function removeFromBasket(item) {
			var basketData = document.querySelector('[data-basket-data]');
			var data = JSON.parse(basketData.value);

			var newBasketData = data.map(function (product) {
				if (product.productName === item) {
					var resetProduct = {};

					for (var prop in product) {
						if (product.hasOwnProperty(prop)) {
							resetProduct[prop] = product[prop];
						}
					}

					resetProduct.variantQuantity = '0';

					return resetProduct;
				}
				return product;
			});

			basketData.value = JSON.stringify(newBasketData);
			checkItemsInBasket();
			toggleButtonStates();
		}

		function getParamName(variantName) {
			var paramMap = {
				adult: 'numberAdults',
				child: 'numberChildren',
				infant: 'numberInfants',
				simple: 'priorityTickets',
			};
			return paramMap[variantName] || '';
		}

		function updateBasketItem(basketJson, input) {
			var item = basketJson.find(function (item) {
				return item.productId === input.dataset.basketProductId && item.variantName === input.dataset.basketVariantName;
			});

			if (item) {
				item.variantQuantity = input.value;
			} else {
				basketJson.push({
					productId: input.dataset.basketProductId,
					productType: input.dataset.basketProductType,
					variantQuantity: input.value,
					variantName: input.dataset.basketVariantName.toLowerCase(),
					productName: input.dataset.basketProductName,
					productPrice: input.dataset.basketPrice,
					productDiscount: input.dataset.basketDiscount,
				});
			}

			basketJson.forEach(function (item) {
				if (item.productId === input.dataset.basketProductId) {
					if (item.variantName === 'adult' && item.variantQuantity === '0') {
						basketJson.forEach(function (relatedItem) {
							if (relatedItem.productId === item.productId) {
								relatedItem.variantQuantity = '0';
							}
						});

						var lounges = input.closest('[data-lounges]');
						var indLounges = lounges.querySelectorAll('[data-lounges-form-number]');

						indLounges.forEach(function (indLounge) {
							indLounge.querySelectorAll('input').forEach(function (input) {
								input.value = 0;
							});
						});

						var url = window.location;
						var params = { numberAdults: 0, numberChildren: 2, numberInfants: 0, priorityTickets: 0 };
						updateUrlParams(url, params);

						LOUNGES = [];

						checkItemsInBasket();
					}
				}
			});
			return basketJson;
		}

		function handleButtonClick(button, index, formNumberInput, formNumberInputMin, formNumberInputMax, paramName, url) {
			var formNumberInputValue = parseInt(formNumberInput.value);
			var paramsToUpdate = {};

			if (isNaN(formNumberInputValue) || formNumberInputValue > formNumberInputMax || formNumberInputValue < formNumberInputMin) {
				paramsToUpdate[paramName] = 0;
				formNumberInput.value = 0;
			} else if (index && formNumberInputValue < formNumberInputMax) {
				paramsToUpdate[paramName] = formNumberInputValue + 1;
				formNumberInput.value = formNumberInputValue + 1;
			} else if (!index && formNumberInputValue > formNumberInputMin) {
				paramsToUpdate[paramName] = formNumberInputValue - 1;
				formNumberInput.value = formNumberInputValue - 1;
			}

			updateUrlParams(url, paramsToUpdate);
			populateInputs();
			updateAddBasketButtons();

			var basketData = $('#hdBasketDatalounges');
			if (!basketData.val() || JSON.parse(basketData.val()).length === 0) return;

			var isLounge = button.closest('[data-lounge-name*="Lounge"]');
			var isPriority = button.closest('[data-lounge-name*="Priority"]');

			if (isLounge || isPriority) {
				updateItemsInBasket(button, isLounge ? 'Lounge' : 'Priority');
			}
		}

		function updateItemsInBasket(button, itemType) {
			var basket = document.querySelector('[data-basket-data]');
			if (!basket) return;

			var basketJson = lowercaseVariantNames(JSON.parse(basket.value));
			var hasItems = checkContains(basketJson, itemType);
			if (!hasItems) return;

			var input = button.closest('[data-lounges-form-number]').querySelector('input');

			if (input.value > 0) {
				basketJson = updateBasketItem(basketJson, input);
			}

			var inputs = button.closest('[data-lounge]').querySelectorAll('input');
			inputs.forEach(function (input) {
				if (input.value > 0) {
					basketJson = updateBasketItem(basketJson, input);
				}
			});

			basketJson = updateBasketItem(basketJson, input);

			basket.value = JSON.stringify(basketJson);
			checkItemsInBasket();
		}

		function initLoungesFormInputsChange() {
			var loungeFormNumbers = document.querySelectorAll('[data-lounges-form-number]');
			if (!loungeFormNumbers) return;

			function setupFormElement(formElement) {
				var formNumberInput = formElement.querySelector('input[type="number"]');
				if (!formNumberInput) return;

				var formNumberInputMin = parseInt(formNumberInput.min);
				var formNumberInputMax = parseInt(formNumberInput.max);
				var variantName = formNumberInput.dataset.basketVariantName;
				var url = window.location;
				var paramName = getParamName(variantName);

				var buttons = formElement.querySelectorAll('button');
				Array.from(buttons).forEach(function (button, index) {
					button.addEventListener('click', function () {
						handleButtonClick(button, index, formNumberInput, formNumberInputMin, formNumberInputMax, paramName, url);
					});
				});
			}

			Array.from(loungeFormNumbers).forEach(setupFormElement);
		}

		function addToBasketButton() {
			var addToBasketButtons = document.querySelectorAll('[data-add-to-basket]');
			if (!addToBasketButtons) return;

			addToBasketButtons.forEach(function (button) {
				button.addEventListener('click', function (e) {
					var adultValue =
						button.closest('[data-lounge-item]').querySelector('[data-basket-variant-name="simple"]') === null
							? button.closest('[data-lounge-item]').querySelector('[data-basket-variant-name="adult"]').value
							: button.closest('[data-lounge-item]').querySelector('[data-basket-variant-name="simple"]').value;
					var loungeName = button.closest('[data-lounge-name]').dataset.loungeName;

					if (adultValue === '0') {
						alert('Adult 18+ must accompany children within the ' + loungeName);
						return;
					}

					var inputs = button.closest('[data-lounge]').querySelectorAll('input');
					if (
						Array.from(inputs).every(function (input) {
							return input.value === '0';
						})
					)
						return;

					if (inputs[0].dataset.basketProductName.includes('Lounge')) {
						var itemLounge = {
							productId: inputs[0].dataset.basketProductId,
							item: inputs[0].dataset.basketProductName,
							tickets: [],
						};

						inputs.forEach(function (input) {
							if (input.dataset.basketVariantName.includes('adult') && input.value > 0) {
								itemLounge.tickets.push({
									name: input.dataset.basketVariantName.toLowerCase(),
									quantity: input.value,
									price: input.dataset.basketPrice,
									discount: input.dataset.basketDiscount,
								});
							}

							if (input.dataset.basketVariantName.includes('child') && input.value > 0) {
								itemLounge.tickets.push({
									name: input.dataset.basketVariantName.toLowerCase(),
									quantity: input.value,
									price: input.dataset.basketPrice,
									discount: input.dataset.basketDiscount,
								});
							}

							if (input.dataset.basketVariantName.includes('infant') && input.value > 0) {
								itemLounge.tickets.push({
									name: input.dataset.basketVariantName.toLowerCase(),
									quantity: input.value,
									price: input.dataset.basketPrice,
									discount: input.dataset.basketDiscount,
								});
							}

							setTimeout(function () {
								var dataAttributes = input;
								updateBasket(dataAttributes);
							}, 10);
						});

						LOUNGES.push(itemLounge);
					}

					if (inputs[0].dataset.basketProductName.includes('Priority')) {
						var itemPriority = {
							productId: inputs[0].dataset.basketProductId,
							item: inputs[0].dataset.basketProductName,
							tickets: [
								{
									name: inputs[0].dataset.basketProductName,
									quantity: inputs[0].value,
									price: inputs[0].dataset.basketPrice,
									discount: inputs[0].dataset.basketDiscount,
								},
							],
						};
						PRIORITY.push(itemPriority);

						var dataAttributes = inputs[0];
						updateBasket(dataAttributes);
					}

					toggleButtonStates(button);
				});
			});
		}

		$('[data-lounges-continue-form]').submit(function (e) {
			e.preventDefault();
			saveLoungesBasket();
		});

		function saveLoungesBasket() {
			var params = new URLSearchParams(window.location.search);
			var numberAdults = parseInt(params.get('numberAdults'), 10) || 0;
			var numberChildren = parseInt(params.get('numberChildren'), 10) || 0;

			var isFrontEnd = $('hdFEOnly');

			if (isFrontEnd.val() !== 'true') {
				var hiddenCmd = $("[data-field='hidden-cmd']");

				var url = '/Checkout?stage=3&cmd=' + hiddenCmd.val() + '&numberAdults=' + numberAdults + '&numberChildren=' + numberChildren;

				var $basketData = $('#hdBasketDatalounges');
				var data = $basketData.val();
				$.ajax({
					url: '/umbraco/api/PurchaseFlowApi/AddOrUpdateBasketDetails',
					data: data,
					contentType: 'application/json; charset=utf-8',
					type: 'POST',
				})
					.done(function (data) {
						if (data === true) {
							window.location.href = url;
						} else {
							//To Return Errors
							return;
						}
					})
					.fail(function (xhr, status, error) {
						var errorMessage = JSON.parse(xhr.responseText).message;
						console.error(errorMessage);
					});
			} else {
				console.log('You saved the basket');
			}
		}

		function checkContains(data, name) {
			return data.some(function (product) {
				return product.productName && product.productName.indexOf(name) !== -1 && product.variantQuantity != '0';
			});
		}

		function toggleButtonStates() {
			var basket = document.querySelector('[data-basket-data]');
			if (!basket) return;

			var basketJson;

			if (basket.value.length > 0) {
				basketJson = JSON.parse(basket.value);
			} else {
				basketJson = [];
			}

			if (document.querySelector('div[data-lounge-name*="Priority"]') !== null) {
				var priorityButton = document.querySelector('div[data-lounge-name*="Priority"]').querySelector('[data-add-to-basket]');

				if (checkContains(basketJson, 'Priority')) {
					priorityButton.setAttribute('disabled', true);
				} else {
					priorityButton.removeAttribute('disabled');
				}
			}

			var lounges = document.querySelectorAll('div[data-lounge-name*="Lounge"]');
			lounges.forEach(function (lounge) {
				if (checkContains(basketJson, lounge.querySelector('[data-basket-product-name]').dataset.basketProductName)) {
					lounge.querySelector('[data-add-to-basket]').setAttribute('disabled', true);
				} else {
					lounge.querySelector('[data-add-to-basket]').removeAttribute('disabled');
				}
			});
		}

		function updateBasket(dataAttributes) {
			var basket = document.querySelector('[data-basket-data]');
			if (!basket) return;

			var basketJson;

			if (basket.value) {
				basketJson = JSON.parse(basket.value);
			} else {
				basketJson = [];
			}

			var item = basketJson.find(function (item) {
				return item.productId === dataAttributes.dataset.basketProductId && item.variantName === dataAttributes.dataset.basketVariantName;
			});

			if (item) {
				item.variantQuantity = dataAttributes.value;
			} else {
				var productItem = {
					productId: dataAttributes.dataset.basketProductId,
					productType: dataAttributes.dataset.basketProductType,
					variantQuantity: dataAttributes.value,
					variantName: dataAttributes.dataset.basketVariantName.toLowerCase(),
					productName: dataAttributes.dataset.basketProductName,
					productPrice: dataAttributes.dataset.basketPrice,
					productDiscount: dataAttributes.dataset.basketDiscount,
				};

				basketJson.push(productItem);
			}

			basket.value = JSON.stringify(basketJson);

			if (LOUNGES.length > 0 || PRIORITY.length > 0) {
				checkItemsInBasket();
			}
		}

		function updateAddBasketButtons() {
			var lounges = document.querySelectorAll('[data-lounge]');
			if (!lounges) return;

			lounges.forEach(function (lounge) {
				var params = getUrlParams();
				var total;
				var adultPrice = 0.0;
				var childPrice = 0.0;

				if (lounge.querySelector('[data-basket-variant-name="simple"]')) {
					var ticketPrice = lounge.querySelector('[data-basket-price][data-basket-variant-name="simple"]').dataset.basketPrice;
					total = ticketPrice * params.priorityTickets;
				} else {
					if (lounge.querySelector('[data-basket-price][data-basket-variant-name="adult"]') !== null) {
						adultPrice = lounge.querySelector('[data-basket-price][data-basket-variant-name="adult"]').dataset.basketPrice;
					}

					if (lounge.querySelector('[data-basket-price][data-basket-variant-name="child"]') !== null) {
						childPrice = lounge.querySelector('[data-basket-price][data-basket-variant-name="child"]').dataset.basketPrice;
					}

					if (params.numberAdults !== null && params.numberChildren !== null) {
						total = adultPrice * params.numberAdults + childPrice * params.numberChildren;
					} else if (params.numberAdults !== null) {
						total = adultPrice * params.numberAdults;
					} else if (params.numberChildren !== null) {
						total = childPrice * params.numberChildren;
					} else {
						total = 0;
					}
				}

				var addToBasketButton = lounge.querySelector('[data-add-to-basket]');
				addToBasketButton.querySelector('span').textContent = total.toFixed(2);
			});
		}

		function toggleBasketVisibility(status) {
			var basket = document.querySelector('[data-basket-summary]');

			if (basket !== null) {
				if (LOUNGES.length > 0 || PRIORITY.length > 0) {
					basket.classList.add('purchase-flow__extras-layout__lounges--open');
				} else {
					basket.classList.remove('purchase-flow__extras-layout__lounges--open');
				}
			}
		}
	});

	function initFormNumber() {
		$('[data-form-number]').each(function () {
			var formNumberInput = $(this).find(':input[type="number"]');
			var formNumberInputMin = parseInt(formNumberInput.prop('min'));
			var formNumberInputMax = parseInt(formNumberInput.prop('max'));

			$(this)
				.find(':button')
				.each(function (index) {
					$(this).on('click', function () {
						var formNumberInputValue = parseInt(formNumberInput.val());
						if (isNaN(formNumberInputValue) || formNumberInputValue > formNumberInputMax || formNumberInputValue < formNumberInputMin) {
							formNumberInput.val(0);
						} else if (index && formNumberInputValue < formNumberInputMax) {
							formNumberInput.val(formNumberInputValue + 1);
						} else if (!index && formNumberInputValue > formNumberInputMin) {
							formNumberInput.val(formNumberInputValue - 1);
						}

						formNumberInput.trigger('change');
					});
				});
		});
	}

	function initRemovePromocode() {
		$('[data-basket-remove-discount]').click(function () {
			$("[data-role='purchase-flow-wrapper']").each(function () {
				var currentWrapper = $(this);
				var promotiontriggers = currentWrapper.find('[data-promo-code-trigger]');
				var currentForm = $(this).find('form[data-booking-form]');
				var hiddenCmd = $("[data-field='hidden-cmd']");
				var apiBaseUrl = currentWrapper.data('api-base');
				var promoCodeWrapper = promotiontriggers.closest('[data-promo-code]');
				var endpointUrl = 'ClearPromotion';
				var entryDateTime = promoCodeWrapper.find("[data-field='entryDateTime']");
				var exitDateTime = promoCodeWrapper.find("[data-field='exitDateTime']");

				var data = {
					promoCode: 'clearPromo',
					entryDateTime: entryDateTime.val(),
					exitDateTime: exitDateTime.val(),
				};
				var formData = {
					firstname: $('#txtFirstName').val(),
					lastname: $('#txtLastName').val(),
					emailaddress: $('#txtEmail').val(),
					phone: $('#phoneNumber').val(),
					addresspostcode: $('#txtAddressPostcode').val(),
					addressstreet: $('#txtAddressStreet').val(),
					addresstown: $('#txtAddressTown').val(),
					addresscounty: $('#txtAddressCounty').val(),
					vehicleregistration: $('#txtVehicleReg').val(),
					vehiclemake: currentForm.find("[data-field='vehicle-make']").val(),
					vehiclemodel: currentForm.find("[data-field='vehicle-model']").val(),
					vehiclecolour: currentForm.find("[data-field='vehicle-colour']").val(),
					outboundflightcode: $('#hdflightDetails').val(),
					reasonforjourney: $('input[name="reason"]:checked').val(),
					cmd: hiddenCmd.val(),
				};
				Cookies.set('pfcustomerDetailsForm', formData, {
					expires: 0.1,
					sameSite: 'strict',
				});
				$.ajax({
					url: apiBaseUrl + endpointUrl + '?' + new URLSearchParams(data),
					type: 'POST',
				})
					.done(function (result) {
						window.location.reload(true);
					})
					.fail(function (xhr, status, error) {
						var errorMessage = JSON.parse(xhr.responseText).message;
						console.error(errorMessage);
					});
			});
		});
	}

	function initToasts() {
		var toasts = document.querySelectorAll('[data-toast]');
		if (toasts.length === 0) return;

		toasts.forEach(function (toast) {
			var toastMessage = toast.dataset.toastMessage;
			var toastDuration = parseInt(toast.dataset.toastDuration) || 4000;
			var toastPosition = toast.dataset.toastPosition || 'top-right';
			var toastStatus = toast.dataset.toastStatus || 'success';

			toast.addEventListener('click', function () {
				var template = document.createElement('div');
				template.classList.add('toast');
				document.body.appendChild(template);
				template.classList.add('toast--' + toastStatus);
				template.classList.add('toast--' + toastPosition);
				template.classList.add('toast--open');
				template.innerHTML = toastMessage || '';

				setTimeout(function () {
					template.classList.remove('toast--open');
					document.body.removeChild(template);
				}, toastDuration);
			});
		});
	}

	function toggleBasketItems() {
		var basketItemsToggle = document.querySelectorAll('[data-basket-items-toggle]');

		if (basketItemsToggle.length < 1) return;

		basketItemsToggle.forEach(function (toggle) {
			toggle.addEventListener('click', function () {
				toggle.classList.toggle('basket-summary-block__title--open');
				const body = toggle.nextElementSibling;
				body.classList.toggle('basket-summary-block__body--open');
			});
		});
	}

	function initDestinationsFilter() {
		const destinationFilterCheckboxes = document.querySelectorAll('[data-filter-checkbox]');
		if (destinationFilterCheckboxes.length < 1) return;

		const destinationsWrapper = document.querySelector('.destinations-filter__destinations-wrapper');
		const allDestinations = document.querySelectorAll('.destinations-filter__destination');
		const originalContainers = document.querySelectorAll('.destinations-filter__destinations');
		const resetButton = document.querySelector('[data-filter-clear-all]');
		const filterHeaders = document.querySelectorAll('[data-filter-header]');
		const hiddenAirlineField = document.getElementById('airlineCategoryHiddenField').value;

		const filteredDestinationsContainer = document.createElement('div');
		filteredDestinationsContainer.className = 'destinations-filter__destinations destinations-filter__destinations--filtered';
		
		const getFilterCategories = () => {
			const categories = {};

			filterHeaders.forEach((header) => {
				const categoryName = header.querySelector('span').textContent.toLowerCase().replace(/\s+/g, '');
				categories[categoryName] = [];

				const checkedFilters = header.nextElementSibling.querySelectorAll('[data-filter-checkbox]:checked');
				checkedFilters.forEach((checkbox) => {
					categories[categoryName].push(checkbox.dataset.filterCheckbox);
				});
			});

			if(hiddenAirlineField !== null && hiddenAirlineField !== ""){
				window.onload = function() {
					categories['airline'].push(hiddenAirlineField);
				}
			}
			return categories;
		};

		const updateHeaderCount = (filterBlock) => {
			const filterHeader = filterBlock.querySelector('[data-filter-header]');
			const checkedBoxes = filterBlock.querySelectorAll('[data-filter-checkbox]:checked').length;

			let countElement = filterHeader.querySelector('.destinations-filter__filter-count');
			if (!countElement && checkedBoxes > 0) {
				countElement = document.createElement('span');
				countElement.className = 'destinations-filter__filter-count';
				const destinationsText = filterHeader.querySelector('span');
				destinationsText.after(countElement); // Using the after() method
			}

			if (checkedBoxes > 0) {
				countElement.textContent = checkedBoxes;
			} else if (countElement) {
				countElement.remove();
			}
		};

		const updateAllHeaderCounts = () => {
			const filterBlocks = document.querySelectorAll('.destinations-filter__filter-block');
			filterBlocks.forEach(updateHeaderCount);
		};

		filterHeaders.forEach((header) => {
			header.addEventListener('click', (e) => {
				const filterBody = header.nextElementSibling;
				header.classList.toggle('destinations-filter__filter-header--open');
				filterBody.classList.toggle('destinations-filter__filter-body--open');
			});
		});

		const updateDestinations = () => {
			const categories = getFilterCategories();
			const hasActiveFilters = Object.values(categories).some((arr) => arr.length > 0);

			if (hasActiveFilters) {
				resetButton.removeAttribute('disabled');
			} else {
				resetButton.setAttribute('disabled', true);
			}

			if (!hasActiveFilters) {
				if (filteredDestinationsContainer.parentNode) {
					filteredDestinationsContainer.remove();
				}
				originalContainers.forEach((container) => (container.style.display = ''));
				return;
			}

			filteredDestinationsContainer.innerHTML = '';
			if (!filteredDestinationsContainer.parentNode) {
				destinationsWrapper.appendChild(filteredDestinationsContainer);
			}

			originalContainers.forEach((container) => (container.style.display = 'none'));

			allDestinations.forEach((destination) => {
				const destinationData = destination.dataset.destination ? destination.dataset.destination.split(' ') : [];

				const matchesAllCategories = Object.entries(categories).every(([category, filters]) => {
					if (filters.length === 0) return true;

					return filters.some((filter) => destinationData.includes(filter));
				});

				if (matchesAllCategories) {
					const clone = destination.cloneNode(true);
					filteredDestinationsContainer.appendChild(clone);
				}
			});
		};

		if(hiddenAirlineField !== null && hiddenAirlineField !== ""){
			updateDestinations();
		}

		destinationFilterCheckboxes.forEach((checkbox) => {
			checkbox.addEventListener('change', () => {
				updateDestinations();
				const filterBlock = checkbox.closest('.destinations-filter__filter-block');
				updateHeaderCount(filterBlock);
			});
		});

		if (resetButton) {
			resetButton.addEventListener('click', () => {
				destinationFilterCheckboxes.forEach((checkbox) => (checkbox.checked = false));
				updateDestinations();
				updateAllHeaderCounts();		
			});
		}
	}

	(function initAll() {
		// initToasts(); // Uncomment to enable toasts
		toggleBasketItems();
		initDestinationsFilter();
		initRemovePromocode();
		initInstaFeed();
		initParkingProductMediaFeed();
		sightseeingFunctions();
		// initFastClick();  // this breaks the select and datepicker on iOS devices
		// initFadingGalleryCarousels();
		initClickBox();
		// initCustomSelect();
		initSearchMobile();
		initSearchDesktop();
		initResponsiveNav();
		initAlert();
		initBannerAlerts();
		initCloseAlertonLoad();
		initClipPath();
		initDatePicker();
		initHeroSlider();
		initHeroReviewSwiperSlider();
		initSearchFlight();
		initSearchFlightTimetable();
		//initSearchFlightMobile();
		initMatchingHeight();
		//initArrivalsDeparturesBoard();
		//  initParkingDatepickers();
		initSelectBoxes();
		initBookingModuleTabs();
		// initMoreLessBookingTabs();
		//initADTSelectBoxes();
		initBookingModuleExpander();
		// initBookingStripPinned();
		initStickyBookingModule();
		initContentReadMoreExpander();
		initSharePopUp();
		initSimilarDestinations();
		initTimeline();
		initFlightCodeShare();
		initMobileGetInspiredFilter();
		initCloseBookingStrip();
		initTopBrands();
		initAccordion();
		initAirportMaps();
		initStickySideBar();
		initLazyLoading();
		if (ssoEnabled()) {
			initCreateAccountForm();
			initLoginPage();
			initEditAccountPage();
			initLoginCheck();
			initAuthorised();
			initRemoveFlightForm();
		}
		$(window)
			.resize(function () {
				// Only re-add this when this function exists
				//initMoveForms();
				initStickyFlightAndSideBar();
				initStickySideBar();
				//initScrollPane();
			})
			.resize();
		initIconSlider();
		initSearchSite();
		initContactForm();
		initNewsletterForm();
		initFlexibleForm();
		initValidation();
		initDestinationMaps();
		initDestinationMapsFilters();
		initNewsListingFilters();
		initSmoothLink();
		//initFlightAlert();
		//initFlightAlertPost();
		initDestinationTimetable();
		initFlightTimetable();
		initTimelineTabs();
		initCarHireForms();
		initTaxisForms();
		initTravelInsuranceForms();
		initHotelForms();
		initFlightForms();
		initParkingForms();
		initLoungeForms();
		initNativeLoungeForms();
		initEditLoungeForms();
		initSecurityForms();
		initTestingForms();
		initPriorityForms();
		initDestinationInspirationFilters();
		initAirlineFilters();
		initRetailerFilters();
		initMegaMenu();
		initDestinationsBtnsMobileFilter();
		initGallery();
		initOfferCarousel();
		initItemCarousel();
		initParkingGridCarousel();
		initLogoCarousel();
		initPinnedParkingStrip();
		initUserPersonalisation();
		initAirlineHandlerSwitcher();
		initInternationalPhoneNumberHelper();
		initPasswordValidation();
		initFAQs();
		initWebChat();
		initViewMoreDestinations();
		initItemListSearch();
		initParkingGrid();
		initFormFlow();
		initPurchaseFlow();
		initValidateField();
		initExtrasBasket();
		initFormNumber();
	})();
})();
